var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 798,
    height: 428,
    viewBox: "0 0 798 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36719 177.502L83.377 175.828L80.8659 137.323L86.7253 131.463L170.279 129.839L235.197 132.563L331.321 131.264H403.504L499.19 126.832L567.157 125.519L651.829 123.005H664.754L675.709 130.944L676.82 139.623V192.38L685.414 191.874L736.77 191.964L773.374 194.879C773.374 194.879 790.503 194.553 791.646 194.607C792.788 194.661 794.38 196.559 794.38 196.559L736.77 239.663L741.407 245.512L752.772 254.212L761.911 262.194L768.7 271.489L782.488 278.289L785.791 283.063L777.852 285.858H698.349L667.344 284.986L668.527 267.541L532.373 269.486L366.734 272.837C366.734 272.837 364.04 270.267 363.079 263.226C362.119 259.534 359.707 267.699 359.707 267.699L355.137 272.258L289.538 273.884L243.82 274.116L193.134 275.376L185.518 275.499L175.511 273.652L155.185 275.377L101.098 276.769L95.3245 277.989L96.2871 286.769L95.4073 292.421L0.229004 292.831C0.229004 292.831 4.68135 287.389 9.70959 281.414C14.7378 275.439 32.4685 255.505 32.4685 255.505C32.4685 255.505 50.8521 235.454 51.6289 231.172C52.4057 226.889 37.1025 217.281 37.1025 217.281L15.3129 194.036L12.5866 189.841C12.5866 189.841 4.35489 184.418 4.10461 179.286C3.85433 174.154 6.36552 177.502 6.36552 177.502L6.36719 177.502Z",
    fill: "#FFFBEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M518.425 357.85L641.904 284.3C633.314 285.91 568.353 284.3 557.079 284.3C545.805 284.3 520.572 284.3 499.634 282.689C482.884 281.401 441.474 283.226 422.862 284.3L316.026 286.984L186.641 284.3L135.638 286.984C139.396 290.205 150.993 298.473 167.313 305.774C183.634 313.076 232.811 339.239 255.36 351.408L324.079 387.915L373.47 414.758L397.629 426.569C398.345 425.854 401.495 423.348 408.367 419.053C415.239 414.758 484.602 376.462 518.425 357.85Z",
    fill: "#FFFBEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.117 54.5204L123.826 116.797C131.342 113.337 208.651 116.797 219.925 116.797L285.423 116.797C302.066 116.797 348.953 116.26 367.564 115.186H458.831L564.057 111.428L594.123 111.428C590.364 108.207 644.266 116.582 627.945 109.281C611.624 101.979 543.657 73.3106 520.572 62.5733L432.526 23.382L397.092 6.20231L383.67 1.37051C376.154 2.44425 368.53 4.05477 361.658 8.34972C354.787 12.6447 292.939 39.488 259.117 54.5204Z",
    fill: "#FFFBEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.963 93.9049C598.213 95.3581 594.588 93.9459 594.321 95.8862C609.415 95.6544 619.541 104.77 633.421 107.814C633.328 110.284 636.03 112.155 634.74 113.776C602.838 113.567 560.061 113.346 526.073 113.776C518.462 113.881 510.59 115.339 503.553 115.1C496.935 114.885 490.215 112.643 483.678 113.776C470.757 116.036 454.292 115.35 439.285 116.425C417.359 118.006 392.603 115.803 369.718 115.768C364.425 115.763 359.568 117.518 354.479 117.755C318.046 119.492 277.295 118.028 239.188 117.755C212.3 117.564 185.766 117.111 162.334 117.093C149.53 117.076 134.163 117.935 121.259 117.755C128.219 108.629 143.685 106.658 154.386 101.192C154.967 100.993 157.285 99.4019 155.706 99.2044C162.776 97.9839 168.313 93.0285 174.919 89.9255C181.652 86.7706 189.019 84.7951 196.124 81.9776C201.033 80.0306 205.565 76.4814 210.702 74.018C215.977 71.4959 222.083 70.3926 227.265 68.0631C231.425 66.1864 234.94 63.1186 239.187 61.4335C244.172 59.4581 250.539 59.4179 253.763 55.4787C281.053 45.3519 309.73 30.7811 335.921 18.365C348.639 12.3456 361.263 5.14102 373.691 1.14404C381.517 -1.37719 390.436 0.609997 396.879 3.79419C410.108 10.3358 421.739 19.9277 438.622 23.0065C441.085 22.7512 439.848 26.1965 441.934 26.3246C478.682 42.2196 512.321 60.5906 551.921 72.0417C559.031 76.196 567.364 81.1397 576.432 81.3146C580.691 86.3814 592.136 91.4063 598.963 93.9049ZM385.619 3.13207C384.021 3.39993 384.178 1.91749 382.301 2.46995C382.045 4.52076 385.49 5.15944 385.619 3.13207ZM312.072 39.5711C307.639 40.6693 300.202 42.7662 296.17 40.2341C288.908 43.7891 280.013 45.7185 274.302 50.8313C273.738 50.7149 273.681 51.0933 273.645 51.4993C272.198 53.5852 266.452 51.3771 266.354 54.8115H271.652C263.223 55.6595 255.565 57.2809 249.785 60.7781C249.663 61.3063 249.122 61.4344 249.134 62.0973C249.192 62.8984 248.163 62.51 249.134 62.0973C250.825 62.0739 249.93 62.5912 249.785 63.4216C244.893 63.6074 238.949 62.7419 237.863 66.7388C243.046 67.2737 248.629 64.7056 253.102 66.7388C244.248 68.6038 232.582 65.1124 228.59 70.7191C236.021 71.5151 243.319 68.6683 249.785 70.7191C235.138 72.6418 224.262 70.1147 215.338 76.0177C225.785 76.7443 237.334 75.0417 245.154 75.3497C236.086 78.7482 217.999 73.6882 214.676 79.3241C222.926 80.1084 241.982 78.3648 252.44 79.3241C235.545 80.9798 215.384 79.3819 199.436 81.9793C198.298 82.8272 199.419 85.9352 197.449 85.9528C192.575 82.9377 187.374 90.2176 180.885 89.9272C179.265 90.8103 181.612 92.3965 180.223 92.5765C176.638 93.0469 174.867 93.4253 170.944 94.5637C171.229 97.1318 171.671 96.9284 170.282 98.5381C172.398 98.9332 172.333 97.3009 173.594 98.5381C173.722 99.2931 174.262 98.9097 174.262 98.5381H174.919C175.134 100.374 176.97 99.6882 177.574 98.5381C175.761 98.6075 176.232 97.4398 174.919 98.5381V97.2188C184.22 95.2668 203.247 94.2029 212.689 93.2386C210.882 93.4244 214.909 93.4244 214.019 93.2386C216.105 93.663 220.898 97.5612 222.623 96.5567C216.186 98.1137 206.896 94.3075 201.429 97.881C195.811 95.389 185.562 97.2825 180.223 99.206C182.047 98.9851 183.436 102.541 184.86 100.53C181.141 99.5484 191.041 98.148 192.151 99.8623C189.664 101.059 187.887 98.8344 186.852 101.193C194.66 101.634 198.629 101.484 204.078 101.855C203.643 102.529 202.556 102.541 202.748 103.848C204.752 105.59 210.923 103.18 212.021 105.835C206.629 107.374 196.427 105.823 192.813 107.154C194.068 112.301 200.471 109.2 204.079 109.141C213.671 109.007 225.111 109.78 235.208 109.803C234.586 111.826 231.089 110.977 228.59 111.128C227.614 114.318 232.396 111.744 231.908 114.446C229.223 113.022 228.097 113.702 224.616 113.778C224.465 112.604 225.284 110.465 223.286 111.128C211.428 110.263 195.363 111.099 182.21 110.471C182.606 113.208 192.238 111.384 188.171 114.446C239.751 117.496 299.529 114.858 349.837 115.77C350.79 115.625 350.069 113.794 351.168 113.778C378.509 114.034 414.129 115.294 440.604 112.453C436.596 109.6 430.124 113.266 425.377 111.128C435.881 109.304 445.449 113.586 453.863 110.471C453.77 112.33 455.484 112.383 457.18 112.453C457.732 109.862 465.372 109.566 468.439 111.796C466.708 111.61 465.587 112.04 465.79 113.778C472.75 113.935 481.581 113.04 483.678 110.471C491.283 111.04 497.337 110.146 503.553 111.128C502.427 110.89 502.304 111.646 502.229 112.453C509.515 111.836 516.498 112.883 524.091 110.471C522.116 108.978 520.042 111.431 519.455 109.141C520.705 108.851 523.446 110.042 522.772 107.816C513.819 106.137 494.206 108.595 486.327 106.486C500.619 105.44 517.049 106.196 529.395 106.486C528.622 106.596 528.216 106.347 528.07 105.835C530.545 105.12 529.953 107.473 532.044 107.154C533.578 106.184 530.749 105.057 533.37 105.167C534.142 105.271 533.933 106.375 534.032 107.154C544.779 105.388 560.606 108.112 573.782 105.835C570.052 105.416 572.824 103.575 574.45 103.185C555.632 104.458 530.662 104.865 514.15 101.855C526.832 101.245 541.99 104.232 556.555 101.193C554.679 101.077 552.012 101.762 551.919 99.8623C554.208 98.759 554.905 98.5088 557.886 97.2188C558.368 95.4058 556.561 95.8829 556.555 94.5637C566.676 94.9412 576.576 93.6571 588.359 93.2386C580.881 90.1365 570.383 92.425 559.868 91.9202C546.562 91.269 530.847 89.7648 519.454 89.9272C520.204 89.805 519.82 89.2592 519.454 89.2592C519.802 88.736 520.146 88.1961 520.122 87.2837C540.886 90.601 564.33 89.9096 583.06 88.608C576.216 85.0237 557.782 89.7874 551.257 85.9528C558.054 85.238 567.809 87.4863 572.457 84.6286C557.055 79.2831 532.34 87.2888 521.44 82.6414C537.749 83.2106 544.534 81.0895 563.184 79.9921C548.607 75.8202 534.089 82.2865 520.121 79.3241C521.248 77.1226 524.328 79.0973 526.739 79.3241C532.491 76.0646 545.591 80.352 550.595 75.3497C542.902 76.4069 537.627 73.3743 534.031 75.3497C521.296 71.5562 501.635 75.2451 487.651 71.3753C506.167 72.1187 523.341 72.2995 539.991 72.0433C540.363 68.7955 535.832 70.4571 533.369 70.0511C529.359 61.3423 516.525 67.4596 506.202 64.7525C509.989 61.9048 517.321 64.9149 522.103 63.4216C517.589 61.6436 507.77 55.0325 508.195 60.1101C502.513 58.5063 493.217 60.5052 487.652 58.7909C494.438 58.5005 502.647 59.6456 507.527 57.4608C503.518 55.0668 498.063 54.1201 494.274 51.4993C494.315 54.5378 488.441 53.9745 488.307 51.4993C490.655 52.0802 489.94 51.5805 492.287 52.1614C485.756 46.6426 477.571 45.161 469.763 41.5583C459.217 36.7017 451.159 28.3118 437.296 29.6302C436.263 31.989 439.546 30.0311 439.284 31.6232H433.323C433.752 30.9494 434.845 30.9376 434.647 29.6302C431.882 28.2883 426.019 31.5537 424.712 27.643C429.406 26.4468 434.955 30.083 437.296 26.9808C436.221 26.0684 435.669 24.6396 433.322 24.9937C431.73 24.7325 433.682 28.0096 431.335 26.9808C417.838 23.3212 404.121 28.0439 392.896 23.6694C403.499 24.8606 415.107 24.3315 422.718 22.3444C415.95 18.8881 404.179 22.6407 398.863 19.0329C405.452 19.9512 406.857 19.0095 414.109 19.0329C411.761 15.0761 401.728 18.5684 394.896 16.3836C396.61 14.3504 403.564 17.5396 403.506 13.7343C397.574 14.3554 391.962 12.647 388.929 15.0586C389.778 16.197 392.892 15.0703 392.898 17.0399C390.231 15.7441 384.764 17.2316 382.3 15.7156C383.805 15.2335 387.471 16.9118 386.943 14.3906C381.58 14.1872 377.966 10.3702 375.02 9.75408C376.589 8.40557 374.103 7.13407 375.678 5.7797C361.228 8.10925 351.729 15.4068 339.238 19.6942C338.807 22.1058 342.393 20.5137 342.549 22.3435C337.187 22.8198 333.318 20.6702 331.284 24.3307C335.02 26.1438 339.964 23.081 344.53 24.9928C337.884 26.5966 323.719 24.4119 319.357 30.2923C323.831 31.2105 328.321 28.6826 331.285 30.2923C318.073 31.0356 308.492 31.4022 300.806 39.5703C304.711 40.5404 307.202 39.2162 312.071 39.5703L312.072 39.5711ZM386.944 5.78138C386.426 5.92702 385.636 5.79895 385.619 6.44433C386.13 6.29282 386.919 6.42675 386.944 5.78138ZM383.626 9.0928C382.783 9.05764 382.713 8.24402 381.639 8.4357C380.61 10.0571 383.893 10.3827 383.626 9.0928ZM387.6 13.0672C387.803 11.3244 386.687 10.8942 384.951 11.0858C384.358 13.2178 387.112 12.01 387.6 13.0672ZM391.58 12.4042C392.015 12.8403 391.301 12.1313 391.58 12.4042ZM426.032 21.6831C424.579 23.7046 421.791 20.9163 426.032 21.6831ZM555.894 76.679C555.388 76.8188 554.592 76.6966 554.569 77.3361C555.086 77.1963 555.876 77.3185 555.894 76.679ZM209.371 77.9982C209.114 80.0549 212.566 80.6994 212.688 78.6662C211.741 78.5096 211.566 77.5738 210.701 77.3361C210.549 77.8592 210.143 78.1087 209.371 77.9982ZM578.424 95.8862C578.977 97.3394 587.836 96.1834 591.671 96.5551C587.779 93.6906 581.376 95.898 578.424 95.8862ZM166.964 98.5364H168.962C169.043 97.3511 168.294 96.9845 166.964 97.2172V98.5364ZM178.892 99.2044C179.699 99.134 179.305 100.169 178.892 99.2044C178.491 98.2342 178.096 99.2738 178.892 99.2044ZM559.205 99.2044C558.247 99.5643 555.778 98.4318 555.894 99.8606C556.858 99.5057 559.316 100.639 559.205 99.2044ZM597.638 101.192C600.044 102.597 604.546 101.279 606.917 100.529C604.401 100.424 599.689 99.0529 597.638 101.192ZM180.222 101.192C181.187 100.785 180.153 100.39 180.222 101.192C178.067 101.464 165.18 99.5183 162.334 103.184C165.942 103.474 167.772 102.004 171.612 102.516V104.509C177.08 103.225 180.24 106.223 183.535 102.516C181.6 100.796 181.385 102.498 180.223 101.854L180.222 101.192ZM591.672 101.854C593.338 101.308 597.382 103.144 596.976 100.529C594.972 100.732 591.817 99.7911 591.672 101.854ZM583.061 102.516C584.821 102.504 586.965 102.882 587.035 101.192C585.275 101.203 583.137 100.825 583.061 102.516ZM590.347 101.192C589.835 101.336 589.04 101.209 589.017 101.854C589.534 101.709 590.33 101.83 590.347 101.192ZM195.461 101.854C194.951 102.005 194.154 101.871 194.131 102.516C194.648 102.364 195.444 102.498 195.461 101.854ZM185.521 103.184C185.951 103.608 185.241 102.899 185.521 103.184ZM187.508 103.184C187.943 103.608 187.235 102.899 187.508 103.184ZM181.552 105.833C184.556 106.362 196.943 105.74 200.76 105.165C196.862 100.459 188.176 105.491 181.552 105.833ZM152.393 105.833C154.728 106.792 155.466 105.851 158.354 105.833C158.819 101.04 153.148 104.119 152.393 105.833ZM616.184 104.509C615.672 104.654 614.882 104.521 614.864 105.165C615.382 105.02 616.178 105.148 616.184 104.509ZM585.048 105.833C584.199 105.793 584.136 104.984 583.061 105.165C582.027 106.797 585.309 107.117 585.048 105.833ZM585.704 105.833C586.146 106.263 585.431 105.554 585.704 105.833ZM591.015 105.165C590.045 105.531 587.587 104.392 587.697 105.833C588.662 105.467 591.125 106.606 591.015 105.165ZM592.996 105.165C592.485 105.317 591.695 105.189 591.672 105.833C592.189 105.682 592.978 105.81 592.996 105.165ZM603.593 105.165C596.203 107.152 594.843 104.34 603.593 105.165ZM144.445 109.801C144.805 109.801 148.581 108.133 149.087 110.469C147.85 110.556 146.867 110.899 146.426 111.794C155.513 112.044 165.587 111.672 172.931 109.801C165.919 108.017 158.563 110.434 150.406 109.801C150.418 108.935 151.568 109.197 151.73 108.477C150.609 106.025 142.783 107.733 144.445 109.801ZM545.291 108.477C544.327 108.842 541.869 107.704 541.979 109.139C542.943 108.778 545.401 109.917 545.291 108.477ZM555.237 109.801H556.556V108.477H555.237V109.801ZM613.534 108.477C612.372 108.86 609.647 107.675 609.56 109.139C610.728 108.755 613.458 109.941 613.534 108.477ZM528.733 111.794C530.719 110.156 533.538 112.792 534.032 110.469C531.44 110.696 529.209 108.639 528.733 111.794ZM142.452 111.794C140.89 111.806 140.505 110.643 138.478 111.126C137.252 114.21 142.69 113.525 142.452 111.794ZM176.248 111.794C176.678 112.229 175.963 111.515 176.248 111.794ZM501.566 111.126C500.782 111.23 499.684 111.015 499.579 111.794C500.357 111.695 501.456 111.903 501.566 111.126ZM170.944 113.113C171.74 113.054 171.344 114.077 170.944 113.113C170.311 111.893 165.465 111.997 165.645 113.775C167.248 115.309 168.858 113.107 170.944 113.113ZM131.855 114.443C133.029 114.292 135.178 115.105 134.499 113.113H131.855V114.443ZM159.016 113.775C158.249 113.223 157.238 112.904 155.705 113.113C154.688 115.117 159.133 114.862 159.016 113.775ZM174.918 114.443C174.732 117.092 180.048 115.652 180.222 114.443C178.916 113.13 176.435 114.019 174.918 114.443ZM182.21 114.443C182.639 114.873 181.931 114.158 182.21 114.443ZM187.508 113.775C186.991 113.927 186.201 113.799 186.183 114.443C186.7 114.292 187.491 114.42 187.508 113.775Z",
    fill: "#72969B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.676 12.4042C375.694 11.7656 376.483 11.8928 377.001 11.7421C376.984 12.3867 376.188 12.2653 375.676 12.4042Z",
    fill: "#72969B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.326 13.7351C378.762 14.1642 378.053 13.4507 378.326 13.7351Z",
    fill: "#72969B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.313 16.3845C380.748 16.8136 380.035 16.1001 380.313 16.3845Z",
    fill: "#72969B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.227 16.3842C393.827 15.4206 393.432 16.4478 394.227 16.3842Z",
    fill: "#72969B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.229 16.3846H394.896C394.896 16.7559 394.351 17.139 394.229 16.3846Z",
    fill: "#72969B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.897 17.0407C393.42 17.1922 393.675 17.6041 393.565 18.3658C393.047 18.221 392.792 17.8133 392.897 17.0407Z",
    fill: "#72969B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.618 19.0338C386.048 19.4629 385.334 18.7553 385.618 19.0338Z",
    fill: "#72969B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.566 18.3658C394.554 18.4755 396.012 18.1332 396.215 19.0336C395.227 18.9232 393.769 19.2713 393.566 18.3658Z",
    fill: "#72969B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.214 19.0338C397.289 18.8304 397.998 19.9286 396.877 20.3639C396.877 19.69 396.342 19.5678 396.214 19.0338Z",
    fill: "#72969B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.878 20.3639C396.941 21.1593 395.919 20.7645 396.878 20.3639Z",
    fill: "#72969B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.874 21.6831C346.105 23.6996 345.878 19.2372 343.874 21.6831Z",
    fill: "#72969B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.053 22.3451C365.673 23.8966 364.441 20.0161 369.053 22.3451Z",
    fill: "#72969B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.054 22.3452C373.43 22.752 375.846 21.1892 380.314 21.6831C378.838 23.7574 371.453 23.3974 369.054 22.3452Z",
    fill: "#72969B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.86 24.3322C346.064 23.4317 347.521 23.7799 348.509 23.6702C348.306 24.5698 346.854 24.2225 345.86 24.3322Z",
    fill: "#72969B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.247 25.6625C390.986 29.7064 382.353 26.3657 378.989 28.3127C381.789 25.8023 387.924 26.6511 392.247 25.6625Z",
    fill: "#72969B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.195 26.9818C400.212 26.3372 401.008 26.4645 401.519 26.3255C401.496 26.9642 400.705 26.8369 400.195 26.9818Z",
    fill: "#72969B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.466 26.9816C408.019 29.0085 405.225 26.221 409.466 26.9816Z",
    fill: "#72969B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.124 27.6438C410.147 26.9993 410.944 27.1324 411.455 26.9817C411.437 27.6329 410.647 27.499 410.124 27.6438Z",
    fill: "#72969B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.326 27.6438C377.001 30.4731 373.881 28.3821 372.359 28.3126C363.145 27.8707 371.098 27.5342 378.326 27.6438Z",
    fill: "#72969B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.042 27.6438C424.245 29.1781 422.13 28.3821 422.055 29.631C420.492 28.7655 419.04 27.7836 416.088 28.3126C415.019 26.9758 421.869 27.9351 424.042 27.6438Z",
    fill: "#72969B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.899 31.6232C447.196 33.9879 441.107 32.9072 440.602 30.9611C442.781 29.9725 445.006 31.4893 447.899 31.6232Z",
    fill: "#72969B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.342 31.623C425.072 33.7252 424.033 29.0322 429.342 31.623Z",
    fill: "#72969B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.322 31.6234C433.391 32.4188 432.357 32.024 433.322 31.6234Z",
    fill: "#72969B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.081 32.9423C417.873 33.8369 416.42 33.4937 415.427 33.6101C415.613 32.0711 417.198 32.0879 418.081 32.9423Z",
    fill: "#72969B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.244 34.2725C337.267 33.628 338.063 33.7611 338.569 33.6104C338.557 34.2491 337.762 34.1219 337.244 34.2725Z",
    fill: "#72969B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.892 34.2724C342.316 34.7024 341.608 33.9939 341.892 34.2724Z",
    fill: "#72969B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.065 34.2725C420.089 33.628 420.885 33.7611 421.396 33.6104C421.379 34.2491 420.583 34.1219 420.065 34.2725Z",
    fill: "#72969B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.72 33.6104C434.043 33.9879 443.735 36.0036 455.849 35.5976C452.956 39.048 445.803 36.0329 439.953 35.5976C433.417 35.1088 426.16 36.4866 422.72 33.6104Z",
    fill: "#72969B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.634 34.9347C328.652 34.2902 329.448 34.4233 329.964 34.2726C329.941 34.9171 329.151 34.784 328.634 34.9347Z",
    fill: "#72969B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.604 34.9345C332.713 34.1563 333.818 34.3713 334.595 34.2726C334.486 35.0508 333.387 34.8249 332.604 34.9345Z",
    fill: "#72969B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.726 35.5976C315.155 36.0267 314.441 35.3191 314.726 35.5976Z",
    fill: "#72969B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.692 35.5975C318.802 34.8192 319.901 35.0393 320.679 34.9347C320.574 35.7071 319.477 35.4929 318.692 35.5975Z",
    fill: "#72969B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.759 36.2595C308.863 35.4813 309.967 35.7014 310.745 35.5976C310.635 36.37 309.536 36.1549 308.759 36.2595Z",
    fill: "#72969B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.1 36.9219C354.965 38.1883 350.462 36.9913 343.874 37.584C345.117 34.6559 351.973 36.7704 354.477 36.9219C357.103 37.8401 360.613 33.8716 361.101 36.9219H361.1Z",
    fill: "#72969B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.898 36.2598C386.124 39.2054 376.863 36.8984 369.054 39.5712C374.289 36.1551 386.856 36.6783 392.898 36.2598Z",
    fill: "#72969B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.466 36.9212C412.218 37.5485 409.599 34.9356 409.466 36.9212Z",
    fill: "#72969B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.465 36.9218C409.337 38.9074 406.714 36.2895 409.465 36.9218Z",
    fill: "#72969B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.414 38.2469C416.585 38.642 415.028 37.7706 412.779 37.5839C413.97 36.2195 417.961 37.6651 419.414 38.2469Z",
    fill: "#72969B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.413 38.2469C422.706 38.0435 425.484 38.3516 428.017 38.909C426.239 40.2157 421.492 38.8337 419.413 38.2469Z",
    fill: "#72969B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.071 39.5711C312.164 38.4846 316.626 38.4846 316.708 39.5711H312.071Z",
    fill: "#72969B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.673 39.571C429.726 39.8329 429.552 40.3668 428.681 39.571C428.693 38.7057 430.522 38.7233 430.673 39.571Z",
    fill: "#72969B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.672 39.5712C441.787 39.9429 450.484 40.687 460.484 40.9022C451.722 42.2205 438.975 41.0118 430.672 39.5712Z",
    fill: "#72969B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.806 41.5581C461.406 40.5946 461.006 41.6275 461.806 41.5581Z",
    fill: "#72969B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.809 41.5584C464.528 41.4947 467.241 41.4361 469.1 42.2205C466.48 43.4869 462.989 42.9353 461.809 41.5584Z",
    fill: "#72969B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.251 45.5326C443.495 44.7717 444.425 43.8593 444.582 44.8705C451.931 44.539 448.835 46.0499 443.251 45.5326Z",
    fill: "#72969B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.135 44.8706C301.298 44.2838 292.293 48.0833 290.87 46.2007C290.394 45.567 301.816 43.8301 294.182 45.5327C296.267 45.0732 297.76 44.5919 302.135 44.8706Z",
    fill: "#72969B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.335 45.5326C431.439 44.7602 432.543 44.9744 433.322 44.8707C433.211 45.6489 432.113 45.4339 431.335 45.5326Z",
    fill: "#72969B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.6 44.8707C435.193 46.852 433.834 44.0454 442.6 44.8707Z",
    fill: "#72969B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.503 44.8707C451.1 46.852 449.735 44.0454 458.503 44.8707Z",
    fill: "#72969B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.821 45.5326C463.787 47.577 463.068 43.0865 459.821 45.5326Z",
    fill: "#72969B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.398 46.8569C470.633 46.8628 469.273 46.1078 467.112 45.5327C459.861 43.6091 472.283 45.9454 474.398 46.2007V46.8569Z",
    fill: "#72969B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.892 46.2006C287.008 45.4223 288.1 45.6374 288.879 45.5328C288.78 46.311 287.67 46.096 286.892 46.2006Z",
    fill: "#72969B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.398 46.8569C476.496 47.4153 479.964 46.5899 480.365 48.85C478.228 48.5537 476.775 47.5776 474.398 47.5249V46.8569Z",
    fill: "#72969B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.68 49.512C429.115 49.9478 428.407 49.2335 428.68 49.512Z",
    fill: "#72969B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.606 50.8312C280.041 51.2779 279.327 50.5586 279.606 50.8312Z",
    fill: "#72969B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.259 50.8314C282.277 50.1927 283.066 50.3258 283.578 50.1693C283.56 50.8205 282.771 50.6866 282.259 50.8314Z",
    fill: "#72969B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.242 50.8314C284.266 50.1927 285.056 50.3258 285.566 50.1693C285.555 50.8205 284.759 50.6866 284.242 50.8314Z",
    fill: "#72969B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.558 50.8312C287.987 51.2779 287.274 50.5586 287.558 50.8312Z",
    fill: "#72969B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.207 50.8311C290.097 49.4026 292.554 50.529 293.518 50.1691C293.628 51.6093 291.165 50.4712 290.207 50.8311Z",
    fill: "#72969B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.428 50.8314C411.53 52.0167 407.591 53.1609 402.182 52.8295C403.971 52.5156 412.534 50.0764 415.428 50.8314Z",
    fill: "#72969B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.693 50.8312C427.127 51.2779 426.414 50.5586 426.693 50.8312Z",
    fill: "#72969B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.301 51.4992V50.8314C275.27 51.1971 277.728 50.0648 277.617 51.4992H274.301Z",
    fill: "#72969B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.146 51.4993C461.586 51.9292 460.873 51.2208 461.146 51.4993Z",
    fill: "#72969B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.801 51.4993C464.085 50.0177 467.066 51.2265 468.437 50.8314C468.147 52.313 465.166 51.1042 463.801 51.4993Z",
    fill: "#72969B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.645 51.4994H274.302C274.302 51.8599 273.767 52.2547 273.645 51.4994Z",
    fill: "#72969B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.677 52.1614C483.758 50.6973 486.483 51.8826 487.651 51.4992C487.57 52.9633 484.839 51.778 483.677 52.1614Z",
    fill: "#72969B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.35 52.1614C324.161 52.6612 327.153 52.9868 329.966 53.4865C327.741 53.5501 322.193 55.328 321.35 52.1614Z",
    fill: "#72969B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.974 52.1614C379.523 54.1832 376.734 51.3949 380.974 52.1614Z",
    fill: "#72969B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.526 52.8294C400.304 55.4386 400.304 50.2094 399.526 52.8294Z",
    fill: "#72969B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.295 52.8292C435.837 50.8024 433.05 53.5849 437.295 52.8292Z",
    fill: "#72969B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.296 52.8293H441.271C443.136 52.795 443.728 53.4161 444.582 53.4864C460.176 54.7931 438.552 54.1427 437.296 52.8293Z",
    fill: "#72969B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.649 54.8107C273.909 54.1661 278.674 52.5849 280.928 54.1536C277.315 53.8456 275.485 55.3272 271.649 54.8107Z",
    fill: "#72969B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.259 54.1544C282.277 53.5032 283.066 53.6313 283.578 53.4865C283.56 54.1251 282.771 54.0038 282.259 54.1544Z",
    fill: "#72969B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.566 54.1544C285.583 53.5032 286.38 53.6313 286.891 53.4865C286.873 54.1251 286.077 54.0038 285.566 54.1544Z",
    fill: "#72969B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.62 54.1543C330.729 53.3701 331.828 53.5852 332.6 53.4865C332.502 54.2647 331.398 54.0438 330.62 54.1543Z",
    fill: "#72969B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.787 56.135C460.175 56.6641 456.45 55.3097 451.878 54.8108C455.423 53.7009 461.639 55.6353 465.787 56.135Z",
    fill: "#72969B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.031 56.1349C425.95 57.5989 423.218 56.4137 422.057 56.8029C422.614 54.439 423.689 56.7217 426.031 56.1349Z",
    fill: "#72969B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.916 56.8036C282.805 55.3634 285.262 56.5015 286.226 56.1358C286.337 57.5701 283.88 56.432 282.916 56.8036Z",
    fill: "#72969B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.788 56.135C467.805 56.5535 471.499 55.2862 472.417 56.803C470.401 56.3845 466.706 57.6451 465.788 56.135Z",
    fill: "#72969B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.975 57.4598C278.638 58.2791 275.803 55.438 272.975 57.4598Z",
    fill: "#72969B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.693 57.4598C426.798 56.6874 427.902 56.9017 428.68 56.8029C428.57 57.5695 427.472 57.3611 426.693 57.4598Z",
    fill: "#72969B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.721 61.4336C468.668 59.9411 450.82 60.1788 441.93 59.4523C440.025 59.2957 426.831 56.7686 430.671 56.803C433.64 56.8147 440.379 58.5985 442.599 58.7901C452.372 59.6389 467.873 58.2963 475.721 61.4336Z",
    fill: "#72969B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.417 56.8038C475.078 57.2223 479.453 55.9382 481.027 57.4609C478.36 57.0365 473.98 58.3264 472.417 56.8038Z",
    fill: "#72969B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.332 58.1279C270.454 57.1463 271.935 57.5178 272.975 57.4601C272.853 58.4417 271.377 58.0701 270.332 58.1279Z",
    fill: "#72969B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.99 58.128C482.475 59.7778 480.476 56.0303 486.99 58.128Z",
    fill: "#72969B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.353 58.7902C266.434 57.3262 269.165 58.5056 270.333 58.1281C270.239 59.5862 267.52 58.4009 266.353 58.7902Z",
    fill: "#72969B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.717 59.4531C261.74 58.8027 262.525 58.9299 263.042 58.791C263.024 59.4296 262.234 59.3024 261.717 59.4531Z",
    fill: "#72969B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.703 59.4531C264.139 59.883 263.425 59.1745 263.703 59.4531Z",
    fill: "#72969B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.352 58.7901C266.224 60.7757 263.606 58.1519 266.352 58.7901Z",
    fill: "#72969B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.026 59.4532C373.73 57.9423 377.192 59.192 378.987 58.791C378.285 60.2902 374.828 59.0413 373.026 59.4532Z",
    fill: "#72969B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.415 59.4531C411.832 62.0446 404.344 59.7318 398.865 60.1102C403.955 57.8443 411.646 60.7028 417.415 59.4531Z",
    fill: "#72969B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.638 60.1093C380.854 58.0928 378.122 60.8351 381.638 60.1093Z",
    fill: "#72969B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.673 60.1093C323.905 59.4758 324.887 62.0959 325.328 60.1093C328.331 61.2357 321.512 62.7922 322.673 60.1093Z",
    fill: "#72969B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.284 60.1093C329.832 62.1361 327.044 59.3477 331.284 60.1093Z",
    fill: "#72969B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.637 60.1093C385.882 59.3477 383.094 62.1361 381.637 60.1093Z",
    fill: "#72969B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.929 60.1094C389.556 62.5084 386.314 61.0385 384.949 61.4336C385.623 60.3412 387.767 60.7129 388.929 60.1094Z",
    fill: "#72969B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.338 61.4335C268.419 59.9754 271.145 61.1548 272.318 60.7773C272.231 62.2354 269.506 61.056 268.338 61.4335Z",
    fill: "#72969B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.644 61.4334C273.528 59.9991 275.991 61.1372 276.955 60.7773C277.059 62.2117 274.602 61.0794 273.644 61.4334Z",
    fill: "#72969B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.384 62.0966C476.03 60.0918 488.509 61.7132 485.663 62.0966H476.384Z",
    fill: "#72969B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.391 61.4337C259.38 63.5196 255.308 62.5377 252.437 62.7587C249.421 61.6203 258.973 62.4741 260.391 61.4337Z",
    fill: "#72969B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.703 62.0965C264.139 62.5373 263.425 61.8238 263.703 62.0965Z",
    fill: "#72969B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.689 62.0965C266.119 62.5373 265.417 61.8238 265.689 62.0965Z",
    fill: "#72969B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.626 62.0963C488.803 60.0687 485.963 62.9097 491.626 62.0963Z",
    fill: "#72969B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.625 62.0965C494.071 62.5209 498.224 61.236 499.579 62.7586C497.127 62.3401 492.973 63.6124 491.625 62.0965Z",
    fill: "#72969B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.235 62.7587C500.403 61.9275 501.554 62.0966 501.566 62.7587C501.269 63.723 500.985 62.6942 500.235 62.7587Z",
    fill: "#72969B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.958 63.4207C437.976 62.7762 438.772 62.9093 439.283 62.7586C439.265 63.4031 438.476 63.2701 437.958 63.4207Z",
    fill: "#72969B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.532 62.7586C504.086 64.7854 501.293 61.992 505.532 62.7586Z",
    fill: "#72969B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.249 63.4208C441.049 65.4482 438.179 62.5904 445.249 63.4208Z",
    fill: "#72969B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.395 65.408C418.595 64.6764 415.091 64.6521 411.454 64.7517C410.599 64.118 421.156 62.8114 421.395 65.408Z",
    fill: "#72969B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.72 64.7517C422.738 64.1005 423.534 64.2344 424.045 64.0887C424.028 64.7333 423.238 64.6002 422.72 64.7517Z",
    fill: "#72969B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.534 64.7515C449.711 62.7188 446.871 65.5582 452.534 64.7515Z",
    fill: "#72969B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.535 64.7518C456.178 63.2819 461.297 65.5704 465.788 65.408C462.336 67.0755 457.45 64.4839 452.535 65.408V64.7518Z",
    fill: "#72969B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.936 65.408C494.959 64.7693 495.75 64.8965 496.266 64.7517C496.243 65.3904 495.453 65.2632 494.936 65.408Z",
    fill: "#72969B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.75 66.7379C255.86 65.9596 256.958 66.1805 257.742 66.0701C257.632 66.8483 256.534 66.6341 255.75 66.7379Z",
    fill: "#72969B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.048 66.738C261.078 66.0935 261.862 66.2207 262.373 66.0701C262.362 66.7146 261.572 66.5874 261.048 66.738Z",
    fill: "#72969B"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.032 66.7379C265.137 65.9596 266.235 66.1805 267.019 66.0701C266.909 66.8483 265.81 66.6341 265.032 66.7379Z",
    fill: "#72969B"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.002 66.738C269.437 67.1679 268.723 66.4595 269.002 66.738Z",
    fill: "#72969B"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.338 67.3951C479.87 68.7603 473.746 66.0759 467.768 66.738C470.208 64.8672 479.847 66.9355 484.338 67.3951Z",
    fill: "#72969B"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.663 68.0631C486.366 66.5589 489.829 67.8069 491.624 67.3951C490.921 68.906 487.464 67.6563 485.663 68.0631Z",
    fill: "#72969B"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.578 68.0631C499.287 69.5506 496.307 68.3302 494.936 68.7194C495.819 66.9884 497.882 67.4588 499.578 68.0631Z",
    fill: "#72969B"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.288 68.7194C492.311 68.0808 493.101 68.2147 493.607 68.0632C493.601 68.7077 492.805 68.5746 492.288 68.7194Z",
    fill: "#72969B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.902 68.7195C500.984 67.2613 503.709 68.4466 504.877 68.0632C504.796 69.5273 502.064 68.342 500.902 68.7195Z",
    fill: "#72969B"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.525 68.7192C507.624 67.0756 509.767 68.5275 510.174 68.7192C510.075 70.3753 507.932 68.9167 507.525 68.7192Z",
    fill: "#72969B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.143 69.3872C516.032 67.9529 518.489 69.0859 519.453 68.7194C519.563 70.1596 517.101 69.0215 516.143 69.3872Z",
    fill: "#72969B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.122 69.3873C520.134 68.7428 520.924 68.87 521.441 68.7194C521.424 69.3639 520.634 69.2367 520.122 69.3873Z",
    fill: "#72969B"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.428 69.3873C523.439 68.3762 528.337 67.935 527.401 70.0503C525.769 70.1432 524.212 70.1549 523.428 69.3873Z",
    fill: "#72969B"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.733 69.3872C528.524 68.2206 532.438 68.208 531.375 70.0499C530.19 70.1311 529.981 69.2365 528.733 69.3872Z",
    fill: "#72969B"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.743 70.0501C257.846 69.2777 258.951 69.4861 259.728 69.3873C259.625 70.1597 258.514 69.9455 257.743 70.0501Z",
    fill: "#72969B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.502 70.7181C458.385 69.2779 460.848 70.416 461.806 70.0503C461.917 71.4847 459.46 70.3466 458.502 70.7181Z",
    fill: "#72969B"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.183 71.3739C296.934 72.0071 294.316 69.3942 294.183 71.3739Z",
    fill: "#72969B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.476 71.3745C354.267 72.2749 352.82 71.9268 351.821 72.0423C352.001 70.5033 353.593 70.515 354.476 71.3745Z",
    fill: "#72969B"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.397 70.7182C472.946 72.7333 470.158 69.9517 474.397 70.7182Z",
    fill: "#72969B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.54 72.0425C289.975 72.4665 289.273 71.764 289.54 72.0425Z",
    fill: "#72969B"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.181 71.3746C292.722 73.4023 289.935 70.6081 294.181 71.3746Z",
    fill: "#72969B"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.592 71.3745C393.17 72.502 397.998 70.4972 400.851 73.3675C397.644 72.1646 391.33 74.0531 389.592 71.3745Z",
    fill: "#72969B"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.714 72.0424C477.732 71.392 478.521 71.5193 479.039 71.3745C479.021 72.019 478.225 71.8918 477.714 72.0424Z",
    fill: "#72969B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.698 72.0425C480.837 70.5207 484.752 71.7922 486.99 71.3745C485.851 72.8913 481.929 71.6181 479.698 72.0425Z",
    fill: "#72969B"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.975 72.6996C273.416 73.1346 272.703 72.427 272.975 72.6996Z",
    fill: "#72969B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.259 72.6995C282.277 72.055 283.066 72.1881 283.578 72.0424C283.56 72.6819 282.771 72.5539 282.259 72.6995Z",
    fill: "#72969B"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.904 72.6996C284.991 71.2414 287.721 72.4208 288.878 72.0425C288.797 73.5065 286.072 72.3154 284.904 72.6996Z",
    fill: "#72969B"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.375 72.6993C425.474 71.9269 426.578 72.1412 427.362 72.0424C427.245 72.8148 426.153 72.5947 425.375 72.6993Z",
    fill: "#72969B"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.018 72.6997C430.684 71.172 436.18 72.467 439.951 72.0426C437.278 73.5761 431.783 72.2694 428.018 72.6997Z",
    fill: "#72969B"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.279 72.6996C276.827 74.7264 274.033 71.933 278.279 72.6996Z",
    fill: "#72969B"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.271 73.3677C442.619 71.845 446.767 73.1241 449.218 72.6997C447.871 74.2215 443.716 72.9433 441.271 73.3677Z",
    fill: "#72969B"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.092 74.0179C255.109 73.3784 255.9 73.5123 256.411 73.3667C256.399 74.0112 255.604 73.8781 255.092 74.0179Z",
    fill: "#72969B"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.878 74.018C451.954 72.5648 454.678 73.7501 455.847 73.3667C455.766 74.8249 453.034 73.6396 451.878 74.018Z",
    fill: "#72969B"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.813 74.6867C245.918 73.9084 247.022 74.1285 247.8 74.0189C247.696 74.803 246.592 74.5821 245.813 74.6867Z",
    fill: "#72969B"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.157 74.018C457.705 76.0507 454.917 73.2564 459.157 74.018Z",
    fill: "#72969B"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.145 74.6868C462.946 74.2332 466.664 73.8498 469.762 74.6868C467.559 75.2795 463.952 75.6913 461.145 74.6868Z",
    fill: "#72969B"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.676 75.3489C377.901 73.8213 382.95 75.1162 386.279 74.6868C383.136 76.3777 379.605 75.7616 375.676 75.3489Z",
    fill: "#72969B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.425 75.3488C474.729 77.5154 473.109 73.455 470.425 75.3488Z",
    fill: "#72969B"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.296 76.0167C437.401 75.2384 438.499 75.4535 439.283 75.3489C439.173 76.133 438.075 75.9071 437.296 76.0167Z",
    fill: "#72969B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.398 76.0169C475.868 75.2267 483.258 74.198 483.677 76.679C480.522 75.9767 478.89 76.9519 474.398 76.0169Z",
    fill: "#72969B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.552 76.679C501.635 78.1899 496.883 75.3891 494.274 77.3361C492.032 76.2964 483.043 76.6505 487.651 76.0169C490.236 75.6511 494.123 76.8422 498.254 75.3489C500.299 75.5113 502.001 76.0227 503.552 76.679Z",
    fill: "#72969B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.349 76.0169C319.31 77.7371 308.991 76.9 304.117 77.9982C307.922 75.4075 316.022 77.0925 321.349 76.0169Z",
    fill: "#72969B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.582 77.3361C444.605 76.6974 445.396 76.8188 445.907 76.679C445.895 77.3185 445.099 77.1963 444.582 77.3361Z",
    fill: "#72969B"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.837 76.6791C512.372 77.6492 509.542 78.7767 512.162 78.6663C511.61 79.6481 510.025 79.6197 508.851 79.9913C510.64 78.1205 507.933 77.0105 505.533 77.3362C503.773 76.1685 509.42 76.854 510.837 76.6791Z",
    fill: "#72969B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.764 77.9981C414.788 77.3536 415.578 77.4867 416.089 77.336C416.078 77.9805 415.281 77.8592 414.764 77.9981Z",
    fill: "#72969B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.753 77.9981C416.771 77.3536 417.567 77.4867 418.083 77.336C418.06 77.9805 417.264 77.8592 416.753 77.9981Z",
    fill: "#72969B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.394 77.9979C420.987 77.046 420.592 78.0673 421.394 77.9979Z",
    fill: "#72969B"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.899 77.9982C448.329 78.439 447.615 77.7256 447.899 77.9982Z",
    fill: "#72969B"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.112 77.9981C467.124 77.3536 467.92 77.4867 468.437 77.336C468.414 77.9805 467.618 77.8592 467.112 77.9981Z",
    fill: "#72969B"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.734 77.9982C474.164 78.439 473.455 77.7256 473.734 77.9982Z",
    fill: "#72969B"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.395 77.9982C422.19 77.9346 421.795 78.9676 421.395 77.9982Z",
    fill: "#72969B"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.645 78.6662C432.385 80.7689 416.124 76.8129 429.341 77.9982C431.066 78.1556 431.345 79.0554 434.645 78.6662Z",
    fill: "#72969B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.424 79.3223C254.314 77.8879 256.771 79.026 257.741 78.6653C257.851 80.1056 255.388 78.9675 254.424 79.3223Z",
    fill: "#72969B"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.339 79.3225C484.171 80.1646 483.021 79.9964 483.009 79.3225C475.404 79.8917 481.011 77.4174 484.339 79.3225Z",
    fill: "#72969B"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.606 81.3155C494.675 82.4598 496.592 82.7502 498.911 82.6406C495.906 84.6386 489.446 80.9614 483.677 82.6406C484.49 81.2402 487.668 82.2103 488.307 80.6475C488.204 79.8749 487.099 80.0959 486.326 79.9913C488.528 78.585 498.782 79.294 502.228 79.3233C509.275 80.8158 493.78 78.6436 493.606 81.3155ZM488.975 80.6467C489.411 81.0828 488.697 80.368 488.975 80.6467Z",
    fill: "#72969B"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.824 79.3224C513.318 77.835 516.542 79.0663 518.128 78.6653C518.075 80.676 513.794 80.2173 512.824 79.3224Z",
    fill: "#72969B"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.973 79.9913C435.99 79.3467 436.78 79.474 437.297 79.3233C437.273 79.9737 436.483 79.8406 435.973 79.9913Z",
    fill: "#72969B"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.602 79.9911C440.712 79.2128 441.816 79.4271 442.6 79.3233C442.49 80.1074 441.391 79.8865 440.602 79.9911Z",
    fill: "#72969B"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.2 79.9913C506.218 79.3467 507.007 79.474 507.524 79.3233C507.507 79.9737 506.711 79.8406 506.2 79.9913Z",
    fill: "#72969B"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.969 80.6467C273.911 81.5934 266.573 81.9659 262.373 81.9776C266.486 78.8629 269.56 80.943 274.969 80.6467Z",
    fill: "#72969B"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.581 80.6467C445.021 81.0825 444.308 80.3682 444.581 80.6467Z",
    fill: "#72969B"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.21 79.9912C447.696 82.018 444.844 79.1661 451.21 79.9912Z",
    fill: "#72969B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.535 79.9913C454.145 81.2461 458.084 80.183 459.821 81.3156C466.049 81.7224 477.442 80.4793 480.364 81.9785H458.502C456.811 81.0134 452.767 82.4138 452.534 79.9913H452.535Z",
    fill: "#72969B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.294 81.3155C277.432 79.7988 281.348 81.0719 283.58 80.6475C282.453 82.1702 278.526 80.8911 276.294 81.3155Z",
    fill: "#72969B"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.904 81.3153C285.013 80.537 286.112 80.7579 286.89 80.6475C286.786 81.4257 285.682 81.2115 284.904 81.3153Z",
    fill: "#72969B"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.877 81.3153C288.987 80.537 290.085 80.7579 290.869 80.6475C290.759 81.4257 289.66 81.2115 288.877 81.3153Z",
    fill: "#72969B"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.785 81.3154C304.802 80.6709 305.598 80.7981 306.109 80.6475C306.091 81.292 305.295 81.1648 304.785 81.3154Z",
    fill: "#72969B"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.058 81.3154C314.076 80.6709 314.865 80.7981 315.377 80.6475C315.371 81.292 314.575 81.1648 314.058 81.3154Z",
    fill: "#72969B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.341 83.2959C433.455 82.4128 438.974 81.4025 443.25 82.6397C439.689 84.1564 433.123 82.674 429.341 83.9639V83.2959Z",
    fill: "#72969B"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.791 83.296C408.392 83.5521 402.012 86.1487 400.85 83.296C403.639 84.6612 408.001 81.9366 410.791 83.296Z",
    fill: "#72969B"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.064 83.2954C419.936 81.3156 417.318 83.9285 420.064 83.2954Z",
    fill: "#72969B"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.066 83.2958C420.583 83.151 421.379 83.2841 421.396 82.6397C423.464 83.4757 420.037 85.8749 420.066 83.2958Z",
    fill: "#72969B"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.361 83.296C426.57 85.0856 423.904 83.296 422.718 83.296C423.503 81.5122 426.169 83.3077 427.361 83.296Z",
    fill: "#72969B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.361 83.2958C427.361 82.4305 429.19 82.4598 429.342 83.2958H427.361Z",
    fill: "#72969B"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.565 83.2958C501.454 81.8673 503.911 83.0054 504.875 82.6397C504.992 84.0741 502.523 82.9359 501.565 83.2958Z",
    fill: "#72969B"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.2 83.2959C506.635 83.7375 505.928 83.0232 506.2 83.2959Z",
    fill: "#72969B"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.525 83.2958C507.415 81.8673 509.872 83.0054 510.836 82.6397C510.952 84.0741 508.483 82.9359 507.525 83.2958Z",
    fill: "#72969B"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.149 83.2959C512.597 85.4338 511.476 80.9722 514.149 83.2959Z",
    fill: "#72969B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.475 82.6397H516.806V83.9639H515.475V82.6397Z",
    fill: "#72969B"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.466 83.2959C517.896 83.7375 517.188 83.0232 517.466 83.2959Z",
    fill: "#72969B"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.896 83.9648C392.984 82.5008 395.715 83.6802 396.877 83.2969C396.796 84.7668 394.07 83.5882 392.896 83.9648Z",
    fill: "#72969B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.201 83.9646C398.305 83.1863 399.409 83.4073 400.193 83.2968C400.083 84.0751 398.985 83.8608 398.201 83.9646Z",
    fill: "#72969B"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.09 83.2959C412.581 85.3286 409.736 82.4716 416.09 83.2959Z",
    fill: "#72969B"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.435 85.2891C203.659 86.4217 221.38 81.3558 229.251 83.964C226.096 82.9127 226.718 85.6725 220.641 84.627C214.1 85.1033 205.849 86.8352 199.435 85.2891Z",
    fill: "#72969B"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.238 84.6269C231.673 85.0619 230.96 84.3426 231.238 84.6269Z",
    fill: "#72969B"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.557 84.6267C232.673 83.8543 233.771 84.0685 234.554 83.9639C234.444 84.7363 233.346 84.528 232.557 84.6267Z",
    fill: "#72969B"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.482 84.6269C244.924 85.0619 244.21 84.3426 244.482 84.6269Z",
    fill: "#72969B"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.133 84.6269C249.562 85.0619 248.848 84.3426 249.133 84.6269Z",
    fill: "#72969B"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.693 85.289C322.046 87.7056 305.493 86.6894 311.407 85.9511C315.48 85.4397 315.166 86.7128 318.693 85.289Z",
    fill: "#72969B"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.984 85.289C322.476 87.3158 319.618 84.4639 325.984 85.289Z",
    fill: "#72969B"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.93 87.9384C286.054 85.5502 294.635 86.6191 301.468 85.9512C298.156 87.4964 286.99 86.9213 280.93 87.9384Z",
    fill: "#72969B"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.341 87.9384C429.381 87.0963 430.19 87.0201 430.009 85.9512C431.102 87.067 433.896 86.4802 435.971 86.6141C434.408 88.4557 432.543 87.0377 429.341 87.9384Z",
    fill: "#72969B"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.513 86.614C509.623 85.8357 510.722 86.0499 511.5 85.9512C511.395 86.7236 510.297 86.5093 509.513 86.614Z",
    fill: "#72969B"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.791 87.9383C517.321 87.4151 516.101 87.3054 512.824 87.282C514.032 85.7653 518.163 85.5217 518.791 87.9383Z",
    fill: "#72969B"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.621 87.2821C223.062 87.7112 222.342 86.9977 222.621 87.2821Z",
    fill: "#72969B"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.601 87.2819C226.705 86.5037 227.809 86.7179 228.587 86.6141C228.477 87.3924 227.373 87.1773 226.601 87.2819Z",
    fill: "#72969B"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.802 87.2821C247.82 86.6309 248.609 86.7648 249.132 86.6141C249.109 87.2587 248.313 87.1256 247.802 87.2821Z",
    fill: "#72969B"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.332 87.2821C268.315 89.7221 268.095 85.2597 270.332 87.2821Z",
    fill: "#72969B"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.797 87.2821C303.076 85.7947 306.063 87.0092 307.434 86.6141C307.149 88.0899 304.168 86.8812 302.797 87.2821Z",
    fill: "#72969B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.287 87.282C383.381 89.1989 375.456 87.0259 381.638 87.282C383.45 87.3339 382.974 86.178 384.287 87.282Z",
    fill: "#72969B"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.62 87.2818C438.51 85.8349 440.967 86.9739 441.931 86.614C442.041 88.0484 439.584 86.9153 438.62 87.2818Z",
    fill: "#72969B"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.601 87.2819C442.699 86.5037 443.803 86.7179 444.581 86.6141C444.472 87.3924 443.373 87.1773 442.601 87.2819Z",
    fill: "#72969B"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.576 87.2822C447.924 85.7596 452.072 87.0319 454.524 86.6142C453.17 88.136 449.022 86.8519 446.576 87.2822Z",
    fill: "#72969B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.483 86.6141C456.288 88.6415 453.424 85.7771 460.483 86.6141Z",
    fill: "#72969B"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.801 87.2821C464.236 87.7112 463.522 86.9977 463.801 87.2821Z",
    fill: "#72969B"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.991 87.2818C539.881 85.8349 542.343 86.9739 543.302 86.614C543.419 88.0484 540.955 86.9153 539.991 87.2818Z",
    fill: "#72969B"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.494 89.2577C197.424 86.0099 209.735 89.1472 217.317 87.2822C221.802 86.8118 221.802 88.403 217.317 87.9385C209.067 89.4025 197.878 87.9326 189.494 89.2577Z",
    fill: "#72969B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.45 87.9383C250.885 88.3741 250.178 87.6598 250.45 87.9383Z",
    fill: "#72969B"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.742 87.9384C257.579 88.7696 256.423 88.6064 256.411 87.9384C248.807 88.5135 254.419 86.0265 257.742 87.9384Z",
    fill: "#72969B"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.716 87.9382C261.6 86.5038 264.068 87.6361 265.032 87.2821C265.137 88.7106 262.675 87.5725 261.716 87.9382Z",
    fill: "#72969B"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.987 87.9383C271.417 88.3741 270.715 87.6598 270.987 87.9383Z",
    fill: "#72969B"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.319 87.9384C273.457 86.4216 277.373 87.6948 279.605 87.2821C278.471 88.798 274.544 87.5198 272.319 87.9384Z",
    fill: "#72969B"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.942 87.9383C387.371 88.3741 386.663 87.6598 386.942 87.9383Z",
    fill: "#72969B"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.091 87.9381C420.337 88.6988 417.549 85.9171 416.091 87.9381Z",
    fill: "#72969B"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.718 87.282C421.266 89.2972 418.473 86.5096 422.718 87.282Z",
    fill: "#72969B"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.77 87.9381C467.88 87.1657 468.978 87.3808 469.763 87.282C469.658 88.0544 468.554 87.8277 467.77 87.9381Z",
    fill: "#72969B"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.698 87.2821C479.901 89.4836 474.504 87.0729 471.75 87.9384C470.675 86.6083 477.525 87.5609 479.698 87.2821Z",
    fill: "#72969B"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.896 88.6064C395.127 87.0729 400.182 88.3628 403.505 87.9384C401.281 89.4719 396.225 88.1711 392.896 88.6064Z",
    fill: "#72969B"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.168 88.6063C404.249 87.1423 406.98 88.3159 408.142 87.9383C408.06 89.4024 405.33 88.2229 404.168 88.6063Z",
    fill: "#72969B"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.805 88.6061C408.543 87.3165 411.819 87.6304 410.791 89.2572H409.467C409.589 88.699 409.205 88.6413 408.805 88.6061Z",
    fill: "#72969B"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.09 87.9383C412.581 89.9709 409.736 87.1131 416.09 87.9383Z",
    fill: "#72969B"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.341 87.9383C429.213 89.9239 426.595 87.306 429.341 87.9383Z",
    fill: "#72969B"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.307 88.6063C488.33 87.9618 489.126 88.089 489.638 87.9384C489.62 88.5829 488.83 88.4557 488.307 88.6063Z",
    fill: "#72969B"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.305 88.6063C490.729 89.0362 490.021 88.3219 490.305 88.6063Z",
    fill: "#72969B"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.513 89.9254C509.402 88.491 511.865 89.6233 512.823 89.2576C512.94 90.6978 510.477 89.5647 509.513 89.9254Z",
    fill: "#72969B"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.475 89.9253C515.911 87.9387 516.898 90.558 518.129 89.9253C518.025 91.5747 515.893 90.1228 515.475 89.9253Z",
    fill: "#72969B"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.453 89.2574V89.9249C519.081 89.9249 518.697 89.3913 519.453 89.2574Z",
    fill: "#72969B"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.631 90.5877C275.655 89.9431 276.438 90.0762 276.956 89.9255C276.938 90.5768 276.142 90.437 275.631 90.5877Z",
    fill: "#72969B"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.904 90.5875C285.013 89.8151 286.112 90.0301 286.89 89.9255C286.786 90.6979 285.682 90.4887 284.904 90.5875Z",
    fill: "#72969B"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.95 90.5876C440.374 91.0233 439.666 90.3149 439.95 90.5876Z",
    fill: "#72969B"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.932 90.5876C442.368 91.0233 441.659 90.3149 441.932 90.5876Z",
    fill: "#72969B"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.335 92.5749C208.648 89.9256 197.488 94.0741 190.156 92.5749C196.628 90.617 212.756 90.3609 221.965 91.2557C219.537 92.6963 217.707 90.8497 215.335 92.5749Z",
    fill: "#72969B"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.987 91.2556C271.417 91.6855 270.715 90.9712 270.987 91.2556Z",
    fill: "#72969B"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.279 91.2556C278.714 91.6855 278.001 90.9712 278.279 91.2556Z",
    fill: "#72969B"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.529 90.5877C349.113 91.1226 351.774 92.2903 356.457 91.2557C354.11 93.3182 346.272 93.1098 344.529 90.5877Z",
    fill: "#72969B"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.209 90.5877C449.751 92.6145 446.963 89.827 451.209 90.5877Z",
    fill: "#72969B"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.535 91.2557C452.553 90.6111 453.349 90.7325 453.86 90.5877C453.843 91.2322 453.047 91.105 452.535 91.2557Z",
    fill: "#72969B"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.284 91.9185C223.725 92.3476 223.011 91.64 223.284 91.9185Z",
    fill: "#72969B"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.557 91.9186C232.58 91.2674 233.376 91.4013 233.887 91.2557C233.869 91.9002 233.079 91.7671 232.557 91.9186Z",
    fill: "#72969B"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.203 91.9185C237.307 91.1402 238.411 91.3544 239.183 91.2557C239.079 92.0281 237.975 91.808 237.203 91.9185Z",
    fill: "#72969B"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.715 91.2557C257.521 93.278 254.656 90.4194 261.715 91.2557Z",
    fill: "#72969B"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.375 91.9185C262.467 90.4487 265.186 91.6339 266.354 91.2556C266.273 92.7137 263.547 91.5343 262.375 91.9185Z",
    fill: "#72969B"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.145 91.2556C459.693 93.2715 456.905 90.489 461.145 91.2556Z",
    fill: "#72969B"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.12 91.2556C466.311 91.1627 466.519 92.0573 467.768 91.9184C467.984 93.085 464.057 93.0975 465.12 91.2556Z",
    fill: "#72969B"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.551 92.5748C182.416 91.4532 185.745 93.4521 187.506 91.9186C187.814 94.4457 182.335 93.1675 181.551 92.5748Z",
    fill: "#72969B"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.813 92.5748C245.837 91.9303 246.62 92.0575 247.138 91.9186C247.12 92.5573 246.331 92.43 245.813 92.5748Z",
    fill: "#72969B"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.466 91.9186C300.339 93.4638 288.545 93.8941 293.518 92.5748C294.68 92.2727 297.894 92.5221 301.466 91.9186Z",
    fill: "#72969B"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.117 92.5748C303.333 90.5642 300.607 93.3014 304.117 92.5748Z",
    fill: "#72969B"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.843 91.9186C401.391 93.9396 398.603 91.152 402.843 91.9186Z",
    fill: "#72969B"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.493 92.5748C405.929 93.0106 405.22 92.3021 405.493 92.5748Z",
    fill: "#72969B"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.1 92.5748C469.123 91.9303 469.907 92.0575 470.425 91.9186C470.407 92.5573 469.617 92.43 469.1 92.5748Z",
    fill: "#72969B"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.085 92.5747C471.283 91.6801 472.747 92.029 473.734 91.9186C473.548 93.4517 471.968 93.4341 471.085 92.5747Z",
    fill: "#72969B"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.065 92.5747C475.169 91.7964 476.274 92.0223 477.046 91.9186C476.936 92.6968 475.838 92.4759 475.065 92.5747Z",
    fill: "#72969B"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.363 92.5747C480.253 91.1403 482.704 92.2784 483.674 91.9186C483.784 93.3471 481.316 92.2148 480.363 92.5747Z",
    fill: "#72969B"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.336 92.575C215.405 93.3762 214.373 92.9814 215.336 92.575Z",
    fill: "#72969B"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.871 92.5749C290.198 93.6731 288.054 93.3014 286.892 93.905C286.967 92.2091 289.111 92.5866 290.871 92.5749Z",
    fill: "#72969B"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.117 92.5748C306.348 92.9992 310.27 91.721 311.409 93.2369C309.172 92.8184 305.256 94.0974 304.117 92.5748Z",
    fill: "#72969B"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.734 93.2369C312.809 91.7787 315.541 92.9582 316.708 92.5748C316.627 94.0388 313.902 92.8594 312.734 93.2369Z",
    fill: "#72969B"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.356 93.237C317.758 95.4158 316.196 91.3954 319.356 93.237Z",
    fill: "#72969B"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.791 93.2371C410.814 92.5925 411.605 92.7256 412.116 92.575C412.098 93.2195 411.309 93.0864 410.791 93.2371Z",
    fill: "#72969B"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.718 92.5749C421.266 94.5968 418.473 91.8142 422.718 92.5749Z",
    fill: "#72969B"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.283 93.2369C439.388 92.4645 440.492 92.6796 441.27 92.575C441.165 93.3532 440.067 93.1331 439.283 93.2369Z",
    fill: "#72969B"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.901 93.237C501.331 93.6727 500.617 92.9585 500.901 93.237Z",
    fill: "#72969B"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.148 93.9049C525.356 91.0413 543.68 93.8354 553.237 94.562C550.012 94.8701 545.48 93.8765 543.302 95.2241C537.3 93.9401 529.555 94.3988 523.426 93.2369C520.394 93.5215 517.815 94.2481 514.148 93.9049Z",
    fill: "#72969B"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.025 93.9049C320.043 93.2604 320.832 93.3876 321.35 93.2369C321.327 93.8815 320.537 93.7542 320.025 93.9049Z",
    fill: "#72969B"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.671 93.9048C322.561 92.4646 325.018 93.6035 325.982 93.237C326.092 94.6772 323.63 93.5391 322.671 93.9048Z",
    fill: "#72969B"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.654 93.9049C326.672 93.2604 327.455 93.3876 327.973 93.2369C327.955 93.8815 327.166 93.7542 326.654 93.9049Z",
    fill: "#72969B"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.984 93.9049C434.001 93.2604 434.791 93.3876 435.308 93.2369C435.285 93.8815 434.489 93.7542 433.984 93.9049Z",
    fill: "#72969B"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.525 93.9049C507.543 93.2604 508.333 93.3876 508.85 93.2369C508.827 93.8815 508.043 93.7542 507.525 93.9049Z",
    fill: "#72969B"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.174 93.9047C510.279 93.1265 511.383 93.3474 512.161 93.2369C512.062 94.0152 510.953 93.801 510.174 93.9047Z",
    fill: "#72969B"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.555 94.5619C555.777 94.4573 554.673 94.6782 554.568 93.905C555.347 94.0096 556.45 93.7828 556.555 94.5619Z",
    fill: "#72969B"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.438 95.8863C252.456 95.2418 253.252 95.3749 253.763 95.2242C253.745 95.8813 252.956 95.7356 252.438 95.8863Z",
    fill: "#72969B"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.258 96.5546C174.12 94.5689 171.507 97.1869 174.258 96.5546Z",
    fill: "#72969B"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.283 96.5551C223.782 95.6653 229.76 94.8935 229.25 97.2172C226.583 97.6709 225.468 96.5835 223.283 96.5551Z",
    fill: "#72969B"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.58 96.5549C283.783 95.6544 285.241 95.9967 286.228 95.8862C286.026 96.7867 284.573 96.4444 283.58 96.5549Z",
    fill: "#72969B"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.658 96.555C377.688 95.9105 378.478 96.0377 378.988 95.8862C378.977 96.5308 378.175 96.4035 377.658 96.555Z",
    fill: "#72969B"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.313 96.5551C380.603 95.0735 383.578 96.2822 384.949 95.8862C384.665 97.3737 381.69 96.1591 380.313 96.5551Z",
    fill: "#72969B"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.618 96.5549C385.722 95.7766 386.826 95.9967 387.598 95.8862C387.5 96.6645 386.39 96.4503 385.618 96.5549Z",
    fill: "#72969B"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.897 96.5552C392.124 94.5387 389.394 97.27 392.897 96.5552Z",
    fill: "#72969B"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.483 96.555C460.314 97.9262 457.566 96.735 457.176 97.8793C454.684 96.961 453.464 98.6293 451.21 97.2172H445.905C443.017 97.2289 445.795 96.0729 447.229 96.555C450.553 96.1189 455.608 97.4206 457.838 95.8862C458.419 96.4035 459.326 96.6011 460.483 96.555Z",
    fill: "#72969B"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.259 96.5551C174.66 96.5952 175.037 96.6537 174.916 97.2166C174.515 97.1757 174.138 97.118 174.259 96.5551Z",
    fill: "#72969B"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.575 97.2172C231.01 97.6521 230.291 96.9387 230.575 97.2172Z",
    fill: "#72969B"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.905 97.2172C231.917 96.5659 232.706 96.7057 233.224 96.5551C233.206 97.1996 232.41 97.0665 231.905 97.2172Z",
    fill: "#72969B"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.206 96.5552C235.776 96.4329 235.839 96.8105 235.874 97.2173C236.467 97.5077 237.066 97.7982 237.205 98.5365C243.909 100.157 249.626 98.0368 256.412 97.8794H259.729C261.501 99.053 255.848 98.3615 254.425 98.5365C248.202 100.222 241.341 101.105 233.887 99.8607C234.172 98.606 235.316 98.205 235.206 96.5552Z",
    fill: "#72969B"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.279 97.217C278.384 96.4446 279.488 96.6538 280.266 96.5551C280.156 97.3275 279.058 97.1124 278.279 97.217Z",
    fill: "#72969B"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.93 97.217C281.04 96.4446 282.138 96.6538 282.916 96.5551C282.812 97.3275 281.708 97.1124 280.93 97.217Z",
    fill: "#72969B"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.558 97.2172C287.987 97.6521 287.274 96.9387 287.558 97.2172Z",
    fill: "#72969B"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.896 96.5551H406.155C401.705 98.2216 396.76 97.891 392.896 96.5551Z",
    fill: "#72969B"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.109 97.2172C414.538 97.6521 413.83 96.9387 414.109 97.2172Z",
    fill: "#72969B"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.271 97.217C441.38 96.4446 442.479 96.6538 443.251 96.5551C443.153 97.3275 442.049 97.1124 441.271 97.217Z",
    fill: "#72969B"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.118 96.555C463.666 98.576 460.878 95.7876 465.118 96.555Z",
    fill: "#72969B"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.961 97.8793C483.926 99.1634 475.141 96.4739 466.444 97.2172C471.434 95.3815 483.862 97.4206 490.961 97.8793Z",
    fill: "#72969B"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.351 97.2171C264.894 99.2439 262.106 96.4506 266.351 97.2171Z",
    fill: "#72969B"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.671 97.8794C267.695 97.2349 268.491 97.3562 269.001 97.2173C268.984 97.856 268.195 97.7287 267.671 97.8794Z",
    fill: "#72969B"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.321 97.2171C431.858 99.2439 429.069 96.4506 433.321 97.2171Z",
    fill: "#72969B"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.646 97.8792C434.75 97.101 435.848 97.3219 436.632 97.2173C436.522 97.9955 435.424 97.7746 434.646 97.8792Z",
    fill: "#72969B"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.591 98.5361C173.591 98.1756 174.131 97.7934 174.259 98.5361H173.591Z",
    fill: "#72969B"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.427 97.8793C203.159 97.6934 204.275 98.112 204.077 99.8606C203.513 98.4376 199.841 100.117 199.435 98.5364C200.219 98.4376 201.312 98.6527 201.427 97.8793Z",
    fill: "#72969B"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.625 98.5365C494.506 97.0081 500.229 98.3038 504.215 97.8794C501.333 99.4129 495.611 98.1063 491.625 98.5365Z",
    fill: "#72969B"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.5 98.5364C511.941 98.9714 511.227 98.2638 511.5 98.5364Z",
    fill: "#72969B"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.701 98.5365C530.475 99.71 528.744 98.4318 525.421 99.2044C526.717 97.6994 529.918 97.4491 532.701 98.5365Z",
    fill: "#72969B"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.701 98.5362C532.59 97.1019 535.053 98.2341 536.017 97.8793C535.192 99.7036 534.089 98.9019 532.701 98.5362Z",
    fill: "#72969B"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.68 97.8793C542.077 97.7747 547.486 97.6709 551.256 99.2044C548.676 101.418 537.603 101.633 536.68 97.8793Z",
    fill: "#72969B"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.459 99.2042C195.558 98.4259 196.667 98.646 197.446 98.5364C197.341 99.3146 196.237 99.0996 195.459 99.2042Z",
    fill: "#72969B"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.732 99.2043C205.656 97.6934 209.351 98.9608 211.356 98.5364C210.014 100.953 207.399 99.0938 204.732 99.2043Z",
    fill: "#72969B"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.02 99.2042C212.13 98.4259 213.234 98.646 214.017 98.5364C213.907 99.3146 212.809 99.0996 212.02 99.2042Z",
    fill: "#72969B"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.674 99.2044C216.405 97.3101 223.94 100.535 215.999 99.2044C216.144 99.2279 213.936 100.005 214.674 99.2044Z",
    fill: "#72969B"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.929 99.2044C278.919 101.656 278.699 97.1879 280.929 99.2044Z",
    fill: "#72969B"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.539 98.5364C288.761 100.499 285.931 99.535 282.259 99.8607C283.153 97.891 286.831 98.6988 289.539 98.5364Z",
    fill: "#72969B"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.492 99.2043C513.922 99.6334 513.208 98.9258 513.492 99.2043Z",
    fill: "#72969B"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.48 99.8606C193.91 100.301 193.195 99.5879 193.48 99.8606Z",
    fill: "#72969B"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.905 99.8606C232.672 102.486 232.672 97.2464 231.905 99.8606Z",
    fill: "#72969B"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.52 99.8606C293.956 100.301 293.242 99.5879 293.52 99.8606Z",
    fill: "#72969B"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.836 99.8607C296.632 98.3389 301.233 99.6339 304.115 99.2045C301.077 100.906 298.799 99.8431 294.836 99.8607Z",
    fill: "#72969B"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.726 99.8607C314.738 99.222 315.527 99.356 316.045 99.2045C316.028 99.849 315.238 99.7159 314.726 99.8607Z",
    fill: "#72969B"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.707 99.8607C316.73 99.222 317.527 99.356 318.031 99.2045C318.02 99.849 317.224 99.7159 316.707 99.8607Z",
    fill: "#72969B"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.575 99.8606C229.116 101.893 226.335 99.0999 230.575 99.8606Z",
    fill: "#72969B"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.373 100.529C262.814 100.964 262.106 100.25 262.373 100.529Z",
    fill: "#72969B"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.673 100.529C322.691 99.89 323.487 100.017 323.998 99.8607C323.981 100.512 323.185 100.384 322.673 100.529Z",
    fill: "#72969B"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.328 100.529C325.752 100.964 325.044 100.25 325.328 100.529Z",
    fill: "#72969B"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.412 100.529C364.847 100.964 364.133 100.25 364.412 100.529Z",
    fill: "#72969B"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.988 100.529C379.005 99.89 379.801 100.017 380.313 99.8607C380.301 100.512 379.499 100.384 378.988 100.529Z",
    fill: "#72969B"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.861 99.8607C455.737 99.3209 455.581 100.801 457.177 100.528C457.282 101.609 452.838 101.859 453.861 99.8607Z",
    fill: "#72969B"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.645 101.191C274.08 101.626 273.366 100.913 273.645 101.191Z",
    fill: "#72969B"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.266 101.191C388.696 101.626 387.988 100.913 388.266 101.191Z",
    fill: "#72969B"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.309 101.191C435.42 100.413 436.518 100.633 437.296 100.529C437.191 101.301 436.087 101.087 435.309 101.191Z",
    fill: "#72969B"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.548 101.191C450.652 100.413 451.756 100.633 452.534 100.529C452.43 101.301 451.325 101.087 450.548 101.191Z",
    fill: "#72969B"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.092 101.854C255.191 101.075 256.3 101.295 257.073 101.192C256.968 101.97 255.864 101.749 255.092 101.854Z",
    fill: "#72969B"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.415 101.854C417.851 102.283 417.142 101.575 417.415 101.854Z",
    fill: "#72969B"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.745 101.854C418.849 101.075 419.954 101.295 420.731 101.192C420.627 101.97 419.523 101.749 418.745 101.854Z",
    fill: "#72969B"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.341 101.854C429.776 102.283 429.063 101.575 429.341 101.854Z",
    fill: "#72969B"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.249 101.854C445.679 102.283 444.965 101.575 445.249 101.854Z",
    fill: "#72969B"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.23 101.192C450.135 101.61 451.076 103.974 455.185 103.184C452.942 105.978 448.044 102.969 443.919 104.509C445.25 103.051 449.148 104.167 447.23 101.192Z",
    fill: "#72969B"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.839 101.854C457.851 101.209 458.647 101.336 459.158 101.192C459.14 101.83 458.344 101.709 457.839 101.854Z",
    fill: "#72969B"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.145 101.854C461.255 101.075 462.353 101.295 463.138 101.192C463.027 101.97 461.929 101.749 461.145 101.854Z",
    fill: "#72969B"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.801 101.854C463.905 101.075 465.009 101.295 465.787 101.192C465.677 101.97 464.579 101.749 463.801 101.854Z",
    fill: "#72969B"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.099 101.853C468.686 100.895 468.298 101.923 469.099 101.853Z",
    fill: "#72969B"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.397 101.192C473.839 102.173 472.265 102.15 471.086 102.515C470.407 100.291 473.148 101.488 474.397 101.192Z",
    fill: "#72969B"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.999 101.854C482.785 103.597 479.334 100.913 475.721 101.854C475.256 100.442 483.087 101.314 484.999 101.854Z",
    fill: "#72969B"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.247 102.516C176.265 101.871 177.061 102.004 177.572 101.854C177.549 102.498 176.759 102.365 176.247 102.516Z",
    fill: "#72969B"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.732 102.516C206.736 100.988 211.564 102.278 214.673 101.854C212.662 103.381 207.835 102.086 204.732 102.516Z",
    fill: "#72969B"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.336 102.516C216.474 100.999 220.397 102.278 222.622 101.854C221.489 103.37 217.568 102.091 215.336 102.516Z",
    fill: "#72969B"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.1 101.854C469.895 101.784 469.506 102.817 469.1 101.854Z",
    fill: "#72969B"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.663 102.516C486.366 101.017 489.829 102.265 491.624 101.854C490.921 103.358 487.464 102.104 485.663 102.516Z",
    fill: "#72969B"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.272 102.516C494.36 101.052 497.084 102.237 498.252 101.854C498.165 103.318 495.44 102.133 494.272 102.516Z",
    fill: "#72969B"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.902 102.516C501.605 101.017 505.068 102.265 506.864 101.854C506.161 103.358 502.705 102.104 500.902 102.516Z",
    fill: "#72969B"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.852 102.516C508.869 101.871 509.665 102.004 510.176 101.854C510.158 102.498 509.375 102.365 508.852 102.516Z",
    fill: "#72969B"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.536 102.516C235.085 104.543 232.296 101.749 236.536 102.516Z",
    fill: "#72969B"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.605 102.516C278.39 104.393 274.631 103.725 272.319 104.509C273.323 102.417 277.147 103.144 279.605 102.516Z",
    fill: "#72969B"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.259 103.184C282.358 102.405 283.461 102.62 284.24 102.516C284.13 103.294 283.032 103.074 282.259 103.184Z",
    fill: "#72969B"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.172 103.184C347.685 104.822 332.057 103.468 340.562 103.184H345.861C347.906 102.719 347.133 102.719 349.172 103.184Z",
    fill: "#72969B"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.637 103.184C378.749 102.749 374.153 104.043 372.358 102.516C375.245 102.94 379.847 101.656 381.637 103.184Z",
    fill: "#72969B"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.637 103.184C384.541 102.405 385.041 103.358 387.597 102.516C387.859 105.2 383.472 103.242 381.637 103.846V103.184Z",
    fill: "#72969B"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.021 103.846C265.726 105.159 253.954 105.415 260.392 104.509C262.756 104.218 263.924 102.737 267.021 103.184V103.846Z",
    fill: "#72969B"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.67 103.845C272.417 104.467 269.798 101.861 269.67 103.845Z",
    fill: "#72969B"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.489 103.846C352.919 104.276 352.205 103.561 352.489 103.846Z",
    fill: "#72969B"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.266 103.846C388.37 103.073 389.474 103.283 390.252 103.184C390.142 103.956 389.044 103.736 388.266 103.846Z",
    fill: "#72969B"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.897 103.846C395.176 102.358 398.156 103.573 399.528 103.184C399.249 104.66 396.269 103.446 394.897 103.846Z",
    fill: "#72969B"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.141 103.846C408.24 103.654 409.571 102.621 410.122 103.184C410.587 103.637 407.515 105.002 408.141 103.846Z",
    fill: "#72969B"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.271 103.845C444.016 104.467 441.398 101.861 441.271 103.845Z",
    fill: "#72969B"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.808 103.846C461.106 105.345 457.642 104.096 455.848 104.509C456.852 103.283 460.316 102.539 461.808 103.846Z",
    fill: "#72969B"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.021 103.846C267.817 103.776 267.422 104.804 267.021 103.846Z",
    fill: "#72969B"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.669 103.846C269.531 105.831 266.918 103.208 269.669 103.846Z",
    fill: "#72969B"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.745 104.509C418.849 103.725 419.954 103.945 420.731 103.846C420.627 104.618 419.523 104.398 418.745 104.509Z",
    fill: "#72969B"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.057 104.509C422.161 103.725 423.258 103.945 424.043 103.846C423.933 104.618 422.835 104.398 422.057 104.509Z",
    fill: "#72969B"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.711 104.509C426.93 102.969 431.98 104.27 435.309 103.846C433.078 105.368 428.029 104.073 424.711 104.509Z",
    fill: "#72969B"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.271 103.846C439.818 105.868 437.03 103.073 441.271 103.846Z",
    fill: "#72969B"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.451 104.509C244.24 105.862 238.581 107.198 232.557 105.833C237.895 104.752 244.466 104.921 250.451 104.509Z",
    fill: "#72969B"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.112 105.165C251.553 105.601 250.84 104.887 251.112 105.165Z",
    fill: "#72969B"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.092 104.509C253.634 106.524 250.841 103.742 255.092 104.509Z",
    fill: "#72969B"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.411 105.165C256.852 105.601 256.139 104.887 256.411 105.165Z",
    fill: "#72969B"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.067 107.152H467.768C469.656 106.164 470.295 103.939 473.735 104.508C474.141 106.628 471.358 105.414 473.067 107.152Z",
    fill: "#72969B"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.346 105.165C482.787 105.601 482.073 104.887 482.346 105.165Z",
    fill: "#72969B"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.648 105.833C218.248 104.863 217.847 105.902 218.648 105.833Z",
    fill: "#72969B"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.648 105.833C219.42 105.27 220.42 104.956 221.964 105.165C222.644 107.389 219.897 106.199 218.648 106.484V105.833Z",
    fill: "#72969B"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.945 105.833C224.38 106.263 223.666 105.555 223.945 105.833Z",
    fill: "#72969B"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.277 105.833C225.294 105.188 226.085 105.316 226.602 105.165C226.578 105.81 225.788 105.682 225.277 105.833Z",
    fill: "#72969B"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.726 105.165C308.01 107.716 300.241 105.188 292.195 106.484C299.533 104.451 306.522 105.566 314.726 105.165Z",
    fill: "#72969B"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.377 105.833C315.818 106.263 315.109 105.555 315.377 105.833Z",
    fill: "#72969B"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.707 105.833C318.491 104.3 323.098 105.595 325.986 105.165C324.196 106.699 319.589 105.404 316.707 105.833Z",
    fill: "#72969B"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.359 105.165C373.961 104.892 373.799 106.374 375.675 105.833C375.791 106.907 371.342 107.158 372.359 105.165Z",
    fill: "#72969B"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.324 105.165C383.698 106.467 386.057 104.788 390.914 105.833C387.649 106.896 375.07 107.117 378.324 105.165Z",
    fill: "#72969B"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.246 105.833C392.338 104.178 394.482 105.629 394.894 105.833C394.79 107.47 392.646 106.025 392.246 105.833Z",
    fill: "#72969B"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.067 105.833C527.109 106.57 526.441 106.548 526.07 105.165C526.86 105.27 527.952 105.049 528.067 105.833Z",
    fill: "#72969B"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.348 106.483C213.452 105.711 214.556 105.931 215.334 105.832C215.23 106.605 214.133 106.385 213.348 106.483Z",
    fill: "#72969B"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.379 106.484C370.808 106.93 370.094 106.211 370.379 106.484Z",
    fill: "#72969B"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.518 106.484C401.53 105.851 402.326 105.978 402.843 105.832C402.82 106.477 402.024 106.344 401.518 106.484Z",
    fill: "#72969B"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.454 105.833C411.471 108.419 408.119 105.944 408.142 107.152C405.719 105.728 410.065 105.619 411.454 105.833Z",
    fill: "#72969B"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.445 106.484C461.518 105.036 460.567 108.773 466.445 106.484Z",
    fill: "#72969B"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.337 107.151C431.772 107.586 431.059 106.879 431.337 107.151Z",
    fill: "#72969B"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.646 107.152C435.134 105.972 435.848 107.059 436.633 107.152C438.585 107.268 447.23 106.745 443.918 107.814C440.898 107.529 436.627 108.477 434.646 107.152Z",
    fill: "#72969B"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.954 107.151C274.596 109.981 268.541 106.617 265.032 109.139C266.648 105.345 274.294 108.337 276.954 107.151Z",
    fill: "#72969B"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.576 107.814C446.587 107.169 447.383 107.302 447.9 107.152C447.877 107.803 447.081 107.675 446.576 107.814Z",
    fill: "#72969B"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.554 107.813C448.659 107.041 449.768 107.256 450.547 107.152C450.436 107.936 449.338 107.715 448.554 107.813Z",
    fill: "#72969B"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.21 107.814C451.645 108.255 450.926 107.541 451.21 107.814Z",
    fill: "#72969B"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.185 107.814C455.203 107.169 455.999 107.302 456.509 107.152C456.492 107.803 455.702 107.675 455.185 107.814Z",
    fill: "#72969B"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.482 107.151C458.345 109.178 455.534 106.362 460.482 107.151Z",
    fill: "#72969B"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.068 107.152C473.875 107.088 473.481 108.115 473.068 107.152Z",
    fill: "#72969B"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.373 107.814C479.082 106.315 482.539 107.563 484.34 107.151C483.637 108.656 480.174 107.408 478.373 107.814Z",
    fill: "#72969B"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.113 107.814C249.695 110.149 244.554 108.773 241.178 109.139C243.455 107.675 248.597 109.052 251.113 107.814Z",
    fill: "#72969B"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.1 108.477C253.118 107.832 253.914 107.965 254.424 107.814C254.407 108.465 253.611 108.325 253.1 108.477Z",
    fill: "#72969B"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.927 108.476C280.818 107.041 283.28 108.174 284.239 107.814C284.355 109.254 281.891 108.116 280.927 108.476Z",
    fill: "#72969B"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.203 109.8C236.228 109.789 235.095 112.6 235.206 109.8C236.105 108.964 236.536 107.797 237.203 109.8Z",
    fill: "#72969B"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.132 111.794C245.53 113.316 238.645 111.869 236.536 113.113C237.094 112.346 237.413 111.341 237.204 109.801C240.503 107.715 243.688 111.741 249.132 111.794Z",
    fill: "#72969B"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.499 109.801C507.305 111.834 504.434 108.97 511.499 109.801Z",
    fill: "#72969B"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.618 111.126C277.636 110.487 278.432 110.614 278.942 110.469C278.925 111.107 278.135 110.974 277.618 111.126Z",
    fill: "#72969B"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.313 111.126C380.748 111.561 380.035 110.859 380.313 111.126Z",
    fill: "#72969B"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.712 111.794C418.356 112.044 411.181 111.137 402.844 111.126C398.126 111.12 390.684 113.81 385.618 111.794C386.402 112.108 396.638 111.16 397.546 111.126C406.551 110.824 417.414 109.202 424.712 111.794Z",
    fill: "#72969B"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.1 111.126C469.123 110.487 469.907 110.614 470.425 110.469C470.407 111.107 469.617 110.974 469.1 111.126Z",
    fill: "#72969B"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.132 111.794C249.022 110.707 253.21 110.707 253.101 111.794H249.132Z",
    fill: "#72969B"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.717 111.794C261.74 111.149 262.525 111.277 263.042 111.126C263.024 111.77 262.234 111.643 261.717 111.794Z",
    fill: "#72969B"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.02 111.794C265.557 109.767 262.775 112.56 267.02 111.794Z",
    fill: "#72969B"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.021 111.794C270.194 111.027 271.496 111.55 275.632 111.126C273.796 112.607 270.386 112.497 267.021 112.45V111.794Z",
    fill: "#72969B"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.267 111.794C280.377 111.015 281.475 111.23 282.26 111.126C282.149 111.904 281.051 111.695 280.267 111.794Z",
    fill: "#72969B"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.76 111.794C303.717 113.031 292.202 113.932 286.892 111.794C290.279 111.347 301.388 112.084 308.76 111.794Z",
    fill: "#72969B"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.426 111.126C316.084 112.195 324.642 111.369 330.621 113.113C325.531 113.125 313.475 114.368 309.426 111.126Z",
    fill: "#72969B"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.821 111.126C350.432 113.414 339.422 112.671 339.237 111.794C343.391 110.521 346.465 111.922 351.821 111.126Z",
    fill: "#72969B"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.099 111.794C361.21 111.015 362.308 111.23 363.08 111.126C362.981 111.904 361.878 111.695 361.099 111.794Z",
    fill: "#72969B"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.761 112.45C253.652 111.016 256.114 112.154 257.073 111.794C257.189 113.234 254.725 112.096 253.761 112.45Z",
    fill: "#72969B"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.391 111.794C258.939 113.815 256.145 111.027 260.391 111.794Z",
    fill: "#72969B"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.228 112.45C286.048 113.989 284.463 113.978 283.58 113.113C284.16 111.19 284.573 112.375 286.228 112.45Z",
    fill: "#72969B"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.476 112.45C354.563 110.992 357.289 112.177 358.45 111.794C358.363 113.252 355.638 112.078 354.476 112.45Z",
    fill: "#72969B"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.732 113.113C204.75 112.468 205.546 112.602 206.057 112.45C206.039 113.095 205.249 112.967 204.732 113.113Z",
    fill: "#72969B"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0715 280.745C95.2227 278.497 90.0053 279.386 90.1099 282.064C88.7614 278.451 84.0445 279.235 80.8369 280.745C81.1332 284.969 88.5295 281.379 90.1099 282.732C88.9999 284.498 83.9985 282.361 82.8241 284.062C85.3051 286.95 91.2776 284.022 94.0893 285.387C88.2039 288.118 77.5832 286.108 70.2347 287.375C71.6342 284.807 77.7699 286.95 80.1698 285.387C80.1639 281.75 72.437 284.179 74.8711 280.083C71.3446 278.932 70.2581 282.436 68.2475 280.745C69.4788 276.869 75.1206 281.472 76.8634 278.096C78.2755 274.691 73.4883 277.491 74.2032 274.784C78.5668 274.743 74.1571 273.029 74.2032 271.466C77.1086 270.967 78.252 271.664 81.4999 270.81C81.6572 267.289 79.0372 270.665 77.5263 268.817C77.6251 267.597 79.7629 268.416 80.1698 267.493C75.9744 266.011 81.4245 262.938 78.1826 259.545C81.4823 258.97 83.6444 259.301 86.1364 258.221C85.1545 255.728 79.1887 256.745 78.8447 255.571C78.2345 253.276 82.5629 253.189 78.1826 252.259C82.4641 249.471 82.5227 253.962 84.8121 254.24C86.323 252.893 82.9471 252.567 85.4742 250.929C84.7309 248.576 79.7579 250.469 78.1826 248.948C79.6926 247.914 79.4382 247.565 78.8447 245.63C81.1165 245.131 79.6935 248.32 82.1628 247.617C81.5057 246.397 84.0973 243.998 80.1698 243.637C81.1106 240.82 85.2131 244.172 85.4742 241.656C82.7847 239.257 79.4725 241.766 75.5333 240.326C75.4228 238.891 77.8862 240.029 78.8447 239.663C78.2579 237.734 78.0026 237.38 79.5076 236.351C77.7875 233.864 75.0277 236.589 75.5333 233.04C73.9236 234.318 69.9961 233.673 68.2475 233.04C51.5439 231.378 76.4683 234.69 76.8634 230.39C75.324 227.694 75.0854 227.782 73.5519 225.085C75.0854 223.488 75.324 226.12 76.8634 226.416C78.7049 228.438 76.0732 231.053 80.1698 231.053C79.0021 227.52 79.1008 221.617 73.5519 220.45C75.504 217.667 73.2096 217.719 74.8711 213.832C77.1362 214.768 78.7459 214.373 77.5263 211.84C79.4892 211.805 80.8838 213.78 82.1628 212.502C80.1346 208.505 80.3966 206.791 76.8634 204.548C76.3871 206.587 76.6658 208.371 78.8447 209.852C78.7225 210.387 78.1826 210.515 78.1826 211.178C76.5905 211.445 76.7411 209.969 74.8711 210.515C75.812 208.487 73.8131 204.967 72.884 201.242C76.2891 202.648 73.4883 197.861 76.2012 198.592C71.9774 194.851 73.4004 191.609 70.9026 189.308C73.3485 187.351 72.5985 185.154 74.2023 183.354C71.6459 182.593 69.7056 181.227 66.2603 181.361C69.7517 178.898 79.3503 180.489 82.162 179.374C79.0305 175.103 72.5115 177.451 68.2466 177.387C49.2712 177.096 29.0469 177.538 7.28999 178.705C21.0304 184.434 44.4497 178.13 62.943 182.686C41.8071 181.779 21.5711 182.795 6.62787 182.028C9.17254 185.596 11.3163 189.646 17.8872 190.639C17.3523 191.208 16.0741 191.028 15.9 191.964C20.4955 194.805 31.4761 194.293 37.7683 193.282H45.0541C44.351 194.781 40.8939 193.538 39.0925 193.945C31.482 196.025 27.1644 194.189 17.8872 194.607C22.4015 199.929 32.3249 196.263 40.4176 197.268C43.6244 197.61 51.7582 196.506 51.6828 197.924H38.4363C33.8634 198.924 26.4269 198.924 21.8725 197.924C23.9986 205.779 40.3013 200.55 47.7084 201.242C42.3462 203.78 31.6444 202.409 26.509 203.223C28.3329 207.993 38.4832 203.874 45.0541 205.21C42.7061 208.609 33.2657 204.908 29.8145 207.203C31.5749 211.183 36.9028 211.595 43.0669 211.178C40.1682 211.125 32.5626 214.477 41.0856 214.483C40.8998 219.932 60.0434 214.029 63.6043 217.132C55.8079 216.628 49.9049 218.01 42.404 217.8C43.38 223.186 54.7448 219.596 58.9736 219.793C57.7716 223.453 48.2952 218.835 47.0396 222.431C49.3524 224.336 54.4878 223.389 57.6427 224.429C56.0213 226.44 53.3318 223.924 51.0132 224.429C51.4669 226.713 55.3885 228.025 53.0062 231.053C53.9061 232.831 62.5521 230.297 60.292 233.04C60.1639 232.29 59.6299 232.673 59.6349 233.04C56.9973 233.621 56.3001 233.621 53.6683 233.04C52.1809 235.468 51.2341 234.492 50.3569 237.019C55.3123 237.856 66.7232 236.677 70.2321 238.339H66.9199C60.0292 238.734 51.1873 237.182 47.0388 240.326C54.1681 242.144 63.3532 240.302 70.9001 240.326C63.9224 243.544 49.4035 240.372 44.3953 243.637C45.6735 246.338 51.6175 244.37 54.9926 244.967C58.1935 246.292 48.1596 244.962 47.0379 246.292C45.2081 246.96 50.0765 247.437 47.7059 248.948H43.0644C41.1358 247.077 45.0516 248.122 44.3945 245.63C41.6464 245.816 39.1654 247.147 38.4338 250.929C42.6342 252.468 49.6873 251.15 54.9917 251.597C51.3664 255.03 40.508 251.242 35.7786 253.578C39.5722 257.401 48.5196 252.533 53.0045 254.903C46.4277 257.599 34.2677 252.695 31.8042 258.221C38.0847 259.313 46.945 257.61 56.3218 258.221C60.0986 257.756 60.0986 259.347 56.3218 258.877H49.0302C43.6504 260.986 35.5685 257.93 30.4733 259.545C26.0921 260.933 25.6568 265.564 22.5254 268.155C25.3547 269.955 37.2652 267.26 43.7315 268.155C48.5011 268.817 42.4885 269.405 39.7513 269.485C36.2767 269.584 27.0162 269.333 20.5441 270.142C19.7832 271.478 14.5599 276.033 19.8761 275.441C13.3922 276.614 11.667 278.683 9.26713 283.394C15.1291 283.679 25.5346 281.68 31.8034 282.064H35.7778C37.8805 282.622 34.6042 282.942 33.7847 282.732C24.7034 283.609 16.645 283.737 7.2858 285.387C9.77272 288.089 18.2137 286.474 21.8683 286.05C17.1272 290.947 4.44481 283.848 2.64931 291.348C29.2763 287.787 64.6171 292.644 94.7414 290.024C96.1242 287.241 93.7478 283.238 96.0664 281.414C96.2288 282.576 97.2107 282.925 98.7208 282.733C95.6764 285.794 98.8195 288.572 98.7208 293.336C67.3242 295.184 30.9144 291.977 0 293.993C1.26648 285.331 9.45798 283.588 11.9282 276.11C12.823 275.902 13.1888 275.164 14.5716 275.442C25.4359 259.582 40.3557 247.776 50.3552 231.055C38.4388 217.791 22.2935 208.757 13.2482 192.629C5.05 190.59 0.640354 181.892 3.3131 176.059C31.2183 174.921 57.2577 173.503 81.4965 174.073C81.5024 162.522 79.8525 149.462 80.1664 135.647C82.2114 134.311 84.1458 130.801 86.133 130.347C97.4392 127.721 107.322 129.627 121.255 128.355C132.915 127.297 147.614 126.525 158.35 127.693C165.973 128.529 173.118 127.588 181.549 127.036C187.511 126.641 192.373 128.407 198.107 129.023C221.457 131.515 246.428 130.691 267.669 131.01C287.01 131.301 306.525 127.251 325.326 128.355C327.783 128.507 330.154 130.179 332.6 130.347C336.654 130.615 341.884 129.836 345.858 129.679C356.623 129.261 367.645 129.784 379.649 130.347C391.396 130.888 403.301 129.063 415.425 128.355C494.742 123.76 583.121 125.868 665.883 121.069C668.491 124.828 677.816 126.902 677.811 132.335C677.759 151.321 677.637 176.403 678.468 192.63C703.345 187.988 740.482 191.235 771.222 193.949C779.756 194.704 789.453 191.782 797.059 195.941C793.352 202.605 782.917 202.553 781.163 211.181C776.765 210.007 774.36 216.212 769.898 217.136C760.404 225.973 748.558 232.462 738.094 240.329C742.777 247.394 749.847 250.206 755.988 254.906C761.949 259.472 765.732 266.316 771.221 270.813C776.59 275.205 784.985 276.849 787.791 284.066C780.197 289.091 764.179 287.546 750.683 288.034C724.608 288.981 690.62 286.913 665.882 286.715C667.189 280.266 668.084 274.259 667.202 268.821C653.287 268.717 641.725 269.682 628.775 270.814C617.945 271.761 607.115 269.204 596.309 269.489C592.016 269.6 587.897 271.075 583.719 270.814C580.332 270.599 577.2 268.752 573.778 268.821C566.864 268.961 559.835 271.825 552.583 272.138C489.181 274.887 426.155 273.754 365.07 274.12C363.577 271.86 362.473 269.204 362.426 265.51C359.243 266.527 359.812 271.29 357.121 272.801C336.084 277.467 314.588 275.34 290.866 276.113C288.513 275.079 290.465 278.361 288.874 278.1C264.333 276.479 241.419 275.09 219.312 274.789C205.118 274.591 190.362 280.046 176.244 274.789C151.046 276.949 117.658 275.654 96.7361 278.768C96.7645 279.674 96.4222 280.22 96.0681 280.749L96.0715 280.745ZM192.149 135.643C184.898 136.916 167.811 133.145 161.664 137.631C162.837 137.781 164.987 136.968 164.319 138.961C161.78 136.671 159.712 140.465 159.014 139.623C160.264 136.357 161.182 135.725 162.332 131.669C158.573 131.728 156.312 130.571 153.054 132.331C152.705 131.797 152.362 131.256 152.391 130.344C149.324 131.547 148.237 131.408 144.443 131.007C143.833 133.267 142.892 135.201 141.794 136.968C142.827 138.769 145.482 135.074 146.424 136.968C144.304 140.233 141.08 139.065 137.814 138.293C141.962 136.997 141.213 134.719 142.451 131.007H137.814C138.435 134.719 136.123 135.498 135.827 138.293C134.403 138.862 133.479 139.925 133.84 142.272C137.965 143.254 141.974 139.577 145.099 143.591H144.442C144.337 144.37 143.233 144.155 142.45 144.253C141.409 146.845 144.175 145.63 144.442 146.909C141.508 146.183 141.148 148.03 139.143 148.24C137.116 146.351 141.769 144.87 138.475 144.253C136.686 147.6 135.146 145.759 134.495 150.883C145.767 151.667 160.82 149.03 172.927 150.883C167.152 150.18 159.054 151.743 151.065 152.213C143.459 152.649 134.483 149.668 132.514 154.2C136.291 155.967 144.047 152.504 148.416 154.862C143.658 155.055 141.693 154.612 138.475 156.838C128.133 158.116 119.813 154.775 114.625 160.161C123.293 159.074 132.229 162.293 137.155 160.161C135.935 163.182 143.941 160.823 145.097 163.478C135.36 163.374 125.047 165.378 118.604 163.478C118.227 169.271 138.655 163.832 143.779 166.784C134.64 169.119 122.01 165.019 116.612 170.107C125.53 172.321 142.292 166.539 147.09 170.758C136.482 172.072 121.974 169.509 115.287 174.733C123.357 175.505 130.851 172.2 137.812 174.071C136.847 174.367 137.882 174.657 137.812 175.401C126.744 176.151 112.661 174.384 109.326 179.375C115.856 181.338 128.859 178.132 135.825 178.706C130.969 183.029 118.18 179.439 112.632 181.361C114.52 184.308 110.662 182.669 110.651 185.336C115.67 186.847 126.872 182.902 129.864 187.985C128.923 187.932 127.987 187.88 127.871 188.647C128.836 189.014 131.299 187.88 131.189 189.31C130.061 190.257 125.791 189.81 127.871 191.965C134.645 194.26 146.573 190.083 152.388 193.284C138.84 194.713 126.901 194.161 113.3 195.939C118.517 200.779 125.756 194.451 131.851 197.926C143.651 195.712 162.602 197.845 174.914 197.27C156.961 200.819 132.164 196.81 113.3 201.895V201.243C111.65 201.139 110.087 201.11 109.983 202.562C105.463 198.844 97.3756 205.491 93.4188 200.575C94.2676 199.657 96.5503 200.169 97.399 199.245C97.4166 199.89 98.2127 199.768 98.7233 199.913C101.472 199.28 98.8572 201.895 98.7233 199.913C98.6998 199.275 97.9096 199.396 97.399 199.245C97.9163 198.664 98.1072 197.758 98.0612 196.602C97.5321 194.975 94.0064 198.484 94.0868 195.271C95.8471 195.266 97.8695 195.533 98.7233 194.609V191.297C98.2009 189.838 94.6158 191.425 95.406 188.647C96.3594 185.812 99.9379 189.688 100.71 186.666C96.5854 185.678 97.3296 180.926 98.0612 177.388C95.7082 176.353 97.6602 179.636 96.0689 179.375C95.7082 176.359 97.8812 175.878 98.7233 174.071C99.886 174.651 100.775 176.29 101.373 174.071C98.468 172.565 97.2484 169.37 94.0876 168.109C97.353 167.238 95.8371 163.304 94.7447 162.81H98.7241C99.1544 160.393 95.5701 161.991 95.4068 160.161C97.3823 160.132 100.711 162.124 101.374 159.493C99.0204 158.308 95.1339 158.674 94.0885 156.187C99.6256 157.273 101.682 157.052 107.329 156.187C105.249 153.88 109.398 153.27 107.329 151.544C104.755 152.869 106.76 155.233 102.036 154.862C102.617 153.688 104.25 152.805 102.036 152.212C101.949 153.27 99.3519 154.554 98.7241 154.199C99.8048 150.691 96.7143 151.341 95.4068 150.214C95.0929 148.134 96.2431 147.513 97.3999 146.908V148.239C98.8229 149.668 101.095 148.575 102.036 147.57C103.646 148.883 100.921 150.399 103.361 150.882C104.598 149.464 105.749 147.977 106.667 146.246C102.791 146.623 100.443 145.107 97.3999 146.908C95.7559 145.183 98.0452 143.66 97.4007 140.941C96.9998 139.803 94.2575 140.994 94.0885 139.622C95.4654 138.571 98.4864 139.163 100.05 138.292C101.078 135.939 97.8017 137.891 98.0628 136.305C100.41 134.469 105.418 135.271 108.66 134.318C109.357 136.845 105.999 136.351 107.997 138.292C112.059 137.478 109.223 133.47 113.302 132.33C120.89 136.287 129.651 132.354 135.164 132.33C131.457 127.363 126.258 131.883 120.587 132.33C109.055 133.237 95.5299 129.478 85.4726 133.65C79.7847 138.083 83.2476 170.205 85.4726 176.055C83.9968 183.027 85.054 190.289 86.7976 197.267C83.3581 199.254 88.3428 201.984 85.4726 204.547C85.7689 206.459 88.3253 206.116 88.7898 207.864C85.6299 207.957 88.8484 210.316 86.1347 210.514C85.8149 212.594 87.0755 213.105 87.4656 214.482C86.1464 214.947 85.6935 216.26 85.4726 217.8C85.3914 221.297 87.5878 225.022 87.4656 228.409C87.3786 230.68 86.873 233.027 87.4656 236.351C88.337 241.313 87.3668 246.303 88.1219 250.927C88.5463 253.559 90.5502 255.5 88.7898 258.219C88.5864 259.746 90.7017 258.956 90.7712 260.2C88.7438 262.182 88.9531 267.085 92.0962 268.154C88.4651 269.38 93.3744 272.285 92.0962 275.44C100.747 272.75 112.884 276.515 117.938 271.465C117.91 272.605 118.432 273.186 119.263 273.453C128.326 273.017 139.081 270.751 147.755 272.133C146.576 272.279 144.437 271.46 145.1 273.453C146.796 274.33 150.555 273.133 149.085 272.133C157.962 273.221 163.209 271.053 168.96 274.115C169.361 272.383 174.874 271.628 178.89 271.465C178.541 271.999 178.204 272.545 178.233 273.452C179.302 273.638 179.371 272.836 180.22 272.795C182.968 272.157 180.353 274.777 180.22 272.795C181.149 271.697 186.587 271.697 187.506 272.795C185.809 272.766 186.704 273.278 186.848 274.115H188.168C188.185 274.759 188.981 274.632 189.493 274.783C191.846 274.707 188.086 272.592 190.155 272.795C213.168 274.016 236.948 271.703 258.404 274.115C259.799 272.859 261.803 272.209 263.703 271.465C294.204 272.331 328.384 276.484 356.457 269.483C358.944 267.549 358.41 262.593 361.761 261.529C365.88 262.267 364.248 268.757 366.398 271.465C412.401 271.256 459.321 271.035 506.201 270.808C520.127 270.739 534.123 269.164 547.938 268.815C556.421 268.607 564.578 267.416 573.124 266.823C578.765 266.44 584.221 268.386 589.682 268.153C616.367 267.037 645.236 268.031 671.839 266.166C674 224.689 675.058 174.939 675.151 134.317C675.163 131.266 668.238 125.852 663.892 127.688C665.931 130.151 663.816 129.483 663.224 132.33C664.043 135.49 669.69 133.811 670.515 136.966C668.488 137.448 668.575 135.828 666.541 136.304C668.522 138.686 669.057 142.434 665.885 144.252C667.616 145.024 669.608 144.043 667.866 146.907C669.743 147.017 672.41 146.338 672.509 148.238C670.138 149.26 668.865 147.552 667.866 150.213C668.139 152.81 670.37 153.455 670.515 156.186C668.383 157.452 666.588 155.633 663.892 156.837C667.134 159.306 666.82 159.858 670.515 162.147C668.291 162.35 668.697 165.192 667.866 166.783C660.023 169.601 640.996 165.72 635.4 168.776C628.173 168.132 632.705 165.558 628.114 164.797C637.718 165.389 652.992 166.196 659.917 162.81C648.995 160.312 636.138 161.891 625.46 160.816C625.338 160.264 625.715 160.195 626.128 160.16C626.929 160.085 626.534 161.119 626.128 160.16C627.615 157.11 632.571 161.664 632.751 157.505C622.775 155.779 595.365 154.844 580.41 156.186C590.385 153.827 604.701 154.094 616.85 152.869C616.054 153.734 616.588 153.908 616.85 154.861C629.946 155.436 649.827 154.239 660.58 154.199C658.872 151.004 651.348 151.317 644.679 151.543C637.73 151.782 628.522 155.5 624.141 150.881C631.961 150.631 646.997 152.182 653.29 148.238C651.518 145.06 648.687 150.23 646.666 146.907C646.788 146.344 646.41 146.28 646.004 146.245C645.609 143.398 640.931 146.953 643.349 143.59C635.401 143.154 625.681 144.479 618.831 142.928C626.627 141.667 637.498 143.479 643.349 140.278C642.466 139.18 639.601 140.063 638.712 138.959C638.939 136.751 641.228 136.612 642.024 134.979C639.275 134.857 638.386 136.13 636.725 134.317C640.611 132.26 643.343 134.061 645.347 132.33C631.345 130.459 611.249 133.224 596.974 132.992C597.044 131.743 599.159 132.533 598.961 131.005C579.045 132.551 554.521 134.113 534.03 135.642C531.509 136.269 529.295 138.505 527.4 136.304C546.718 133.033 569.493 130.727 587.696 130.342C589.479 130.308 591.937 131.302 593.662 131.005C597.038 130.413 601.256 126.938 605.59 131.005C618.181 130.558 632.159 130.697 647.328 129.674C652.749 129.314 660.011 129.576 661.905 125.706C636.51 125.038 609.947 126.252 579.753 127.687C558.408 128.715 536.016 125.677 514.81 127.687C494.208 129.65 469.464 128.106 447.23 129.674C429.666 130.917 411.993 133.206 394.227 133.648C380.556 133.996 366.304 131.655 352.488 131.667C337.906 131.672 325.42 132.643 314.056 132.329C283.525 131.492 247.156 134.699 214.672 132.992C203.355 132.398 191.584 129.819 181.551 130.341C177.943 130.527 174.492 132.084 170.942 132.329C167.288 132.572 165.789 129.575 162.994 134.316C172.272 135.199 183.264 134.362 192.148 135.641L192.149 135.643ZM649.316 133.65C649.287 132.745 649.624 132.203 649.978 131.669C649.084 131.46 648.713 130.728 647.329 131.007C646.748 133.127 648.346 133.075 649.316 133.65ZM653.952 131.007H651.302C650.779 133.557 654.469 133.557 653.952 131.007ZM659.918 131.67C662.138 130.067 658.315 133.889 659.918 131.67ZM652.627 134.318C651.942 136.549 654.696 135.352 655.945 135.643C656.084 133.674 653.58 133.308 652.627 134.318ZM125.225 134.98C125.457 137.316 126.967 136.695 128.537 136.306C128.636 133.645 126.84 134.551 125.225 134.98ZM131.192 136.968H133.179C133.359 135.463 133.022 134.476 131.854 134.318C131.645 135.213 130.908 135.585 131.192 136.968ZM648.647 136.306C650.988 136.881 652.157 134.69 649.977 134.318C649.815 135.265 648.886 135.434 648.647 136.306ZM119.926 137.631C121.471 137.41 122.773 136.951 123.238 135.643C122.454 134.882 120.897 134.888 119.264 134.98C119.218 136.131 119.409 137.037 119.926 137.631ZM644.68 136.306H646.005C647.033 134.673 643.755 134.354 644.017 135.643C644.418 135.684 644.802 135.742 644.68 136.306ZM112.635 137.631H113.96C114.001 136.782 114.814 136.712 114.628 135.643H112.635V137.631ZM115.29 136.306C116.94 133.72 116.254 138.501 115.29 136.306ZM102.7 138.293C103.931 138.206 104.914 137.857 105.349 136.968C104.362 135.928 102.387 136.236 102.7 138.293ZM117.277 139.623C118.486 141.541 117.405 142.638 119.264 142.929C120.106 141.778 121.501 141.198 121.257 138.961C120.222 137.863 118.671 139.182 117.277 139.623ZM129.199 139.623C131.029 139.332 129.827 142.086 131.192 142.272C131.076 140.39 133.435 140.977 132.516 138.293C130.872 138.194 129.304 138.176 129.199 139.623ZM640.043 138.961C640.467 139.39 639.758 138.682 640.043 138.961ZM110.654 142.272C110.061 142.563 109.469 142.847 109.33 143.591C110.207 144.451 111.792 144.469 111.973 142.929C111.206 143.039 110.8 142.789 110.654 142.272C111.636 141.488 113.611 141.691 113.303 139.623C111.99 138.52 112.461 139.676 110.654 139.623V142.272ZM123.238 139.623C123.209 140.529 123.552 141.076 123.906 141.61C123.093 141.685 122.332 141.808 122.575 142.929C124.388 142.993 123.911 141.825 125.225 142.929C125.864 141.581 126.585 140.308 127.218 138.961C125.585 138.868 124.023 138.862 123.238 139.623ZM645.348 139.623C644.662 141.848 647.399 140.652 648.647 140.942C648.792 138.972 646.294 138.613 645.348 139.623ZM653.952 140.28C651.866 140.6 652.453 138.247 649.977 138.961C649.135 141.186 653.33 141.691 653.952 140.28ZM104.687 140.942C108.208 141.791 102.753 144.341 106.012 144.916C106.157 144.399 106.57 144.15 107.331 144.253C105.763 141.587 108.394 142.633 108.662 140.28C106.971 139.774 105.623 139.31 104.687 140.942ZM100.713 141.61C101.66 142.615 104.17 142.255 104.03 140.28C102.38 140.186 100.807 140.158 100.713 141.61ZM100.051 143.591C100.114 144.393 99.0866 144.004 100.051 143.591H100.713C103.467 142.964 100.847 145.579 100.713 143.591C100.585 142.836 100.045 143.226 100.051 143.591ZM657.926 143.591C657.688 145.857 661.761 146.391 661.243 143.591C659.594 143.516 659.193 142.348 657.926 143.591ZM652.627 144.916C653.876 146.462 655.695 146.201 656.607 144.253C655.752 143.348 652.645 143.103 652.627 144.916ZM122.575 147.571C123.331 147.444 122.947 146.909 122.575 146.909C122.686 146.13 123.784 146.351 124.563 146.247C124.278 143.289 123.168 145.253 121.257 144.253C121.599 147.507 118.3 148.582 119.926 152.87C118.033 152.742 116.307 152.789 116.615 154.862C121.408 153.637 128.937 157 131.853 152.87C128.57 151.766 122.877 154.834 120.588 151.545C122.192 151.156 122.058 149.041 122.575 147.571ZM130.524 146.247C129.856 145.811 129.844 144.724 128.537 144.916C127.979 146.787 126.399 147.635 126.55 150.215C128.688 151.302 130.146 150.535 132.516 150.215C132.982 147.816 134.648 146.613 135.829 144.916C136.793 144.515 135.759 144.12 135.829 144.916C134.248 143.534 131.024 144.521 130.524 146.247ZM647.985 144.916C647.311 147.141 650.048 145.95 651.302 146.247C651.767 143.957 648.985 143.864 647.985 144.916ZM107.999 148.89C108.069 149.698 107.034 149.303 107.999 148.89C109.696 148.821 110.317 147.675 111.311 146.909H112.635C113.437 146.839 113.048 147.873 112.635 146.909C112.473 146.072 111.322 146.241 111.311 146.909C110.061 146.839 110.851 144.713 109.33 144.916C108.15 145.677 106.303 147.211 107.999 148.89ZM116.615 146.247C117.498 147.106 119.077 147.118 119.264 145.584C118.381 144.724 116.8 144.707 116.615 146.247ZM659.918 147.571C660.907 147.454 662.365 147.803 662.568 146.909C661.685 146.043 660.105 146.037 659.918 147.571ZM657.926 146.909H654.614C654.626 149.494 657.914 149.494 657.926 146.909ZM661.905 152.87C662.417 153.009 662.678 153.428 662.568 154.2C664.474 154.334 665.932 154.032 666.542 152.87C665.351 152.207 662.481 150.337 661.905 152.87ZM667.205 152.87C667.634 153.306 666.92 152.597 667.205 152.87ZM107.999 155.519C109.143 156.332 113.298 155.914 113.96 154.199C112.507 153.073 108.743 153.88 107.999 155.519ZM638.051 156.188C637.487 155.618 636.157 156.664 636.064 156.839C635.436 158.012 638.504 156.641 638.051 156.188ZM638.713 156.838C639.486 159.464 639.486 154.229 638.713 156.838ZM644.68 156.188H640.043C640.49 158.303 645.063 158.639 644.68 156.188ZM106.669 158.837C107.534 162.299 109.259 158.361 111.311 161.486C110.817 159.441 113.135 160.214 112.635 158.169C110.073 157.814 109.399 159.354 106.669 158.837ZM648.647 158.837C649.088 159.267 648.38 158.552 648.647 158.837ZM104.687 159.493C105.652 159.092 104.624 158.691 104.687 159.493C103.717 158.552 102.591 158.987 102.7 160.817C103.828 160.847 104.414 160.335 104.687 159.493ZM661.905 162.81C662.672 165.419 662.672 160.195 661.905 162.81ZM100.051 166.122C105.105 163.943 109.417 168.132 110.654 163.478C105.699 164.798 102.921 162.45 100.051 166.122ZM116.615 164.135C117.044 164.565 116.335 163.85 116.615 164.135ZM634.739 168.109C635.175 168.544 634.46 167.836 634.739 168.109ZM112.635 169.439C113.53 169.642 113.908 170.375 115.29 170.107V168.777C114.628 168.777 114.5 168.237 113.96 168.109C113.954 168.986 112.804 168.713 112.635 169.439ZM98.7258 170.758C99.7654 170.7 101.021 170.851 100.713 169.439H99.3938C99.3938 170.107 98.8539 170.223 98.7258 170.758ZM106.669 170.107C107.11 170.526 106.396 169.822 106.669 170.107ZM110.654 174.733C112.298 174.802 112.705 175.976 113.96 174.733C114.175 171.624 110.898 172.966 110.654 174.733ZM103.362 174.733C104.356 175.784 106.076 175.221 106.669 174.071C105.681 173.025 103.973 173.588 103.362 174.733ZM102.038 178.044V180.037C104.089 180.101 105.71 179.735 106.669 178.706C105.745 177.708 103.456 176.621 102.038 178.044ZM108.661 178.044C108.149 178.201 107.353 178.062 107.33 178.706C107.853 178.561 108.643 178.694 108.661 178.044ZM100.713 182.029C102.694 184.435 110.399 183.755 110.654 181.361C107.064 182.675 103.856 181.153 100.713 182.029ZM75.5333 184.017C75.9685 184.447 75.2604 183.732 75.5333 184.017ZM109.986 184.673C107.982 187.119 107.755 182.669 109.986 184.673ZM107.999 187.322C108.662 187.322 108.783 187.856 109.33 187.984C109.324 187.322 109.864 187.2 109.986 186.665C109.324 186.665 109.196 186.119 108.662 186.003C108.662 186.665 108.133 186.787 107.999 187.322ZM102.038 191.296C105.803 190.088 106.035 194.77 108.662 192.627C107.988 191.093 107.331 189.541 105.349 189.309C105.628 190.976 100.179 190.233 102.038 191.296ZM109.986 192.627C113.275 192.597 117.132 193.138 117.94 190.639C115.977 189.855 114.083 190.431 111.311 189.309C111.805 191.348 109.492 190.582 109.986 192.627ZM79.5076 189.971C78.514 190.088 77.0676 189.739 76.8634 190.639C77.7406 191.494 79.3268 191.511 79.5076 189.971ZM78.1826 193.283C78.6187 193.719 77.9097 193.01 78.1826 193.283ZM685.761 264.186C688.173 263.751 686.575 267.341 688.404 267.493C689.549 266.394 695.214 266.394 696.352 267.493C695.365 268.556 693.046 266.929 693.046 270.142C694.004 270.514 696.462 269.375 696.352 270.81C695.138 273.622 696.88 274.755 697.682 276.771C693.534 277.369 688.288 279.274 684.436 278.096C685.883 276.707 685.796 275.598 683.768 274.784C682.101 275.993 681.032 277.782 679.794 279.426C689.816 280.791 698.026 279.269 707.623 279.426C704.352 284.179 687.085 278.009 686.417 282.732C682.984 282.871 681.555 282.97 681.781 280.745C678.91 280.123 674.838 281.715 673.833 280.745C674.443 279.426 675.988 277.59 674.495 276.109C675.454 275.696 674.425 275.308 674.495 276.109C673.6 275.9 673.943 274.453 673.833 273.453C674.878 273.401 676.36 273.773 676.482 272.797C672.41 273.396 676.354 269.834 674.495 268.817C672.438 269.688 672.601 268.637 669.853 268.817C670.847 274.865 670.045 278.537 668.528 283.394C672.885 284.875 677.528 285.602 683.112 285.387C706.909 284.462 731.385 286.81 754.003 285.387C754.543 283.516 753.063 283.666 753.335 282.063C741.815 281.25 726.615 281.186 718.889 280.082C729.555 276.927 743.545 282.435 753.335 279.425C744.4 276.351 728.679 278.309 721.538 275.44C732.24 275.126 740.101 277.63 751.354 276.77C750.796 274.899 752.283 275.056 752.01 273.453C744.26 272.488 727.714 275.475 720.87 271.465C734.412 272.575 749.076 273.168 756.653 270.809C758.692 270.309 757.931 272.628 759.964 272.133C760.307 271.146 760.946 270.46 761.295 269.484C759.906 269.101 759.395 267.834 757.315 268.154C757.599 269.543 756.862 269.908 756.653 270.809C755.328 270.141 755.601 267.875 753.335 268.154C752.121 271.082 749.46 268.515 746.055 268.154C738.037 267.318 724.118 269.938 719.539 266.167C724.338 267.648 728.696 267.05 733.459 266.824C738.944 266.58 744.835 268.688 748.036 265.505C747.263 265.394 747.478 264.296 747.373 263.517C741.15 263.291 724.999 266.353 718.888 262.193C728.404 263.274 739.705 265.238 746.705 260.868C741.906 258.771 737.119 261.978 733.458 260.2C738.077 257.505 745.055 261.728 746.055 256.894C741.145 254.501 729.985 258.381 726.168 254.902C731.536 255.779 740.471 255.883 744.725 253.576C737.927 250.358 726.127 253.438 721.538 250.927C729.225 250.98 735.987 250.765 741.407 251.595C741.843 247.929 735.185 245.989 733.459 242.316C724.948 240.08 715.443 242.729 708.279 239.661C722.536 241.201 738.984 241.828 745.387 231.051C739.053 231.051 734.29 232.074 728.829 230.388C734.138 230.191 740.007 230.145 744.724 229.726C746.426 229.575 749.807 231.504 749.36 227.739C742.4 227.298 732.547 229.272 726.168 227.739C734.26 227.913 746.06 224.985 753.335 227.077C755.543 224.858 758.999 223.91 760.626 221.11C750.418 218.583 735.597 223.742 726.168 219.791C739.013 219.762 747.838 219.309 760.626 218.461C761.544 218.867 760.725 221.017 761.95 221.11C763.101 219.39 766.476 219.896 765.925 216.474C752.829 214.957 742.262 217.99 730.148 217.13C738.479 214.789 754.898 215.393 764.601 213.83C762.672 208.695 755.392 212.378 750.686 212.5C741.762 212.733 731.008 212.832 724.187 211.176C735.087 211.199 749.85 210.687 761.951 209.851C756.484 205.441 745.295 209.107 737.434 209.189C733.977 209.229 731.078 208.782 728.83 207.864C738.34 206.806 752.127 208.328 761.295 205.208C753.968 202.577 738.479 206.441 730.816 204.546C743.25 202.211 750.256 205.691 760.627 201.24C755.672 199.758 746.729 204.029 744.057 199.242C742.437 200.131 744.795 201.711 743.395 201.891C739.677 201.996 741.101 200.393 739.427 199.242C735.104 198.144 727.22 201.38 726.836 197.923C734.773 197.196 744.022 199.09 752.673 197.923C750.407 192.926 744.957 196.232 740.752 195.935C731.851 195.303 722.735 193.565 714.241 194.605C706.758 195.529 695.185 191.398 691.054 197.923C699.578 198.452 704.37 197.15 708.948 197.923C704.26 200.392 695.841 198.225 690.397 199.242C690.13 201.409 688.556 202.269 688.404 204.546C695.103 206.475 705.183 203.361 712.922 203.889C706.002 207.695 690.624 203.965 685.761 207.864C686.679 210.339 690.67 206.801 691.722 209.851C688.568 210.008 684.251 209.009 683.768 211.838C687.899 213.598 693.174 211.565 695.702 213.83C691.548 214.754 683.449 211.733 682.444 215.806C684.372 216.804 689.212 215.021 690.397 216.474C689.444 218.402 683.64 215.462 684.436 219.129C686.261 219.721 690.647 217.764 690.397 220.447C685.988 220.913 682.153 218.252 681.781 223.097C683.28 224.468 689.979 221.122 691.054 224.427C688.033 224.759 687.301 223.276 685.093 224.427C685.093 228.105 688.195 224.55 689.072 227.077C687.109 229.017 682.815 225.084 683.112 229.726C683.03 230.87 688.288 228.384 689.072 230.388C688.991 231.644 686.877 230.854 687.08 232.375C687.952 233.665 690.595 231.051 691.054 233.7C688.875 233.724 687.76 234.822 685.093 234.368C685.964 239.312 690.502 232.776 692.379 236.35C690.613 239.213 682.182 235.431 683.112 240.992C688.428 240.933 693.315 237.721 697.683 240.992C691.699 241.108 689.637 241.318 684.437 241.654C683.676 243.734 685.476 243.264 685.762 244.298C684.768 245.297 681.98 244.501 682.445 246.953C684.019 248.33 686.279 246.378 688.405 246.291C689.387 243.769 685.449 246.163 686.418 243.636C689.852 244.623 694.157 241.765 695.035 244.298C691.467 245.588 688.638 247.627 685.094 248.946C686.098 250.59 690.804 248.533 691.723 250.265C686.785 250.579 673.823 251.403 680.451 256.894C678.558 257.196 676.803 257.656 676.483 259.543C678.15 260.728 680.236 258.282 681.114 260.868C679.928 263.732 681.37 265.551 683.112 268.154C684.391 267.225 685.076 265.708 685.762 264.185L685.761 264.186ZM689.072 195.27C689.131 196.078 688.102 195.683 689.072 195.27C691.054 195.137 688.44 192.528 689.072 195.27ZM81.4999 195.27C80.6519 195.236 80.5816 194.421 79.5076 194.608C78.4789 196.246 81.7619 196.566 81.4999 195.27ZM677.813 201.242C680.52 201.08 680.782 198.471 681.113 195.938C679.806 195.933 680.277 194.131 678.469 194.608C677.296 195.869 677.981 198.994 677.813 201.242ZM683.768 196.601H685.761V194.608H683.768V196.601ZM76.2012 195.938C76.6315 196.368 75.9166 195.659 76.2012 195.938ZM110.654 196.601C108.643 199.053 108.423 194.59 110.654 196.601ZM107.331 196.601C106.378 196.961 103.909 195.822 104.031 197.269C104.99 196.897 107.453 198.03 107.331 196.601ZM761.295 199.244C763.188 199.383 764.903 199.337 764.601 197.269C763.816 196.496 762.259 196.513 760.627 196.601C760.476 197.856 761.37 198.065 761.295 199.244ZM126.55 197.925C126.985 198.361 126.271 197.652 126.55 197.925ZM755.991 198.593C757.635 198.68 759.203 198.71 759.302 197.269C758.053 197.554 755.305 196.357 755.991 198.593ZM785.801 197.925C785.598 201.027 788.875 199.697 789.118 197.925C787.858 196.676 787.452 197.856 785.801 197.925ZM82.1628 198.593C82.5922 199.023 81.8774 198.309 82.1628 198.593ZM769.237 198.593C769.673 199.023 768.958 198.309 769.237 198.593ZM681.781 201.242C683.902 201.812 683.855 200.22 684.436 199.244C682.693 199.064 681.578 199.488 681.781 201.242ZM686.417 200.574H687.742V199.244H686.417V200.574ZM773.223 202.562C773.879 200.353 772.293 200.395 770.562 200.574C770.365 202.317 771.48 202.753 773.223 202.562ZM782.49 201.894C783.669 201.755 785.807 202.573 785.145 200.574C783.634 200.395 782.646 200.738 782.49 201.894ZM765.264 201.894C765.258 201.237 764.107 201.068 763.933 201.894C764.676 201.835 764.972 202.864 765.264 201.894ZM775.204 201.894C775.639 202.335 774.931 201.621 775.204 201.894ZM74.8711 203.224C75.7141 204.13 78.119 204.253 78.1826 202.562C77.1948 201.51 75.4747 202.074 74.8711 203.224ZM80.8377 203.224C80.826 202.562 79.6817 202.388 79.5076 203.224C80.251 203.154 80.5414 204.189 80.8377 203.224ZM679.794 205.211H681.781C681.677 204.432 681.897 203.328 681.113 203.224C681.055 204.269 679.434 203.747 679.794 205.211ZM684.436 204.549H685.761V203.224H684.436V204.549ZM763.933 205.211C764.711 205.775 765.716 206.088 767.251 205.874C767.512 203.817 764.067 203.178 763.933 205.211ZM774.542 204.549C773.293 204.694 773.078 203.806 771.892 203.892C771.388 206.147 774.419 206.472 774.542 204.549ZM81.4999 207.204C80.739 207.326 81.1341 207.866 81.4999 207.866C84.2479 207.227 81.6338 209.847 81.4999 207.866V207.204C83.4234 207.082 83.0978 204.049 80.8377 204.549C79.5018 205.897 81.1282 205.85 81.4999 207.204ZM678.469 211.84C678.853 210.015 680.12 209.08 680.451 207.203H678.469C679.022 208.934 676.459 210.84 678.469 211.84ZM684.436 207.204C683.652 207.303 682.553 207.088 682.444 207.866C683.228 207.756 684.326 207.977 684.436 207.204ZM773.874 211.178C770.853 211.648 767.158 210.428 765.926 211.178C765.403 213.466 766.663 213.972 767.251 215.151C770.876 215.244 772.317 213.147 773.874 211.178C775.012 210.323 776.483 209.801 776.524 207.865C774.491 207.401 775.257 207.401 773.224 207.865C772.666 209.73 774.147 209.58 773.874 211.178ZM765.926 209.19C767.099 209.039 769.243 209.852 768.575 207.865H765.926V209.19ZM681.781 211.178C684.006 209.568 680.178 213.397 681.781 211.178ZM679.794 215.151C680.561 217.772 680.561 212.531 679.794 215.151ZM78.1826 215.808C78.9903 215.744 78.5894 216.772 78.1826 215.808C78.0545 213.833 75.4345 216.453 78.1826 215.808ZM81.4999 216.476H82.8249V215.151H81.4999V216.476ZM80.8377 218.463C79.2281 220.642 77.6711 216.622 80.8377 218.463ZM679.131 229.061C679.259 229.816 679.794 229.432 679.794 229.061C680.544 228.938 680.16 228.409 679.794 228.409C679.666 227.654 679.131 228.032 679.131 228.409C677.284 225.325 681.241 223.693 679.794 221.113C674.96 221.519 677.894 225.749 676.482 229.729C677.865 230.007 678.232 229.275 679.131 229.061ZM80.1698 223.762C80.4025 226.103 81.9125 225.476 83.487 225.086C83.9516 222.798 81.1634 222.71 80.1698 223.762ZM84.1441 229.729C82.1394 232.175 81.9184 227.713 84.1441 229.729ZM682.444 232.378C682.879 232.814 682.159 232.099 682.444 232.378ZM677.145 235.033C678.795 232.448 678.109 237.224 677.145 235.033ZM80.8377 236.351C81.6045 237.188 83.5917 236.885 83.487 235.032C81.9761 234.841 81.0001 235.19 80.8377 236.351ZM681.781 235.033C681.263 235.178 680.474 235.045 680.451 235.69C680.974 235.545 681.764 235.673 681.781 235.033ZM677.813 240.994H677.145C677.157 242.551 676.001 242.94 676.482 244.967C678.603 245.153 678.888 242.069 677.813 240.994C679.672 240.866 680.631 239.837 680.451 237.676C678.039 237.258 677.848 239.053 677.813 240.994ZM82.8249 239.001C83.2602 239.437 82.5462 238.722 82.8249 239.001ZM85.4742 244.967C83.4636 247.414 83.2376 242.952 85.4742 244.967ZM679.131 246.954H680.451V245.63H679.131V246.954ZM677.813 249.599C678.237 250.046 677.528 249.331 677.813 249.599ZM683.112 249.599C682.967 251.585 680.352 248.977 683.112 249.599C685.86 250.237 683.24 247.623 683.112 249.599ZM676.483 254.902C676.762 253.642 678.377 253.711 677.814 251.596C675.838 250.8 674.961 254.385 676.483 254.902ZM752.673 258.221C751.569 257.337 750.453 256.466 748.037 256.895C747.275 259.714 752.911 259.916 752.673 258.221ZM82.8249 261.531C83.2602 261.967 82.5462 261.247 82.8249 261.531ZM675.152 267.493C677.598 267.87 678.667 260.823 676.482 260.869C676.239 263.379 675.163 263.611 675.152 267.493ZM751.355 261.531C751.784 261.967 751.07 261.247 751.355 261.531ZM756.653 260.869C756.135 261.021 755.339 260.881 755.328 261.531C755.84 261.386 756.629 261.514 756.653 260.869ZM84.1441 265.505C83.9173 266.383 82.9764 266.545 82.8249 267.493C83.4117 268.016 84.3182 268.208 85.4742 268.155C85.4567 268.799 84.6673 268.666 84.1441 268.817C83.1907 271.327 85.9681 270.089 85.4742 272.134C83.6787 272.902 83.8244 272.448 81.4999 272.134C80.6804 274.186 78.4211 274.795 78.8447 278.096C82.3545 280.338 86.0376 278.107 88.1235 276.109C86.9441 275.318 83.4762 276.859 82.1628 274.784C83.6327 275.144 83.1095 273.518 84.1441 273.453C84.6899 274.854 87.6414 275.278 88.7915 274.116C87.5895 272.228 87.0898 269.636 85.4742 268.155C85.2825 267.086 86.102 267.016 86.1364 266.168C85.0616 266.353 84.9979 265.546 84.1441 265.505C84.1676 264.861 84.9636 264.994 85.4742 264.843C85.5847 262.798 83.1447 261.863 82.1628 262.856C82.0523 264.518 83.179 264.93 84.1441 265.505ZM751.355 266.825C752.993 266.928 754.568 266.958 754.666 265.505C753.487 264.913 753.818 262.815 751.355 263.518C750.112 264.779 751.744 264.721 751.355 266.825ZM750.024 266.825C749.873 265.657 750.698 263.512 748.699 264.187C748.519 265.691 748.861 266.668 750.024 266.825ZM757.978 267.493C758.105 265.598 758.059 263.873 755.991 264.186C755.671 266.261 756.81 266.894 757.978 267.493ZM679.131 266.825C681.357 265.233 677.528 269.05 679.131 266.825ZM685.761 268.817V270.81C687.841 271.124 688.462 269.979 689.072 268.817C687.806 267.574 687.399 268.747 685.761 268.817ZM681.781 268.817C685.662 269.694 679.382 271.948 681.781 268.817ZM763.933 271.466C764.125 269.735 763.695 268.619 761.951 268.817C761.765 270.554 762.19 271.664 763.933 271.466ZM176.909 272.797C177.339 273.232 176.625 272.518 176.909 272.797ZM675.814 278.764C677.377 279.728 677.051 280.152 679.131 279.426C679.434 275.046 680.799 275.818 681.781 272.134H679.131C680.015 276.335 676.563 276.196 675.814 278.764ZM683.112 274.116C684.471 273.715 687.713 275.184 687.08 272.797C686.133 271.043 682.815 272.436 683.112 274.116ZM182.209 273.453C182.638 273.884 181.93 273.181 182.209 273.453ZM691.722 273.453C692.152 273.884 691.443 273.181 691.722 273.453ZM757.315 277.434C757.867 276.667 758.192 275.662 757.978 274.116C756.176 272.669 756.327 273.384 754.003 272.797C753.998 275.446 754.346 277.747 757.315 277.434ZM758.634 273.453C757.716 276.597 761.062 277.463 762.614 276.109C762.865 273.082 760.499 272.663 758.634 273.453ZM763.276 274.116C763.166 276.173 765.612 277.102 766.594 276.109C766.704 274.453 765.577 274.034 764.601 273.453C764.456 273.971 764.043 274.226 763.276 274.116ZM279.605 275.441H280.929V274.116H279.605V275.441ZM769.9 274.784C769.673 274.249 768.145 273.988 767.913 274.784C767.477 276.318 770.504 276.213 769.9 274.784ZM771.892 280.745C771.938 279.589 771.741 278.683 771.224 278.096C768.685 280.989 766.147 276.196 763.933 279.426C763.329 278.258 762.707 277.119 760.627 277.434C759.686 283.847 768.662 279.577 771.892 280.745ZM754.666 280.083C755.218 280.646 759.842 281.896 759.302 279.426C758.361 277.44 754.991 277.944 754.666 280.083ZM773.223 278.764C773.241 281.169 775.163 281.669 777.854 281.413C777.755 279.125 774.885 277.422 773.223 278.764ZM755.328 284.719C757.455 285.195 762.631 285.067 765.264 284.062C762.352 282.4 760.168 282.621 755.328 282.063V284.719ZM765.926 283.394C765.467 285.69 768.249 285.771 769.237 284.719C769.708 282.43 766.913 282.343 765.926 283.394ZM770.562 284.062C771.927 285.84 774.547 283.214 771.892 282.732C771.881 283.609 770.73 283.342 770.562 284.062ZM775.86 282.731C775.349 282.883 774.559 282.749 774.541 283.394C775.052 283.242 775.848 283.376 775.86 282.731Z",
    fill: "#72969B"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.68 131.007C520.285 134.818 499.096 132.222 480.365 134.318C498.213 131.041 519.263 132.099 536.68 131.007Z",
    fill: "#72969B"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.053 132.332C153.123 133.127 152.09 132.738 153.053 132.332Z",
    fill: "#72969B"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.417 132.994C148.992 135.12 146.697 134.365 146.424 135.643C144.763 134.975 146.959 132.716 148.417 132.994Z",
    fill: "#72969B"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.795 134.318C140.241 134.748 139.527 134.046 139.795 134.318Z",
    fill: "#72969B"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.405 133.65C151.723 134.76 151.253 133.598 153.054 133.65C153.193 135.829 149.946 136.27 150.405 133.65Z",
    fill: "#72969B"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.086 134.318C466.862 136.503 458.769 134.812 453.86 136.306C451.443 135.859 449.044 135.376 445.906 135.643C453.842 135.144 464.074 133.552 471.086 134.318Z",
    fill: "#72969B"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.354 134.98C158.273 136.439 155.547 135.265 154.385 135.643C155.047 133.802 157.052 134.801 158.354 134.98Z",
    fill: "#72969B"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.722 134.981C475.746 134.336 476.536 134.469 477.047 134.318C477.03 134.963 476.239 134.836 475.722 134.981Z",
    fill: "#72969B"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.076 134.318C635.261 134.133 635.435 134.94 634.738 134.98C633.111 140.146 626.18 137.154 622.147 136.968C610.685 136.439 595.869 137.369 584.383 136.968C598.89 134.457 618.261 137.072 634.076 134.318Z",
    fill: "#72969B"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.016 135.643C159.452 136.078 158.738 135.365 159.016 135.643Z",
    fill: "#72969B"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.148 135.644C194.989 135.568 197.023 134.289 198.777 136.306C196.756 135.887 193.061 137.154 192.148 135.644Z",
    fill: "#72969B"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.355 135.643C210.396 137.7 203.988 135.533 200.095 136.306C200.02 134.888 208.16 135.998 211.355 135.643Z",
    fill: "#72969B"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.703 136.968C156.138 137.403 155.43 136.689 155.703 136.968Z",
    fill: "#72969B"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.999 136.968C216.016 136.323 216.812 136.45 217.317 136.306C217.312 136.95 216.516 136.823 215.999 136.968Z",
    fill: "#72969B"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.428 136.968C514.219 137.665 502.542 139.757 494.936 138.293C502.193 136.898 513.58 136.3 523.428 136.968Z",
    fill: "#72969B"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.734 136.968C581.752 136.323 582.548 136.45 583.059 136.306C583.042 136.95 582.246 136.823 581.734 136.968Z",
    fill: "#72969B"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.743 140.279C149.772 139.373 149.429 138.821 149.087 138.292C150.254 137.712 151.009 136.195 152.392 137.631C152.125 138.903 149.825 138.153 150.406 140.279H149.743Z",
    fill: "#72969B"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.751 137.631C524.774 136.986 525.565 137.119 526.07 136.968C526.064 137.612 525.268 137.479 524.751 137.631Z",
    fill: "#72969B"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.725 137.631C636.893 136.794 638.044 136.968 638.05 137.631C637.758 138.595 637.469 137.56 636.725 137.631Z",
    fill: "#72969B"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.087 138.292C148.675 137.334 148.28 138.368 149.087 138.292Z",
    fill: "#72969B"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.385 137.631C158.261 138.52 151.979 140.755 154.385 137.631Z",
    fill: "#72969B"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.828 138.293C136.345 138.444 137.141 138.31 137.158 138.961C136.635 138.809 135.845 138.937 135.828 138.293Z",
    fill: "#72969B"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.366 138.961C156.39 138.309 157.18 138.443 157.691 138.293C157.68 138.937 156.884 138.81 156.366 138.961Z",
    fill: "#72969B"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.892 138.961C175.881 140.186 170.403 138.188 165.645 138.961C166.267 137.647 175.963 138.211 178.892 138.961Z",
    fill: "#72969B"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.777 139.623C215.829 137.578 235.223 140.146 249.783 140.942C231.761 141.238 212.687 139.594 198.777 139.623Z",
    fill: "#72969B"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.559 139.623C181.784 138.089 186.839 139.385 190.156 138.961C187.362 141.669 183.748 139.135 179.559 139.623Z",
    fill: "#72969B"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.479 139.623C194.24 142.243 194.24 137.003 193.479 139.623Z",
    fill: "#72969B"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.46 139.623C195.895 140.059 195.182 139.344 195.46 139.623Z",
    fill: "#72969B"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.777 139.623C199.034 140.901 195.751 140.587 196.786 138.961H198.11C198.151 139.362 198.208 139.745 198.777 139.623Z",
    fill: "#72969B"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.4 139.623C635.418 138.972 636.208 139.1 636.725 138.961C636.714 139.605 635.919 139.472 635.4 139.623Z",
    fill: "#72969B"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.712 138.961C638.706 139.623 637.561 139.797 637.387 138.961H638.712Z",
    fill: "#72969B"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.749 139.623C255.191 140.599 254.088 141.04 252.438 140.942C252.537 139.495 254.111 139.518 255.749 139.623Z",
    fill: "#72969B"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.453 139.623C612.057 144.608 593.675 139.275 576.431 142.272C587.806 138.223 612.359 141.587 627.453 139.623Z",
    fill: "#72969B"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.116 140.28C628.22 139.501 629.318 139.727 630.102 139.623C629.993 140.395 628.894 140.181 628.116 140.28Z",
    fill: "#72969B"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.759 140.28C630.846 138.821 633.577 139.995 634.739 139.623C634.658 141.087 631.927 139.896 630.759 140.28Z",
    fill: "#72969B"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.742 140.28C149.812 141.086 148.778 140.686 149.742 140.28Z",
    fill: "#72969B"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.053 141.61C153.82 144.224 153.82 138.99 153.053 141.61Z",
    fill: "#72969B"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.361 141.61C533.421 142.981 528.976 141.848 526.739 142.929C528.476 141.198 532.636 140.402 535.361 141.61Z",
    fill: "#72969B"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.504 140.942C560.31 142.969 557.451 140.106 564.504 140.942Z",
    fill: "#72969B"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.171 141.61C565.275 140.826 566.373 141.047 567.157 140.942C567.048 141.72 565.949 141.499 565.171 141.61Z",
    fill: "#72969B"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.779 141.61C569.166 143.359 567.121 139.663 573.779 141.61Z",
    fill: "#72969B"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.451 141.61C574.875 142.034 574.172 141.326 574.451 141.61Z",
    fill: "#72969B"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.1 143.591C148.522 141.732 149.66 142.266 153.716 143.591C150.032 146.978 147.778 142.093 145.768 146.909C145.814 144.439 146.755 144.765 145.1 143.591Z",
    fill: "#72969B"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.352 141.61C159.079 141.772 158.806 142.923 159.683 142.929C158.684 143.702 158.062 144.846 156.365 144.916C156.075 144.33 155.785 143.737 155.041 143.591C155.465 142.243 158.143 143.156 158.352 141.61Z",
    fill: "#72969B"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.018 142.272C536.122 141.494 537.226 141.709 537.999 141.61C537.9 142.382 536.796 142.162 536.018 142.272Z",
    fill: "#72969B"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.006 143.591C161.093 142.133 163.818 143.313 164.981 142.929C164.417 145.293 163.348 143.01 161.006 143.591Z",
    fill: "#72969B"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.608 142.929C170.157 144.95 167.363 142.174 171.608 142.929Z",
    fill: "#72969B"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.26 143.591C178.165 142.348 186.194 142.686 190.156 143.591C184.863 143.714 178.693 144.358 174.26 143.591Z",
    fill: "#72969B"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.614 142.929C215.98 146.009 201.653 143.394 190.817 144.253C201.6 141.633 212.442 144.62 224.614 142.929Z",
    fill: "#72969B"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.556 143.591C230.958 145.77 229.396 141.756 232.556 143.591Z",
    fill: "#72969B"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.53 143.591C343.235 145.067 340.138 142.726 337.244 143.591C336.1 142.337 343.386 142.871 344.53 143.591Z",
    fill: "#72969B"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.441 142.929C518.792 144.248 515.428 144.87 511.5 144.916C514.156 143.603 517.52 142.987 521.441 142.929Z",
    fill: "#72969B"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.428 143.591C523.537 142.819 524.636 143.039 525.419 142.929C525.31 143.713 524.211 143.487 523.428 143.591Z",
    fill: "#72969B"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.513 143.591C617.949 144.026 617.234 143.313 617.513 143.591Z",
    fill: "#72969B"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.292 143.591C166.84 145.618 164.046 142.831 168.292 143.591Z",
    fill: "#72969B"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.263 144.253C227.467 143.359 228.924 143.714 229.912 143.591C229.708 144.492 228.251 144.15 227.263 144.253Z",
    fill: "#72969B"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.555 144.253C234.985 144.689 234.271 143.975 234.555 144.253Z",
    fill: "#72969B"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.538 144.254C236.561 143.615 237.351 143.742 237.863 143.591C237.851 144.236 237.055 144.109 236.538 144.254Z",
    fill: "#72969B"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.058 144.916C316.661 143.138 318.369 144.224 320.025 144.253C329.797 144.463 322.587 145.166 314.058 144.916Z",
    fill: "#72969B"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.302 144.253C329.186 142.825 331.643 143.963 332.601 143.591C332.723 145.032 330.261 143.894 329.302 144.253Z",
    fill: "#72969B"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.521 144.254C346.539 143.615 347.329 143.742 347.846 143.591C347.834 144.236 347.038 144.109 346.521 144.254Z",
    fill: "#72969B"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.178 144.916C241.34 143.365 244.087 144.539 244.482 144.916C243.919 146.868 242.816 144.056 241.178 144.916Z",
    fill: "#72969B"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.994 145.584C163.429 146.019 162.716 145.3 162.994 145.584Z",
    fill: "#72969B"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.631 146.246C168.066 146.687 167.359 145.968 167.631 146.246Z",
    fill: "#72969B"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.623 146.246C169.908 144.765 172.883 145.974 174.26 145.584C173.975 147.066 170.994 145.851 169.623 146.246Z",
    fill: "#72969B"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.572 146.246C178.001 146.687 177.288 145.968 177.572 146.246Z",
    fill: "#72969B"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.559 146.246C179.837 144.765 182.824 145.974 184.195 145.584C183.904 147.066 180.93 145.851 179.559 146.246Z",
    fill: "#72969B"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.887 146.246C236.118 148.257 235.898 143.795 233.887 146.246Z",
    fill: "#72969B"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.74 145.584C635.03 147.42 629.342 146.02 632.752 147.571C617.078 147.792 601.089 148.925 582.399 150.215C598.236 147.56 616.003 146.787 634.74 145.584ZM627.454 146.909C626.942 147.053 626.147 146.926 626.13 147.571C626.641 147.42 627.436 147.553 627.454 146.909Z",
    fill: "#72969B"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.522 146.247C131.323 146.177 130.935 147.21 130.522 146.247Z",
    fill: "#72969B"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.084 146.909C149.508 147.338 148.799 146.63 149.084 146.909Z",
    fill: "#72969B"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.354 146.909C158.788 147.338 158.081 146.63 158.354 146.909Z",
    fill: "#72969B"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.494 146.909C189.929 147.338 189.214 146.63 189.494 146.909Z",
    fill: "#72969B"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.481 146.909C191.916 147.338 191.208 146.63 191.481 146.909Z",
    fill: "#72969B"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.479 146.909C193.758 145.427 196.739 146.636 198.11 146.246C197.825 147.734 194.838 146.513 193.479 146.909Z",
    fill: "#72969B"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.37 146.247C208.307 149.093 204.751 145.881 201.428 146.909C200.348 145.579 207.203 146.537 209.37 146.247Z",
    fill: "#72969B"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.037 146.909C218.88 144.591 215.499 148.349 210.037 146.909Z",
    fill: "#72969B"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.985 146.909C218.421 147.338 217.713 146.63 217.985 146.909Z",
    fill: "#72969B"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.283 146.909C223.301 146.264 224.097 146.391 224.613 146.247C224.59 146.885 223.8 146.758 223.283 146.909Z",
    fill: "#72969B"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.912 146.909C230.342 147.338 229.633 146.63 229.912 146.909Z",
    fill: "#72969B"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.4 146.909C635.836 147.338 635.122 146.63 635.4 146.909Z",
    fill: "#72969B"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.005 146.247V146.908C645.639 146.908 645.249 146.369 646.005 146.247Z",
    fill: "#72969B"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.574 146.909V147.57C122.203 147.57 121.825 147.031 122.574 146.909Z",
    fill: "#72969B"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.897 147.571C395.001 146.798 396.099 147.007 396.878 146.909C396.774 147.681 395.67 147.472 394.897 147.571Z",
    fill: "#72969B"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.201 147.571C398.224 146.926 399.014 147.054 399.526 146.909C399.508 147.553 398.718 147.42 398.201 147.571Z",
    fill: "#72969B"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.195 147.571C400.212 146.926 401.008 147.054 401.519 146.909C401.496 147.553 400.705 147.42 400.195 147.571Z",
    fill: "#72969B"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.005 146.909H646.666C646.666 147.28 646.133 147.664 646.005 146.909Z",
    fill: "#72969B"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.043 147.571C633.699 149.529 631.194 146.804 640.043 147.571Z",
    fill: "#72969B"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.025 148.239C642.048 147.595 642.839 147.716 643.35 147.571C643.338 148.215 642.548 148.082 642.025 148.239Z",
    fill: "#72969B"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.887 150.215C230.918 149.042 226.247 151.11 221.297 151.545C216.718 151.946 206.499 151.121 215.335 150.883C221.076 151.458 228.856 147.351 233.887 150.215Z",
    fill: "#72969B"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.593 150.883C173.483 149.449 175.945 150.581 176.909 150.215C177.02 151.661 174.563 150.522 173.593 150.883Z",
    fill: "#72969B"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.533 150.215C183.94 152.835 179.896 151.005 178.235 151.545C176.684 150.383 182.731 151.231 183.533 150.215Z",
    fill: "#72969B"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.849 150.883C190.062 150.929 180.303 150.79 186.849 150.883Z",
    fill: "#72969B"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.831 150.883C194.374 149.338 201.625 151.784 208.713 150.883C203.85 152.76 195.409 151.15 188.831 150.883Z",
    fill: "#72969B"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.002 150.215C262.67 152.179 260.159 149.454 269.002 150.215Z",
    fill: "#72969B"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.754 150.883C577.964 149.982 579.416 150.33 580.409 150.215C580.206 151.12 578.754 150.778 577.754 150.883Z",
    fill: "#72969B"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.37 151.545C209.805 151.981 209.097 151.272 209.37 151.545Z",
    fill: "#72969B"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.775 150.883C253.693 152.521 240.98 150.563 238.523 152.213C237.343 152.399 237.163 151.58 237.86 151.545C241.282 150.11 247.283 151.249 251.775 150.883Z",
    fill: "#72969B"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.126 151.545C571.15 150.894 571.946 151.04 572.457 150.883C572.44 151.528 571.644 151.4 571.126 151.545Z",
    fill: "#72969B"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.451 151.545C574.462 150.894 575.258 151.04 575.77 150.883C575.752 151.528 574.956 151.4 574.451 151.545Z",
    fill: "#72969B"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M566.494 151.545C566.332 152.707 565.356 153.049 563.846 152.87C564.008 151.703 564.984 151.359 566.494 151.545Z",
    fill: "#72969B"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7463 152.213C96.2861 152.399 96.2736 153.979 95.4083 154.862C93.486 154.281 94.6652 153.868 94.7463 152.213Z",
    fill: "#72969B"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.699 152.87C210.6 154.322 209.026 154.293 207.388 154.2C207.946 153.212 209.52 153.236 210.699 152.87Z",
    fill: "#72969B"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.346 154.862C160.415 154.334 162.535 152.852 162.332 154.2C164.116 154.444 170.402 153.59 168.962 154.862H160.346Z",
    fill: "#72969B"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.075 153.538C204.476 156.147 200.438 154.311 198.776 154.862C197.219 153.695 203.267 154.543 204.075 153.538Z",
    fill: "#72969B"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.066 154.862C150.932 152.871 148.315 155.495 151.066 154.862Z",
    fill: "#72969B"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.042 154.862C154.838 155.757 153.385 155.403 152.392 155.519C152.578 153.992 154.164 153.997 155.042 154.862Z",
    fill: "#72969B"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.016 154.862C159.452 155.286 158.738 154.584 159.016 154.862Z",
    fill: "#72969B"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.818 154.2C186.791 157.018 177.769 154.834 171.61 155.519C176.763 153.834 185.537 155.763 190.818 154.2Z",
    fill: "#72969B"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.447 154.2C193.247 156.223 190.382 153.358 197.447 154.2Z",
    fill: "#72969B"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.066 154.862C151.861 154.793 151.472 155.821 151.066 154.862Z",
    fill: "#72969B"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.931 155.519C546.551 153.967 545.325 157.848 549.931 155.519Z",
    fill: "#72969B"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.853 155.519C240.213 156.367 234.473 156.75 231.905 156.838C233.619 155.473 236.68 155.443 239.853 155.519Z",
    fill: "#72969B"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.593 156.188C551.296 154.677 554.759 155.926 556.554 155.52C555.846 157.024 552.395 155.77 550.593 156.188Z",
    fill: "#72969B"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.854 156.187C562.348 154.688 565.572 155.92 567.158 155.519C565.903 156.333 562.917 157.163 561.854 156.187Z",
    fill: "#72969B"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.25 156.838C229.355 156.071 230.452 156.285 231.237 156.187C231.126 156.959 230.028 156.739 229.25 156.838Z",
    fill: "#72969B"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M534.693 156.838C535.123 157.279 534.414 156.565 534.693 156.838Z",
    fill: "#72969B"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.64 156.838C542.743 156.071 543.848 156.285 544.625 156.187C544.527 156.959 543.417 156.739 542.64 156.838Z",
    fill: "#72969B"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.887 156.838C557.904 156.204 558.694 156.332 559.205 156.187C559.193 156.825 558.398 156.698 557.887 156.838Z",
    fill: "#72969B"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.615 156.838C218.95 159.853 209.213 159.992 202.747 158.168C207.998 157.727 219.061 159.023 224.615 156.838Z",
    fill: "#72969B"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.98 159.493C164.214 160.056 163.203 160.37 161.663 160.161C162.232 159.172 163.336 158.731 164.98 158.836V159.493Z",
    fill: "#72969B"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.981 159.493C167.77 158.087 173.057 159.173 176.909 158.836C174.899 160.364 170.071 159.063 166.963 159.493C166.858 160.266 165.917 160.213 164.981 160.161V159.493Z",
    fill: "#72969B"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.236 159.493C178.67 159.928 177.957 159.214 178.236 159.493Z",
    fill: "#72969B"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.85 158.837C179.443 160.818 178.083 158.007 186.85 158.837Z",
    fill: "#72969B"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.168 158.837C189.499 158.61 190.243 158.971 190.155 160.162H188.168V158.837Z",
    fill: "#72969B"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.489 159.493C352.919 159.928 352.205 159.214 352.489 159.493Z",
    fill: "#72969B"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.15 160.161C617.252 161.736 609.438 160.626 603.593 160.161C599.968 159.859 580.801 157.941 592.996 158.836C601.984 159.487 613.186 159.214 622.15 160.161Z",
    fill: "#72969B"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.127 160.161C141.562 160.596 140.848 159.882 141.127 160.161Z",
    fill: "#72969B"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.392 160.161C152.41 159.516 153.206 159.638 153.717 159.493C153.7 160.143 152.91 160.01 152.392 160.161Z",
    fill: "#72969B"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.041 160.161C155.476 160.596 154.768 159.882 155.041 160.161Z",
    fill: "#72969B"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.21 159.493C341.757 161.52 338.969 158.731 343.21 159.493Z",
    fill: "#72969B"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.191 159.493C345.727 161.52 342.95 158.731 347.191 159.493Z",
    fill: "#72969B"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M623.479 159.493C626.512 159.928 622.945 163.508 623.479 159.493Z",
    fill: "#72969B"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.18 160.817C133.204 160.179 133.987 160.306 134.499 160.161C134.487 160.8 133.697 160.678 133.18 160.817Z",
    fill: "#72969B"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.283 160.817C338.342 161.654 335.484 158.796 331.283 160.817Z",
    fill: "#72969B"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.244 160.817C337.354 160.045 338.458 160.265 339.236 160.161C339.132 160.939 338.028 160.718 337.244 160.817Z",
    fill: "#72969B"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.282 160.817C328.552 161.84 325.664 162.712 322.003 162.81C323.606 160.649 327.988 161.282 331.282 160.817Z",
    fill: "#72969B"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.558 161.485C178.588 163.6 173.807 161.926 172.267 163.478C169.53 161.787 159.508 163.879 159.014 162.147C166.132 162.2 173.313 162.299 179.558 161.485Z",
    fill: "#72969B"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.221 162.147C180.104 161.067 184.554 160.806 183.531 162.81C181.934 163.077 182.09 161.596 180.221 162.147Z",
    fill: "#72969B"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.554 162.81C556.995 161.927 557.972 161.573 559.203 161.485C559.051 162.653 558.065 162.989 556.554 162.81Z",
    fill: "#72969B"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.092 163.478C148.225 161.294 152.669 162.426 155.702 162.147C159.107 163.083 150.403 163.113 147.092 163.478Z",
    fill: "#72969B"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.296 164.798C217.629 164.146 212.935 163.699 209.368 164.798C211.215 162.049 219.32 162.107 221.296 164.798Z",
    fill: "#72969B"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.557 162.81C230.465 164.286 226.55 163.751 222.622 164.797C224.603 162.799 228.507 162.729 232.557 162.81Z",
    fill: "#72969B"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.554 162.81C556.421 164.79 553.803 162.177 556.554 162.81Z",
    fill: "#72969B"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.447 164.135C198.783 162.293 199.359 164.129 200.097 164.135C208.021 164.21 203.396 165.599 197.447 164.135Z",
    fill: "#72969B"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.555 164.134C234.34 162.961 238.261 162.955 237.204 164.797C236.612 164.286 235.706 164.082 234.555 164.134Z",
    fill: "#72969B"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.588 164.135C552.6 163.49 553.39 163.617 553.907 163.478C553.89 164.111 553.1 163.983 552.588 164.135Z",
    fill: "#72969B"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.388 164.797C207.818 165.227 207.104 164.513 207.388 164.797Z",
    fill: "#72969B"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.359 164.135C584.159 166.168 581.294 163.304 588.359 164.135Z",
    fill: "#72969B"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.148 164.798C622.166 164.153 622.956 164.286 623.479 164.135C623.455 164.774 622.659 164.646 622.148 164.798Z",
    fill: "#72969B"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.814 166.122H238.522C237.587 165.994 246.034 163.426 245.814 166.122Z",
    fill: "#72969B"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.483 165.459C249.839 167.266 248.94 163.147 246.483 165.459Z",
    fill: "#72969B"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.783 165.46C252.496 164.699 255.587 165.343 259.729 164.797C257.667 167.54 252.537 166.54 249.783 165.46Z",
    fill: "#72969B"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.021 164.797C266.272 166.61 261.549 166.79 260.393 166.122C262.013 165.099 264.703 165.128 267.021 164.797Z",
    fill: "#72969B"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.831 166.122C611.755 167.487 598.467 165.954 592.994 165.46C582.839 164.547 596.288 165.407 597.637 165.46C604.138 165.721 613.05 165.46 618.831 166.122Z",
    fill: "#72969B"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.572 168.777C174.347 167.365 169.264 170.572 166.312 169.439C168.706 168.574 176.003 166.098 177.572 168.777Z",
    fill: "#72969B"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.233 168.109C180.237 166.581 185.065 167.876 188.168 167.447C187.221 169.806 180.214 168.899 178.233 168.109Z",
    fill: "#72969B"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.216 168.109C557.652 168.544 556.932 167.836 557.216 168.109Z",
    fill: "#72969B"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.639 168.777C489.871 168.37 495.686 167.993 495.605 170.107C493.537 169.729 491.283 169.55 489.639 168.777Z",
    fill: "#72969B"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.994 169.439C163.429 169.863 162.716 169.16 162.994 169.439Z",
    fill: "#72969B"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.836 169.439C511.272 169.863 510.558 169.16 510.836 169.439Z",
    fill: "#72969B"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M663.893 189.309C665.148 190.709 667.146 191.354 669.191 191.964C664.363 194.102 671.789 197.53 667.205 199.912C668.657 201.586 667.71 202.55 668.529 203.892C667.419 206.007 667.124 201.847 664.555 203.224C663.596 203.595 662.94 204.258 662.569 205.211C664.91 209.01 669.488 202.439 669.191 208.523C667.844 210.161 666.484 206.315 664.555 208.523C664.323 212.642 666.577 211.707 668.529 212.503C669.029 214.769 665.834 213.345 666.542 215.809C665.124 215.292 662.841 214.205 661.906 215.152C661.145 217.238 662.945 216.762 663.225 217.801C665.124 217.929 666.844 217.882 666.542 215.809C668.693 216.785 666.054 219.446 668.529 219.132C667.21 220.462 665.398 221.298 664.555 223.101C664.032 225.837 667.727 224.35 667.205 227.08C665.055 227.58 664.305 229.474 663.225 231.054C663.324 232.501 664.898 232.477 666.542 232.379C663.951 235.551 666.996 238.288 666.542 242.982C665.404 243.243 664.846 241.993 664.555 242.982C664.294 247.356 667.814 243.801 668.529 246.955C667.634 248.495 663.55 246.833 663.225 248.948C663.12 250.813 667.315 248.39 667.205 250.268C667.6 254.026 664.41 250.082 663.225 252.26C663.364 254.549 666.879 253.457 668.529 254.241C668.773 256.258 666.368 255.624 665.218 256.228C665.862 259.017 665.862 260.969 666.542 264.845C659.622 263.753 647.568 263.433 641.368 264.188C639.189 263.05 639.91 259.012 636.064 259.546C638.417 257.518 635.454 257.465 636.726 254.904C626.884 252.667 618.309 255.323 607.578 254.904C610.32 253.986 608.467 252.575 610.221 250.93C623.55 252.394 629.469 251.83 639.375 251.598C640.59 249.936 639.322 249.047 640.043 246.293C626.6 244.417 605.62 246.816 594.319 244.968C592.733 244.562 589.515 245.799 589.015 244.3C612.742 244.846 635.284 244.835 658.594 243.638C656.055 240.054 646.754 242.226 642.025 241.657C637.981 241.169 640.578 241.499 637.388 242.319C632.27 243.626 625.908 241.11 620.156 242.319C620.197 241.18 619.657 240.617 618.832 240.327C629.319 242.087 646.766 238.816 659.919 238.339C657.637 236.619 656.021 237.102 652.628 237.02C651.066 236.974 648.044 235.347 646.667 236.352C650.466 233.592 653.574 239.245 658.595 235.033C651.257 233.551 635.065 234.389 625.462 235.033C633.693 232.494 655.667 234.505 661.906 231.716C651.49 228.607 636.855 231.408 625.462 231.716C634.344 228.903 647.411 230.246 657.27 228.409C657.27 225.4 652.82 226.835 656.608 225.086C657.473 225.888 657.647 225.348 658.595 225.086C658.444 224.244 656.62 224.227 656.608 225.086C648.067 224.268 640.242 226.864 630.103 223.762C634.426 220.258 641.589 225.447 644.018 221.113C644.86 221.083 644.936 220.264 646.005 220.45C645.842 221.396 644.907 221.571 644.68 222.431C646.4 222.837 647.062 222.169 646.667 220.45C650.008 220.874 655.236 221.135 654.615 217.8C656.689 217.667 659.478 218.254 660.582 217.132C659.373 215.041 657.84 215.25 657.927 213.164C653.918 212.909 650.461 213.205 647.986 214.483C650.194 215.552 658.612 215.401 650.646 215.808C637.83 216.046 629.823 214.675 616.183 215.151C621.987 212.252 637.581 216.575 642.687 213.164C640.904 211.636 636.302 212.926 633.42 212.502C631.974 212.978 629.197 211.822 632.09 211.84H637.389C646.755 211.561 659.234 212.868 663.894 209.852C649.787 206.616 627.843 210.678 609.56 208.522C625.543 206.256 645.354 209.08 661.906 205.873C658.165 203.061 660.698 201.166 657.27 196.6C656.364 198.941 658.408 201.056 658.595 205.21C657.032 205.228 656.637 204.072 654.615 204.548C655.266 203.659 656.851 203.688 657.27 202.561C655.492 199.65 654.022 197.384 653.291 191.296C638.568 190.186 660.942 191.371 660.582 189.308C657.497 184.701 653.831 189.657 649.317 187.983C651.368 186.211 647.586 185.468 649.317 184.015C652.007 183.806 657.085 187.808 657.927 183.353C650.566 180.559 638.266 182.691 628.779 182.028C628.935 181.081 629.865 180.907 630.103 180.035H626.786C625.183 178.809 631.155 179.594 632.752 179.373C632.596 180.32 631.66 180.489 631.428 181.36C634.85 181.116 634.903 181.604 636.065 179.373C637.25 179.733 638.819 179.716 639.376 180.698C639.446 181.494 638.418 181.104 639.376 180.698H640.701C641.502 180.622 641.114 181.656 640.701 180.698C640.701 180.03 641.235 179.907 641.369 179.373C646.656 181.796 655.51 180.802 660.582 180.035C659.687 179.414 654.656 177.56 659.257 177.386C656.335 174.156 648.642 177.153 644.681 176.055C649.259 173.58 658.142 175.381 663.894 174.069C660.425 170.037 652.239 172.36 646.006 172.744C630.65 173.685 608.793 173.017 594.989 172.076H577.757C575.736 171.059 580.639 171.501 581.737 171.425C602.257 171.239 619.199 171.901 637.39 170.757C647.522 170.118 658.398 167.567 666.544 171.425C665.23 173.9 667.456 175.834 664.557 176.723C665.736 177.966 668.926 177.217 668.531 180.035C665.899 179.391 666.468 181.952 665.888 183.353C666.753 185.88 669.861 182.319 669.856 186.002C669.019 185.096 666.359 184.718 667.207 187.321C665.672 187.525 666.468 185.416 665.22 185.334C663.134 185.235 664.941 189.029 661.907 187.983C661.547 189.366 664.255 192.004 663.894 189.308L663.893 189.309ZM662.569 176.725C664.218 179.311 663.538 174.529 662.569 176.725ZM663.225 180.699H664.555C665.584 179.073 662.307 178.747 662.569 180.037C662.975 180.077 663.353 180.136 663.225 180.699ZM636.064 180.699C636.499 181.129 635.785 180.42 636.064 180.699ZM660.581 183.354C662.8 181.745 658.972 185.573 660.581 183.354ZM659.918 192.627C660.355 193.051 659.64 192.348 659.918 192.627ZM661.906 193.946C661.342 193.382 660.012 194.434 659.918 194.608C659.286 195.776 662.365 194.399 661.906 193.946ZM659.918 197.269C661.888 197.274 660.767 200.395 661.906 201.242C663.928 201.719 663.853 200.098 665.886 200.574C664.706 198.117 663.858 198.785 663.893 195.938C661.988 195.799 660.523 196.101 659.918 197.269ZM662.569 203.224C662.998 203.66 662.29 202.945 662.569 203.224ZM636.064 223.762C636.499 224.197 635.785 223.483 636.064 223.762ZM661.906 225.755H663.225V224.43H661.906V225.755ZM659.256 227.079C658.745 227.231 657.95 227.097 657.926 227.741C658.444 227.59 659.233 227.724 659.256 227.079ZM662.569 235.033C662.563 234.359 661.401 234.197 661.244 235.033C661.987 234.964 662.272 235.992 662.569 235.033ZM661.906 245.63C664.126 244.032 660.303 247.849 661.906 245.63ZM644.018 251.597C644.029 250.499 645.853 251.225 646.005 250.267C643.814 249.883 645.051 247.768 645.348 246.292C643.773 246.304 643.39 245.148 641.368 245.63C640.973 248.529 642.123 249.79 644.018 251.597ZM646.005 246.292C646.9 249.156 648.868 247.936 648.648 250.929C649.891 250.842 650.868 250.499 651.303 249.599C648.59 249.913 651.321 247.937 651.303 246.954C650.42 245.775 647.475 244.904 646.005 246.292ZM652.628 246.954C654.852 248.965 654.637 244.509 652.628 246.954ZM657.926 246.292C657.415 246.437 656.625 246.304 656.607 246.954C657.118 246.798 657.909 246.937 657.926 246.292ZM638.051 255.571C639.747 255.641 639.114 258.034 640.043 258.877C641.908 259.429 641.757 257.948 643.35 258.221C643.524 256.28 641.85 256.181 642.025 254.24C640.27 254.252 638.126 253.874 638.051 255.571ZM646.005 258.221C647.759 258.209 649.897 258.586 649.978 256.895C649.009 256.32 647.41 256.367 647.986 254.24H644.68C644.36 256.326 646.713 255.745 646.005 258.221ZM652.628 255.571C654.219 253.979 650.455 253.851 650.646 254.903C650.635 254.857 652.877 255.309 652.628 255.571ZM651.965 257.558H653.952C654.039 256.366 653.296 256.006 651.965 256.227V257.558ZM649.978 259.545C649.467 259.696 648.672 259.562 648.648 260.202C649.171 260.063 649.962 260.19 649.978 259.545ZM641.368 262.194H642.687V260.869H641.368V262.194ZM648.647 262.194C649.617 261.827 652.075 262.967 651.965 261.531C651.123 260.631 648.717 260.508 648.647 262.194Z",
    fill: "#72969B"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.849 171.426C181.289 172.57 172.934 172.309 169.623 172.077C174.933 170.357 182.184 171.415 186.849 171.426Z",
    fill: "#72969B"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.332 172.077C162.762 172.518 162.054 171.811 162.332 172.077Z",
    fill: "#72969B"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.451 172.078C574.462 171.444 575.258 171.572 575.77 171.426C575.752 172.071 574.956 171.938 574.451 172.078Z",
    fill: "#72969B"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.702 172.745C154.452 172.606 154.244 173.495 153.053 173.407C153.216 172.24 154.191 171.897 155.702 172.077V172.745Z",
    fill: "#72969B"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.366 172.745C157.335 172.339 156.296 171.95 156.366 172.745Z",
    fill: "#72969B"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.014 172.745C159.038 172.101 159.828 172.234 160.345 172.077C160.328 172.729 159.531 172.606 159.014 172.745Z",
    fill: "#72969B"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.796 173.407C139.825 172.763 140.616 172.896 141.126 172.745C141.109 173.39 140.325 173.257 139.796 173.407Z",
    fill: "#72969B"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.45 173.407C142.468 172.763 143.264 172.896 143.78 172.745C143.757 173.39 142.967 173.257 142.45 173.407Z",
    fill: "#72969B"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.756 173.407C148.041 171.926 151.022 173.14 152.392 172.745C152.107 174.233 149.127 173.018 147.756 173.407Z",
    fill: "#72969B"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.705 172.745H156.366C156.366 173.117 155.833 173.5 155.705 172.745Z",
    fill: "#72969B"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.149 174.732C192.084 173.693 190.452 174.215 190.818 172.745C193.449 171.624 195.906 175.284 192.149 174.732Z",
    fill: "#72969B"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.402 172.745C204.717 174.273 202.352 174.122 200.098 174.07C201.324 173.089 203.247 172.804 205.402 172.745Z",
    fill: "#72969B"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.476 174.07C138.911 174.505 138.203 173.792 138.476 174.07Z",
    fill: "#72969B"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.123 174.733C196.326 173.832 197.784 174.187 198.777 174.071C198.569 174.97 197.116 174.616 196.123 174.733Z",
    fill: "#72969B"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.148 174.733C192.287 175.483 192.88 175.766 193.478 176.057C186.878 177.376 179.332 176.731 173.591 177.388C177.269 173.995 188.238 177.893 192.148 174.733Z",
    fill: "#72969B"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.622 176.725C169.431 175.668 173.201 175.796 171.609 177.387C171.859 177.131 169.611 176.679 169.622 176.725Z",
    fill: "#72969B"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.148 176.725C627.453 175.18 635.622 176.504 642.024 176.057C637.649 177.939 629.248 176.086 622.148 176.725Z",
    fill: "#72969B"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.686 176.725C643.121 177.155 642.413 176.446 642.686 176.725Z",
    fill: "#72969B"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.066 177.388C150.223 177.417 150.154 178.235 149.085 178.044C148.992 176.853 149.741 176.505 151.066 176.725V177.388Z",
    fill: "#72969B"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.663 177.388C161.687 176.743 162.483 176.871 162.994 176.725C162.976 177.369 162.18 177.236 161.663 177.388Z",
    fill: "#72969B"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.658 177.388C163.541 175.947 166.01 177.085 166.963 176.725C167.08 178.16 164.616 177.027 163.658 177.388Z",
    fill: "#72969B"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.45 178.044C142.56 177.271 143.659 177.487 144.442 177.388C144.337 178.16 143.233 177.939 142.45 178.044Z",
    fill: "#72969B"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.755 178.044C148.184 178.485 147.476 177.771 147.755 178.044Z",
    fill: "#72969B"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.066 177.388C156.027 176.586 153.203 179.415 151.066 177.388Z",
    fill: "#72969B"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.647 178.706C650.006 177.184 654.161 178.474 656.607 178.044C655.247 179.567 651.099 178.283 648.647 178.706Z",
    fill: "#72969B"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.817 179.375C190.939 182.222 175.648 180.2 182.869 180.037C185.396 179.822 188.62 177.823 190.817 179.375Z",
    fill: "#72969B"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.654 180.037C210.694 181.135 200.102 181.135 194.13 180.037C198.109 178.597 208.021 180.705 216.654 180.037Z",
    fill: "#72969B"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.943 178.706C595.133 180.31 582.339 178.869 594.319 178.706C596.544 178.689 598.985 178.736 600.943 178.706Z",
    fill: "#72969B"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.655 180.037C220.907 180.803 218.113 178.015 216.655 180.037Z",
    fill: "#72969B"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.972 180.037C219.863 178.603 222.325 179.735 223.284 179.375C223.406 180.815 220.936 179.676 219.972 180.037Z",
    fill: "#72969B"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.526 180.037C405.37 178.619 409.519 180.287 415.428 180.037C411.152 181.647 404.058 180.368 399.526 180.037Z",
    fill: "#72969B"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M602.939 180.037C603.852 178.526 607.553 179.794 609.557 179.375C608.645 180.886 604.95 179.624 602.939 180.037Z",
    fill: "#72969B"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.532 179.375C612.085 181.39 609.297 178.608 613.532 179.375Z",
    fill: "#72969B"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.201 180.037C614.09 178.603 616.547 179.735 617.511 179.375C617.622 180.815 615.159 179.676 614.201 180.037Z",
    fill: "#72969B"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.18 180.037C618.279 179.265 619.383 179.474 620.155 179.375C620.056 180.147 618.953 179.926 618.18 180.037Z",
    fill: "#72969B"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.487 180.037C621.596 179.265 622.695 179.474 623.479 179.375C623.375 180.147 622.27 179.926 621.487 180.037Z",
    fill: "#72969B"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.61 180.699C171.622 180.055 172.412 180.176 172.93 180.037C172.918 180.676 172.123 180.554 171.61 180.699Z",
    fill: "#72969B"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.583 180.699C175.659 179.229 178.383 180.415 179.558 180.037C179.477 181.495 176.745 180.322 175.583 180.699Z",
    fill: "#72969B"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.1 181.361C150.166 179.84 158.404 180.868 163.656 181.361C158.974 182.506 149.806 182.407 145.1 181.361Z",
    fill: "#72969B"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.942 180.699C170.797 182.762 167.648 181.815 165.643 182.029C166.7 180.867 168.624 180.589 170.942 180.699Z",
    fill: "#72969B"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.965 181.361C325.759 183.39 322.894 180.519 329.965 181.361Z",
    fill: "#72969B"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.141 182.029C624.907 184.638 624.907 179.403 624.141 182.029Z",
    fill: "#72969B"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.145 182.685C139.575 183.12 138.861 182.407 139.145 182.685Z",
    fill: "#72969B"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.792 182.685C141.903 181.901 143.001 182.127 143.779 182.029C143.675 182.795 142.565 182.581 141.792 182.685Z",
    fill: "#72969B"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.283 182.685C331.718 183.12 331.005 182.407 331.283 182.685Z",
    fill: "#72969B"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.575 183.354C122.593 182.71 123.389 182.837 123.906 182.686C123.883 183.331 123.093 183.204 122.575 183.354Z",
    fill: "#72969B"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.55 183.354C126.985 183.784 126.272 183.076 126.55 183.354Z",
    fill: "#72969B"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.604 183.354C332.627 182.71 333.423 182.837 333.934 182.686C333.922 183.331 333.127 183.204 332.604 183.354Z",
    fill: "#72969B"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.962 183.354C491.171 182.442 492.617 182.796 493.605 182.686C493.408 183.581 491.955 183.232 490.962 183.354Z",
    fill: "#72969B"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.8 185.335C184.928 184.58 179.235 187.171 170.282 185.335C169.184 185.254 164.286 185.696 166.313 184.673H171.612C178.689 187.624 189.472 181.006 194.8 185.335Z",
    fill: "#72969B"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.228 183.354C494.826 185.33 493.466 182.523 502.228 183.354Z",
    fill: "#72969B"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.552 184.016C503.657 183.232 504.761 183.453 505.533 183.354C505.434 184.121 504.331 183.912 503.552 184.016Z",
    fill: "#72969B"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2715 184.673C11.2832 184.028 12.0734 184.156 12.5907 184.016C12.5731 184.649 11.7838 184.527 11.2715 184.673Z",
    fill: "#72969B"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5748 184.673C15.0156 185.102 14.3022 184.4 14.5748 184.673Z",
    fill: "#72969B"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5676 184.673C16.3526 183.505 20.279 183.494 19.2162 185.335C18.6296 184.823 17.7233 184.627 16.5676 184.673Z",
    fill: "#72969B"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.781 184.673C573.885 188.013 552.133 183.917 562.521 184.673C563.242 184.73 571.237 184.632 573.781 184.673Z",
    fill: "#72969B"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.576 184.673C598.548 188.368 588.281 183.128 579.752 185.335C584.859 182.146 598.303 185.637 607.576 184.673Z",
    fill: "#72969B"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8809 185.335C19.9043 184.69 20.6886 184.824 21.2059 184.673C21.1884 185.317 20.3982 185.19 19.8809 185.335Z",
    fill: "#72969B"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5293 185.335C22.6105 183.877 25.3418 185.05 26.5095 184.673C26.4225 186.131 23.6911 184.951 22.5293 185.335Z",
    fill: "#72969B"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4909 185.335C28.9258 185.77 28.2124 185.051 28.4909 185.335Z",
    fill: "#72969B"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.451 185.335C142.886 185.77 142.179 185.051 142.451 185.335Z",
    fill: "#72969B"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.092 185.335C147.109 184.69 147.905 184.824 148.417 184.673C148.393 185.317 147.604 185.19 147.092 185.335Z",
    fill: "#72969B"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.027 186.004C160.99 183.098 167.863 185.451 159.015 185.336C158.486 185.33 157.94 186.306 157.027 186.004Z",
    fill: "#72969B"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.304 185.335C543.739 185.77 543.025 185.051 543.304 185.335Z",
    fill: "#72969B"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.451 185.335C574.526 183.877 577.257 185.05 578.425 184.673C578.338 186.131 575.613 184.951 574.451 185.335Z",
    fill: "#72969B"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.884 185.335C610.907 184.69 611.697 184.824 612.214 184.673C612.19 185.317 611.4 185.19 610.884 185.335Z",
    fill: "#72969B"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.025 185.335C642.048 184.69 642.839 184.824 643.35 184.673C643.338 185.317 642.548 185.19 642.025 185.335Z",
    fill: "#72969B"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.005 185.335C646.022 184.69 646.819 184.824 647.329 184.673C647.312 185.317 646.515 185.19 646.005 185.335Z",
    fill: "#72969B"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.127 185.335C140.453 186.868 138.088 186.706 135.828 186.665C136.885 185.515 138.808 185.224 141.127 185.335Z",
    fill: "#72969B"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.384 186.004C154.814 186.428 154.1 185.719 154.384 186.004Z",
    fill: "#72969B"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.18 186.004C618.261 184.54 620.987 185.719 622.149 185.336C622.067 186.794 619.342 185.62 618.18 186.004Z",
    fill: "#72969B"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.711 185.335C636.58 187.362 633.757 184.539 638.711 185.335Z",
    fill: "#72969B"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8291 186.665C27.8291 186.294 28.3636 185.911 28.4915 186.665H27.8291Z",
    fill: "#72969B"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3843 186.004C47.5056 185.76 47.6337 186.521 47.7082 187.323C47.1391 187.2 47.0814 187.584 47.0404 187.985C46.268 187.88 46.4889 186.783 46.3843 186.004Z",
    fill: "#72969B"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.479 186.004H200.759C199.644 186.765 193.967 188.909 193.479 186.004Z",
    fill: "#72969B"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.116 186.666C628.133 186.01 628.929 186.148 629.441 186.004C629.423 186.642 628.627 186.515 628.116 186.666Z",
    fill: "#72969B"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2042 186.666C23.4877 188.368 17.7932 188.264 21.2042 186.666Z",
    fill: "#72969B"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8275 186.666C27.7581 188.351 25.6143 187.973 23.854 187.985C24.522 186.887 26.6716 187.264 27.8275 186.666Z",
    fill: "#72969B"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4899 186.666C29.4079 186.637 29.9418 186.974 30.4766 187.323C30.7435 188.607 27.4673 188.299 28.4899 186.666Z",
    fill: "#72969B"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.038 186.666C207.899 188.688 205.077 185.87 210.038 186.666Z",
    fill: "#72969B"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.673 187.322C215.103 187.757 214.395 187.049 214.673 187.322Z",
    fill: "#72969B"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.317 187.322C219.329 186.678 220.118 186.811 220.641 186.665C220.618 187.305 219.828 187.176 219.317 187.322Z",
    fill: "#72969B"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5762 187.984C14.8666 186.503 17.8474 187.723 19.2185 187.322C18.9281 188.804 15.9531 187.589 14.5762 187.984Z",
    fill: "#72969B"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.696 187.984C50.1318 188.42 49.4117 187.706 49.696 187.984Z",
    fill: "#72969B"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.851 187.984C616.961 187.212 618.059 187.432 618.832 187.322C618.733 188.106 617.629 187.879 616.851 187.984Z",
    fill: "#72969B"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.737 188.646C634.761 188.002 635.551 188.135 636.062 187.984C636.045 188.635 635.249 188.496 634.737 188.646Z",
    fill: "#72969B"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.171 189.309C565.6 189.744 564.892 189.031 565.171 189.309Z",
    fill: "#72969B"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M569.145 188.646C567.693 190.674 564.905 187.886 569.145 188.646Z",
    fill: "#72969B"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M569.807 188.646C577.708 189.803 587.126 189.442 594.319 191.297C585.877 190.692 576.343 191.163 569.807 188.646Z",
    fill: "#72969B"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M663.894 189.309C663.488 188.345 663.098 189.378 663.894 189.309Z",
    fill: "#72969B"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8735 191.296C26.6264 189.414 36.4276 189.849 40.4187 189.971C41.7488 190.017 49.017 190.151 44.3981 190.639C36.9089 191.418 30.9423 190.663 21.8735 191.296Z",
    fill: "#72969B"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3672 190.639C48.4777 189.861 49.5756 190.082 50.3597 189.971C50.2492 190.744 49.1513 190.535 48.3672 190.639Z",
    fill: "#72969B"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.309 190.639C435.327 189.995 436.117 190.122 436.634 189.971C436.617 190.623 435.821 190.483 435.309 190.639Z",
    fill: "#72969B"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8877 190.639C18.8802 190.744 20.3388 190.396 20.5472 191.296C19.548 191.186 18.0961 191.54 17.8877 190.639Z",
    fill: "#72969B"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9818 190.639C55.5299 192.661 52.7415 189.873 56.9818 190.639Z",
    fill: "#72969B"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.384 191.296C154.814 191.731 154.1 191.018 154.384 191.296Z",
    fill: "#72969B"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.987 191.296C598.084 190.361 607.781 190.465 610.883 191.296C605.067 193.371 600.1 191.947 594.987 191.296Z",
    fill: "#72969B"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.18 190.639C617.751 193.033 614.997 190.454 612.214 191.296C610.598 190.07 616.577 190.85 618.18 190.639Z",
    fill: "#72969B"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.831 191.297C624.124 189.803 629.643 191.157 622.148 191.297C620.533 191.331 620.749 192.581 618.831 191.297Z",
    fill: "#72969B"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.759 191.296C633.275 189.861 637.144 190.953 638.713 191.296C636.18 192.476 632.944 191.662 630.759 191.296Z",
    fill: "#72969B"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M645.346 190.639H646.665V191.964H645.346V190.639Z",
    fill: "#72969B"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.691 191.964C162.885 190.936 173.046 192.389 164.32 193.283C161.909 193.539 162.013 192.231 159.015 193.283C157.888 193.533 157.766 192.771 157.691 191.964Z",
    fill: "#72969B"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.909 192.626C177.873 192.214 176.833 191.825 176.909 192.626Z",
    fill: "#72969B"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.233 191.964C184.107 192.476 192.246 191.238 198.776 192.626C195.07 193.905 182.636 194.201 178.233 191.964Z",
    fill: "#72969B"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.041 193.283C372.807 191.969 376.885 192.946 378.988 191.964C378.378 194.44 373.673 192.824 371.041 193.283Z",
    fill: "#72969B"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.651 192.626C379.768 191.848 380.866 192.063 381.638 191.964C381.539 192.737 380.43 192.516 379.651 192.626Z",
    fill: "#72969B"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7389 193.283C97.168 193.719 96.4604 193.01 96.7389 193.283Z",
    fill: "#72969B"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.908 192.627C173.4 194.653 170.542 191.796 176.908 192.627Z",
    fill: "#72969B"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.041 193.283C369.542 194.521 363.982 194.189 362.431 193.283C364.255 191.708 367.677 194.189 371.041 193.283Z",
    fill: "#72969B"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3656 193.283C46.9187 195.305 44.1254 192.528 48.3656 193.283Z",
    fill: "#72969B"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.716 193.946C153.733 193.301 154.524 193.44 155.041 193.283C155.023 193.927 154.233 193.8 153.716 193.946Z",
    fill: "#72969B"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.199 193.946C614.628 194.381 613.92 193.678 614.199 193.946Z",
    fill: "#72969B"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.783 193.283C625.331 195.305 622.537 192.528 626.783 193.283Z",
    fill: "#72969B"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.316 193.946C649.334 193.301 650.124 193.44 650.646 193.283C650.623 193.927 649.828 193.8 649.316 193.946Z",
    fill: "#72969B"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.116 194.608C629.464 193.091 633.612 194.37 636.064 193.946C634.715 195.468 630.562 194.189 628.116 194.608Z",
    fill: "#72969B"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M637.387 194.608C638.526 193.091 642.441 194.37 644.679 193.946C643.54 195.463 639.625 194.189 637.387 194.608Z",
    fill: "#72969B"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.311 195.938C595.905 194.974 595.511 196.008 596.311 195.938Z",
    fill: "#72969B"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.759 196.601C200.656 197.374 199.551 197.158 198.778 197.269C196.292 197.716 199.26 199.47 196.786 199.912C194.648 200.505 195.856 197.757 194.799 197.269C191.824 198.448 180.373 198.366 184.196 197.269H192.149C193.985 194.782 196.931 197.303 200.759 196.601Z",
    fill: "#72969B"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.312 195.938C597.114 195.874 596.719 196.896 596.312 195.938Z",
    fill: "#72969B"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.961 196.601C600.972 193.893 613.573 197.687 614.863 197.269C610.058 198.832 602.849 195.252 598.961 196.601Z",
    fill: "#72969B"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.316 195.938C648.566 197.949 645.162 196.938 641.368 197.269C633.582 196.851 646.794 196.246 649.316 195.938Z",
    fill: "#72969B"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.645 196.601C650.657 195.957 651.447 196.084 651.964 195.938C651.941 196.583 651.157 196.444 650.645 196.601Z",
    fill: "#72969B"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.917 197.269C175.417 196.165 180.384 196.165 180.884 197.269C179.112 198.959 177.392 196.862 174.917 197.269Z",
    fill: "#72969B"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.183 197.269C618.194 195.73 623.027 197.03 626.13 196.601C624.125 198.129 619.297 196.827 616.183 197.269Z",
    fill: "#72969B"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.089 197.269C633.74 199.849 633.053 195.067 632.089 197.269Z",
    fill: "#72969B"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9957 197.925C55.4248 198.361 54.7172 197.652 54.9957 197.925Z",
    fill: "#72969B"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M712.923 197.269C712.702 199.255 711.912 200.667 710.273 201.243C710.215 200.185 710.587 198.71 709.611 198.593C710.169 197.605 711.743 197.629 712.923 197.269Z",
    fill: "#72969B"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2222 198.593C73.2967 198.402 73.3603 199.215 74.203 199.244C74.4758 200.534 71.1937 200.22 72.2222 198.593Z",
    fill: "#72969B"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.777 199.244C199.69 197.74 203.385 199.007 205.401 198.593C204.477 200.098 200.782 198.832 198.777 199.244Z",
    fill: "#72969B"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.712 199.244C208.997 197.769 211.977 198.977 213.348 198.593C213.064 200.063 210.083 198.86 208.712 199.244Z",
    fill: "#72969B"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.971 199.244C220.081 198.472 221.179 198.692 221.963 198.593C221.853 199.36 220.755 199.146 219.971 199.244Z",
    fill: "#72969B"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.978 199.244C647.776 201.248 639.364 198.803 647.328 199.244C649.136 199.314 648.659 198.146 649.978 199.244Z",
    fill: "#72969B"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M653.288 198.593C652.852 199.476 651.876 199.819 650.644 199.912C650.796 198.751 651.777 198.402 653.288 198.593Z",
    fill: "#72969B"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.52 199.912C615.543 199.274 616.333 199.395 616.85 199.244C616.826 199.889 616.036 199.767 615.52 199.912Z",
    fill: "#72969B"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.375 199.912C639.265 198.484 641.727 199.61 642.686 199.244C642.088 200.406 640.368 200.958 639.375 199.912Z",
    fill: "#72969B"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.776 200.574C628.886 199.802 629.985 200.011 630.757 199.912C630.653 200.685 629.549 200.476 628.776 200.574Z",
    fill: "#72969B"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M637.387 200.574C637.405 199.93 638.201 200.063 638.712 199.912C638.695 200.557 637.899 200.43 637.387 200.574Z",
    fill: "#72969B"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M707.624 201.242C707.636 200.598 708.431 200.719 708.949 200.574C708.926 201.219 708.135 201.092 707.624 201.242Z",
    fill: "#72969B"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M716.232 200.574C718.341 201.586 719.148 200.807 721.536 200.574C722.169 202.84 715.238 204.066 716.232 200.574Z",
    fill: "#72969B"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.034 202.561C699.361 203.119 697.671 199.46 695.034 202.561Z",
    fill: "#72969B"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M702.317 201.894C702.747 202.334 702.045 201.621 702.317 201.894Z",
    fill: "#72969B"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.302 201.894C119.862 203.904 135.688 202.399 146.424 201.894C162.151 201.167 178.826 204.252 192.148 203.224C198.643 202.725 207.805 202.532 214.016 203.224C192.077 204.996 172.023 204.002 155.703 205.211C155.906 204.101 156.661 204.235 155.04 203.892C141.48 201.028 123.208 207.273 112.634 207.204C110.484 211.265 111.623 215.494 107.998 217.132C105.656 215 111.211 213.67 107.998 213.164C105.936 215.493 104.913 216.696 102.037 218.463C103.698 220.671 107.846 218.353 111.31 218.463C112.349 216.412 112.925 213.885 115.289 213.164C113.884 218.033 117.218 216.609 115.957 220.45C119.792 221.246 126.862 218.806 128.536 221.781C118.543 220.7 103.03 222.187 94.0889 223.1C96.8662 221.374 95.7915 220.468 96.0702 218.463C98.1788 219.712 98.8467 218.294 101.375 219.131C101.863 215.169 99.2309 218.185 98.7245 215.808C101.496 216.069 99.4452 213.409 98.7245 213.164C99.7642 213.1 101.02 213.258 100.712 211.84C100.392 209.068 98.4399 207.918 97.4003 205.873C100.869 202.683 106.295 203.857 109.984 202.561C110.861 202.572 110.588 203.717 111.309 203.891C111.953 203.211 112.622 202.549 113.301 201.893L113.302 201.894ZM106.011 208.522C108.242 206.924 104.413 210.747 106.011 208.522ZM108.66 209.19H109.984V207.865H108.66V209.19ZM104.686 211.178C106.911 209.568 103.088 213.397 104.686 211.178ZM104.029 214.483C104.459 214.919 103.744 214.216 104.029 214.483Z",
    fill: "#72969B"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.296 202.562C221.319 201.917 222.11 202.044 222.62 201.894C222.608 202.545 221.813 202.411 221.296 202.562Z",
    fill: "#72969B"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.033 202.562C605.31 202.156 626.36 202.108 642.686 203.892C641.384 205.78 636.347 203.991 634.076 203.892C619.063 203.212 599.373 204.008 587.033 202.562Z",
    fill: "#72969B"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.647 201.894C647.944 202.521 648.449 204.345 646.666 203.891C647.374 203.275 646.875 201.44 648.647 201.894Z",
    fill: "#72969B"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M690.396 202.562C690.478 201.098 693.203 202.283 694.371 201.894C694.29 203.364 691.558 202.178 690.396 202.562Z",
    fill: "#72969B"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.336 203.224C215.446 202.451 216.544 202.666 217.317 202.562C217.218 203.346 216.115 203.12 215.336 203.224Z",
    fill: "#72969B"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.647 204.549C650.234 203.591 649.84 204.618 650.647 204.549Z",
    fill: "#72969B"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.645 204.549C651.54 204.345 651.9 203.608 653.289 203.892C653.956 205.878 651.813 205.065 650.645 205.211V204.549Z",
    fill: "#72969B"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.329 205.211C647.346 204.572 648.136 204.694 648.648 204.549C648.642 205.2 647.846 205.066 647.329 205.211Z",
    fill: "#72969B"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M722.863 205.211C725.779 202.783 725.378 207.04 722.863 205.211Z",
    fill: "#72969B"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7183 205.211H47.0425V206.542H45.7183V205.211Z",
    fill: "#72969B"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7092 205.873C47.4942 204.705 51.4156 204.688 50.3587 206.541C48.9704 206.819 48.5988 206.087 47.7092 205.873Z",
    fill: "#72969B"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.249 205.873C229.684 206.314 228.971 205.6 229.249 205.873Z",
    fill: "#72969B"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.696 205.211C593.005 205.444 590.153 208.296 587.696 205.211Z",
    fill: "#72969B"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0161 206.542C52.1554 205.025 56.0703 206.297 58.3078 205.874C57.1752 207.396 53.2536 206.117 51.0161 206.542Z",
    fill: "#72969B"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2735 205.873C60.8274 207.9 58.0391 205.106 62.2735 205.873Z",
    fill: "#72969B"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7456 206.542C95.5182 209.156 95.5182 203.921 94.7456 206.542Z",
    fill: "#72969B"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.965 206.542C222.395 206.971 221.681 206.269 221.965 206.542Z",
    fill: "#72969B"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.614 206.542C225.044 206.971 224.335 206.269 224.614 206.542Z",
    fill: "#72969B"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.459 207.204C181.963 210.969 160.78 208.36 147.092 209.853C158.764 206.211 179.47 209.127 195.459 207.204Z",
    fill: "#72969B"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.686 207.204C212.704 206.559 213.488 206.687 214.016 206.542C213.993 207.186 213.197 207.053 212.686 207.204Z",
    fill: "#72969B"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.999 207.204C216.016 206.559 216.812 206.687 217.317 206.542C217.312 207.186 216.516 207.053 215.999 207.204Z",
    fill: "#72969B"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.333 207.204C592.442 206.426 593.541 206.641 594.319 206.542C594.215 207.314 593.111 207.105 592.333 207.204Z",
    fill: "#72969B"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.7 207.866C211.136 208.296 210.421 207.588 210.7 207.866Z",
    fill: "#72969B"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.637 207.866C597.84 206.966 599.292 207.314 600.291 207.204C600.082 208.099 598.624 207.756 597.637 207.866Z",
    fill: "#72969B"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.897 207.204C608.164 209.871 605.248 206.931 602.273 207.866C600.833 206.588 607.118 207.448 608.897 207.204Z",
    fill: "#72969B"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0864 209.19C41.3183 208.435 42.2483 207.505 42.4048 208.522H58.3065C54.5414 210.062 47.9361 208.754 43.0678 209.19H41.0864Z",
    fill: "#72969B"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1339 209.19C33.563 209.62 32.8554 208.906 33.1339 209.19Z",
    fill: "#72969B"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4363 208.522C35.6019 210.555 32.7667 207.715 38.4363 208.522Z",
    fill: "#72969B"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0938 209.19C39.1113 208.546 39.9074 208.673 40.4188 208.522C40.4012 209.167 39.6111 209.04 39.0938 209.19Z",
    fill: "#72969B"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.614 209.852C118.775 207.778 114.266 208.737 116.614 209.852Z",
    fill: "#72969B"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.397 209.19C474.833 209.62 474.119 208.906 474.397 209.19Z",
    fill: "#72969B"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.033 208.522C693.581 210.549 690.793 207.767 695.033 208.522Z",
    fill: "#72969B"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8437 209.852C79.8131 209.446 78.7801 209.046 78.8437 209.852Z",
    fill: "#72969B"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.896 209.852C395.325 210.287 394.611 209.568 394.896 209.852Z",
    fill: "#72969B"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.877 209.852C396.987 209.08 398.086 209.289 398.864 209.19C398.759 209.963 397.656 209.748 396.877 209.852Z",
    fill: "#72969B"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.614 209.852C117.508 212.438 124.242 209.179 125.886 210.515C122.208 213.547 117.211 211.485 113.958 212.502C114.109 211.99 113.981 211.195 114.625 211.177C114.748 211.927 115.288 211.543 115.288 211.177C116.031 211.038 116.317 210.439 116.614 209.852Z",
    fill: "#72969B"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.692 209.852C321.725 210.137 324.31 210.857 327.97 210.515C327.29 212.449 318.402 213.094 318.692 209.852Z",
    fill: "#72969B"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.62 210.515C330.637 209.871 331.433 210.004 331.95 209.853C331.926 210.492 331.136 210.365 330.62 210.515Z",
    fill: "#72969B"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.195 210.515C400.276 209.046 403.001 210.231 404.169 209.853C404.082 211.317 401.351 210.138 400.195 210.515Z",
    fill: "#72969B"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M709.608 209.853C709.475 212.147 705.954 211.055 704.304 211.84C704.269 209.376 707.25 209.935 709.608 209.853Z",
    fill: "#72969B"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0889 211.177C94.1064 210.533 94.8966 210.66 95.4081 210.515C95.3964 211.159 94.6012 211.032 94.0889 211.177Z",
    fill: "#72969B"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.628 211.177C114.628 210.811 115.162 210.422 115.29 211.177H114.628Z",
    fill: "#72969B"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.539 211.177C722.455 208.744 722.06 213.007 719.539 211.177Z",
    fill: "#72969B"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0547 211.84C45.1417 210.376 47.8722 211.561 49.0341 211.178C48.9529 212.641 46.2216 211.462 45.0547 211.84Z",
    fill: "#72969B"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0864 214.483C48.255 213.803 48.8887 211.892 54.333 211.178C52.7174 212.735 55.0763 212.665 55.658 213.832C50.2606 213.187 45.286 216.098 41.0864 214.483Z",
    fill: "#72969B"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6441 211.84C58.079 212.269 57.3714 211.561 57.6441 211.84Z",
    fill: "#72969B"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4007 211.84C97.8356 212.269 97.1163 211.561 97.4007 211.84Z",
    fill: "#72969B"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.28 213.833C177.792 214.111 188.801 210.335 199.434 212.503C190.37 211.404 181.393 215.494 170.28 214.484V213.833Z",
    fill: "#72969B"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.128 212.502C626.557 212.937 625.85 212.223 626.128 212.502Z",
    fill: "#72969B"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6457 213.833C57.5352 212.386 59.9981 213.531 60.9562 213.165C61.0667 214.6 58.6097 213.467 57.6457 213.833Z",
    fill: "#72969B"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.158 213.833C137.588 214.257 136.88 213.548 137.158 213.833Z",
    fill: "#72969B"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.291 213.164C168.001 213.971 167.449 214.524 166.311 214.483C166.589 213.676 167.152 213.124 168.291 213.164Z",
    fill: "#72969B"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.278 213.832C170.144 211.842 167.526 214.459 170.278 213.832Z",
    fill: "#72969B"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.746 215.151C202.38 213.681 204.012 214.204 204.076 213.164C206.731 213.815 209.886 213.972 213.349 213.832C216.44 213.356 216.44 214.959 213.349 214.483C209.602 215.221 205.465 215.285 202.746 215.151Z",
    fill: "#72969B"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.06 213.833C584.849 212.299 589.451 213.589 592.333 213.165C593.593 214.466 587.022 213.56 585.047 213.833C584.175 214.624 584.001 214.083 583.06 213.833Z",
    fill: "#72969B"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.905 213.833C122.441 215.849 119.659 213.06 123.905 213.833Z",
    fill: "#72969B"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.548 214.483C126.665 213.711 127.763 213.931 128.535 213.832C128.436 214.599 127.327 214.384 126.548 214.483Z",
    fill: "#72969B"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.868 214.483C130.071 213.588 131.529 213.943 132.516 213.832C132.313 214.721 130.855 214.372 129.868 214.483Z",
    fill: "#72969B"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.497 214.483C134.52 213.844 135.316 213.972 135.828 213.832C135.81 214.466 135.02 214.337 134.497 214.483Z",
    fill: "#72969B"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.78 214.483C143.798 213.844 144.594 213.972 145.099 213.832C145.088 214.466 144.292 214.337 143.78 214.483Z",
    fill: "#72969B"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.093 214.483C147.523 214.919 146.813 214.216 147.093 214.483Z",
    fill: "#72969B"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.691 214.483C159.358 212.485 166.382 214.959 159.683 214.483C158.806 215.285 158.638 214.75 157.691 214.483Z",
    fill: "#72969B"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.656 214.483C164.086 214.919 163.377 214.216 163.656 214.483Z",
    fill: "#72969B"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.974 213.833C595.521 215.849 592.728 213.06 596.974 213.833Z",
    fill: "#72969B"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.942 213.833C599.495 215.849 596.702 213.06 600.942 213.833Z",
    fill: "#72969B"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.61 214.483C601.691 213.025 604.416 214.204 605.589 213.832C605.508 215.285 602.778 214.111 601.61 214.483Z",
    fill: "#72969B"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.862 213.833C607.461 215.808 606.101 212.997 614.862 213.833Z",
    fill: "#72969B"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M714.909 213.833C710.953 216.731 704.079 214.373 712.922 214.484C713.451 214.496 714.003 213.531 714.909 213.833Z",
    fill: "#72969B"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.973 215.151C220.409 215.587 219.694 214.878 219.973 215.151Z",
    fill: "#72969B"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.207 215.151C239.522 217.318 237.895 213.258 235.207 215.151Z",
    fill: "#72969B"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.606 215.151C657.373 217.772 657.373 212.531 656.606 215.151Z",
    fill: "#72969B"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4082 215.808C95.5187 215.041 96.6166 215.25 97.4007 215.151C97.2903 215.924 96.1923 215.703 95.4082 215.808Z",
    fill: "#72969B"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.614 215.808C224.632 215.17 225.421 215.303 225.944 215.151C225.915 215.796 225.125 215.668 224.614 215.808Z",
    fill: "#72969B"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.814 215.808C246.249 216.249 245.535 215.536 245.814 215.808Z",
    fill: "#72969B"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.14 215.808C247.244 215.041 248.342 215.25 249.132 215.151C249.022 215.924 247.918 215.703 247.14 215.808Z",
    fill: "#72969B"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.114 215.808C251.137 215.17 251.927 215.303 252.439 215.151C252.427 215.796 251.625 215.668 251.114 215.808Z",
    fill: "#72969B"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.74 217.132C150.17 217.574 149.462 216.86 149.74 217.132Z",
    fill: "#72969B"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.612 217.132C172.042 217.574 171.328 216.86 171.612 217.132Z",
    fill: "#72969B"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.167 217.132C729.119 216.731 728.091 216.343 728.167 217.132Z",
    fill: "#72969B"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.907 217.8C122.081 216.964 123.226 217.132 123.238 217.8C122.946 218.76 122.657 217.731 121.907 217.8Z",
    fill: "#72969B"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.168 217.132C723.961 219.166 721.097 216.302 728.168 217.132Z",
    fill: "#72969B"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.939 218.463C118.374 218.898 117.66 218.191 117.939 218.463Z",
    fill: "#72969B"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.795 219.131C571.685 217.691 574.148 218.829 575.106 218.463C575.216 219.898 572.759 218.76 571.795 219.131Z",
    fill: "#72969B"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.431 219.131C576.46 218.48 577.25 218.614 577.756 218.463C577.744 219.108 576.949 218.981 576.431 219.131Z",
    fill: "#72969B"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.697 218.463C583.845 220.038 574.416 218.69 583.061 218.463C584.606 218.422 586.087 218.498 587.697 218.463Z",
    fill: "#72969B"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M589.684 219.131C589.701 218.48 590.491 218.614 591.014 218.463C590.99 219.108 590.194 218.981 589.684 219.131Z",
    fill: "#72969B"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.647 218.463C648.416 220.34 646.673 219.05 643.35 219.131C642.094 217.818 648.672 218.736 650.647 218.463Z",
    fill: "#72969B"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M702.98 219.793C699.151 220.311 697.322 218.829 693.702 219.131C692.657 218.498 702.933 217.191 702.98 219.793Z",
    fill: "#72969B"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.942 219.793C601.657 218.289 605.113 219.532 606.915 219.131C606.206 220.636 602.743 219.375 600.942 219.793Z",
    fill: "#72969B"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.578 219.793C609.141 218.266 613.521 219.556 616.182 219.131C614.619 220.653 610.244 219.363 607.578 219.793Z",
    fill: "#72969B"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.042 219.131C635.603 222.205 630.811 220.59 624.141 220.45C626.267 218.498 635.748 220.833 640.042 219.131Z",
    fill: "#72969B"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.871 220.45C181.308 221.978 176.928 220.688 174.261 221.113C174.883 218.813 181.238 219.637 182.871 220.45Z",
    fill: "#72969B"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.13 220.45C192.126 222.902 191.905 218.434 194.13 220.45Z",
    fill: "#72969B"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.851 220.45C617.281 220.88 616.566 220.177 616.851 220.45Z",
    fill: "#72969B"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2739 221.112C62.3902 220.34 63.4882 220.56 64.2715 220.45C64.1618 221.228 63.0639 221.014 62.2739 221.112Z",
    fill: "#72969B"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.198 221.112C129.088 219.672 131.544 220.81 132.514 220.45C131.911 221.606 130.191 222.164 129.198 221.112Z",
    fill: "#72969B"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.18 220.45C134.51 220.229 135.254 220.589 135.166 221.78H133.18V220.45Z",
    fill: "#72969B"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.268 221.781C166.122 221.368 161.305 222.292 155.705 222.432C158.848 220.636 169.706 219.782 172.268 221.781Z",
    fill: "#72969B"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.494 220.45C185.298 222.483 182.429 219.619 189.494 220.45Z",
    fill: "#72969B"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.016 221.112C643.61 220.16 643.215 221.182 644.016 221.112Z",
    fill: "#72969B"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M668.529 220.45C669.894 221.734 669.795 224.488 670.516 226.417C668.279 225.993 668.791 222.838 668.529 220.45Z",
    fill: "#72969B"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5533 221.113C74.2211 221.542 74.2336 222.64 75.5341 222.431C75.1684 224.61 72.9725 223.453 73.5533 221.113Z",
    fill: "#72969B"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.497 221.781C141.179 220.636 150.347 220.728 155.042 221.781C151.061 222.21 142.55 221.473 136.497 221.781Z",
    fill: "#72969B"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.89 223.1C716.589 224.128 712.847 223.687 709.611 223.762C710.25 221.758 719.04 221.566 718.89 223.1Z",
    fill: "#72969B"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.165 225.755C128.896 224.982 126.027 225.609 119.263 225.755C117.799 226.277 117.607 228.067 116.614 229.061C125.34 231.867 134.107 229.758 144.443 230.391C144.03 232.848 142.258 233.952 139.144 233.703C141.038 237.073 147.825 233.5 145.768 231.054C145.849 229.584 148.58 230.769 149.742 230.391C149.451 231.21 148.894 231.751 147.755 231.716C153.228 234.109 163.79 232.395 168.96 233.703C167.368 235.649 161.018 232.837 160.345 235.69C150.073 234.574 125.886 236.346 113.959 237.677C112.861 238.339 113.494 240.745 111.972 240.995C110.339 240.222 109.526 239.264 111.309 238.339C107.928 237.66 106.615 237.415 103.361 239.002C104.029 241.587 105.639 239.112 107.998 239.664C105.36 242.418 101.66 240.675 97.4008 240.995C97.9532 239.565 100.817 240.436 101.375 239.002C99.6257 236.991 97.5925 238.27 94.7456 238.339C95.1348 235.19 100.886 237.415 102.037 235.033C99.8877 232.646 98.7309 233.389 94.7456 233.041C96.8198 231.681 98.2897 231.21 102.699 231.054C102.188 230.461 101.985 229.554 102.037 228.409C100.382 228.287 99.9572 229.426 99.393 230.391C98.1148 228.88 97.0291 227.19 94.7456 228.409C98.098 220.543 110.537 228.095 117.276 223.1C121.099 227.463 132.939 220.77 135.164 225.755H135.165ZM104.029 231.054C108.724 230.368 111.362 231.048 115.289 230.391C114.028 225.917 109.09 228.73 105.348 228.409C107.677 229.537 103.687 229.74 104.029 231.054ZM113.959 235.689C118.804 235.103 127.292 236.589 131.191 233.702C127.222 234.882 118.792 232.377 113.959 235.689ZM104.687 236.351C106.203 236.2 113.081 237.792 113.302 234.37C110.014 234.614 105.233 233.371 104.687 236.351Z",
    fill: "#72969B"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.757 223.1C199.032 225.533 196.203 222.71 200.757 223.1Z",
    fill: "#72969B"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.09 223.762C202.189 222.989 203.292 223.204 204.076 223.1C203.966 223.884 202.862 223.663 202.09 223.762Z",
    fill: "#72969B"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.726 223.762C206.83 222.989 207.934 223.204 208.711 223.1C208.608 223.884 207.503 223.663 206.726 223.762Z",
    fill: "#72969B"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.7 223.762C211.136 224.197 210.421 223.483 210.7 223.762Z",
    fill: "#72969B"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.148 223.1C729.863 223.919 729.3 224.459 728.167 224.43C727.847 223.006 729.102 223.163 730.148 223.1Z",
    fill: "#72969B"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.004 223.1C752.057 226.852 747.427 222.309 742.739 224.43C743.989 221.49 750.576 223.872 754.004 223.1Z",
    fill: "#72969B"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M736.771 224.43C737.061 222.948 740.042 224.163 741.407 223.762C741.128 225.249 738.148 224.035 736.771 224.43Z",
    fill: "#72969B"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.122 224.43C179.105 228.003 156.58 225.766 137.157 225.755C153.482 223.675 177.652 226.214 196.122 224.43Z",
    fill: "#72969B"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M613.533 225.086C613.968 225.528 613.26 224.813 613.533 225.086Z",
    fill: "#72969B"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8633 226.417C77.8218 226.01 76.7938 225.61 76.8633 226.417Z",
    fill: "#72969B"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.33 226.417C697.862 228.729 696.968 224.61 700.33 226.417Z",
    fill: "#72969B"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.739 227.079C628.644 229.304 628.308 225.65 634.739 227.079Z",
    fill: "#72969B"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.979 227.079C650.089 226.301 651.187 226.522 651.965 226.417C651.861 227.19 650.757 226.974 649.979 227.079Z",
    fill: "#72969B"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M653.289 227.079C653.724 227.509 653.011 226.801 653.289 227.079Z",
    fill: "#72969B"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701 227.079C701.012 226.441 701.802 226.562 702.32 226.417C702.296 227.056 701.513 226.929 701 227.079Z",
    fill: "#72969B"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.986 227.741C595.411 228.177 594.702 227.463 594.986 227.741Z",
    fill: "#72969B"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.141 227.741C624.158 227.097 624.948 227.23 625.46 227.079C625.442 227.724 624.652 227.591 624.141 227.741Z",
    fill: "#72969B"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.452 227.741C627.882 228.177 627.173 227.463 627.452 227.741Z",
    fill: "#72969B"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M637.387 227.741C637.498 226.963 638.596 227.178 639.374 227.079C639.269 227.852 638.172 227.642 637.387 227.741Z",
    fill: "#72969B"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.042 227.741C640.054 227.097 640.85 227.23 641.367 227.079C641.344 227.724 640.548 227.591 640.042 227.741Z",
    fill: "#72969B"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.371 228.409C586.807 228.839 586.098 228.125 586.371 228.409Z",
    fill: "#72969B"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.345 228.409C590.78 228.839 590.067 228.125 590.345 228.409Z",
    fill: "#72969B"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.61 228.409C601.627 227.765 602.417 227.886 602.94 227.741C602.917 228.386 602.12 228.253 601.61 228.409Z",
    fill: "#72969B"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.589 228.409C605.7 227.625 606.798 227.846 607.576 227.741C607.471 228.514 606.362 228.305 605.589 228.409Z",
    fill: "#72969B"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.897 228.409C609.338 228.839 608.619 228.125 608.897 228.409Z",
    fill: "#72969B"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.156 228.409C620.597 228.839 619.883 228.125 620.156 228.409Z",
    fill: "#72969B"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.66 229.06C109.095 229.496 108.382 228.788 108.66 229.06Z",
    fill: "#72969B"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679.131 229.06V228.409H679.793V229.06H679.131Z",
    fill: "#72969B"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.494 229.728C189.517 229.084 190.306 229.211 190.818 229.06C190.806 229.705 190.011 229.584 189.494 229.728Z",
    fill: "#72969B"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.112 229.728C357.863 231.239 351.35 232.267 351.164 229.06C353.151 229.949 356.23 229.74 359.112 229.728Z",
    fill: "#72969B"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.112 229.729C362.622 230.444 359.897 227.713 359.112 229.729Z",
    fill: "#72969B"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.888 229.729C713.938 231.291 704.462 229.926 714.24 229.729C715.495 229.699 716.477 228.753 718.888 229.729Z",
    fill: "#72969B"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.053 230.391C153.488 230.821 152.773 230.112 153.053 230.391Z",
    fill: "#72969B"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.354 230.39C158.464 229.618 159.562 229.827 160.346 229.729C160.236 230.507 159.138 230.292 158.354 230.39Z",
    fill: "#72969B"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.665 230.391C162.101 230.821 161.392 230.112 161.665 230.391Z",
    fill: "#72969B"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.655 230.391C163.667 229.746 164.462 229.879 164.98 229.729C164.957 230.373 164.161 230.24 163.655 230.391Z",
    fill: "#72969B"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.643 230.391C167.212 228.863 171.586 230.153 174.259 229.729C172.684 231.257 168.31 229.961 165.643 230.391Z",
    fill: "#72969B"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.909 230.391C178.257 228.869 182.411 230.147 184.857 229.729C183.508 231.251 179.355 229.961 176.909 230.391Z",
    fill: "#72969B"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.673 230.391C210.821 231.652 207.934 232.587 203.407 231.716C206.69 231.083 212.204 229.694 214.673 230.391Z",
    fill: "#72969B"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.251 229.729C226.294 230.984 219.508 231.89 215.999 230.391C221.146 230.896 224.411 229.531 229.251 229.729Z",
    fill: "#72969B"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.538 230.391C236.619 228.921 239.35 230.112 240.512 229.729C240.437 231.193 237.705 230.007 236.538 230.391Z",
    fill: "#72969B"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M726.168 231.054C726.192 230.402 726.988 230.542 727.499 230.391C727.481 231.03 726.692 230.908 726.168 231.054Z",
    fill: "#72969B"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M723.525 231.716C723.63 230.949 724.727 231.158 725.512 231.054C725.402 231.832 724.303 231.611 723.525 231.716Z",
    fill: "#72969B"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.479 233.04C193.491 232.395 194.281 232.528 194.798 232.377C194.775 233.028 193.985 232.888 193.479 233.04Z",
    fill: "#72969B"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.703 232.378C697.898 233.041 702.901 230.914 702.983 233.703C700.774 233.041 695.779 235.173 695.703 232.378Z",
    fill: "#72969B"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6377 233.04H60.2943C60.2943 233.405 59.7598 233.789 59.6377 233.04Z",
    fill: "#72969B"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.571 233.04C173.887 236.276 170.68 233.068 177.571 233.04Z",
    fill: "#72969B"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.148 233.04C190.69 235.067 187.908 232.273 192.148 233.04Z",
    fill: "#72969B"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M569.807 233.702C578.743 232.668 598.374 233.824 608.896 235.032C595.701 234.998 581.792 234.301 569.807 233.702Z",
    fill: "#72969B"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M738.759 234.371C736.783 235.695 732.513 234.737 729.486 235.033C730.13 233.022 738.91 232.831 738.759 234.371Z",
    fill: "#72969B"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6709 234.371C53.6651 233.999 54.2104 233.615 54.3325 234.371H53.6709Z",
    fill: "#72969B"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.891 234.371C178.978 232.907 181.702 234.086 182.87 233.703C182.789 235.167 180.058 233.982 178.891 234.371Z",
    fill: "#72969B"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6699 234.371C54.3022 237.111 51.6842 234.505 53.6699 234.371Z",
    fill: "#72969B"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3335 234.371C55.1348 234.302 54.7458 235.329 54.3335 234.371Z",
    fill: "#72969B"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6577 235.033C55.8611 234.127 57.313 234.48 58.3063 234.371C58.1088 235.265 56.6452 234.916 55.6577 235.033Z",
    fill: "#72969B"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.221 235.033C610.924 233.522 614.393 234.772 616.183 234.371C615.48 235.869 612.023 234.621 610.221 235.033Z",
    fill: "#72969B"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.851 235.033C616.869 234.388 617.658 234.51 618.181 234.371C618.158 235.015 617.362 234.876 616.851 235.033Z",
    fill: "#72969B"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.14 234.371C620.626 236.392 617.774 233.546 624.14 234.371Z",
    fill: "#72969B"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M723.525 235.033C725.169 232.448 724.49 237.224 723.525 235.033Z",
    fill: "#72969B"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2739 235.689C62.5702 234.208 65.551 235.416 66.9213 235.032C66.6367 236.514 63.6559 235.294 62.2739 235.689Z",
    fill: "#72969B"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M641.368 237.019C641.797 237.449 641.084 236.735 641.368 237.019Z",
    fill: "#72969B"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.679 237.019C644.69 236.375 645.486 236.502 646.004 236.351C645.98 236.996 645.19 236.869 644.679 237.019Z",
    fill: "#72969B"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.188 237.676C730.805 235.934 734.447 238.036 726.169 237.676C725.338 237.641 725.106 238.565 724.188 237.676Z",
    fill: "#72969B"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.796 238.339C193.338 240.359 190.549 237.572 194.796 238.339Z",
    fill: "#72969B"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.109 239.001C198.545 239.436 197.83 238.722 198.109 239.001Z",
    fill: "#72969B"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.734 239.001C204.473 237.723 207.748 238.036 206.726 239.662H205.401C205.524 239.105 205.14 239.041 204.734 239.001Z",
    fill: "#72969B"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.264 239.001C227.694 239.436 226.985 238.722 227.264 239.001Z",
    fill: "#72969B"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.44 239.001C521.875 239.436 521.167 238.722 521.44 239.001Z",
    fill: "#72969B"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.66 239.663C109.427 242.289 109.427 237.049 108.66 239.663Z",
    fill: "#72969B"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.926 239.663C118.27 240.877 117.376 239.611 114.627 240.326C114.192 237.827 119.27 239.089 119.926 239.663Z",
    fill: "#72969B"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.587 239.663C120.605 239.018 121.395 239.151 121.907 239.001C121.901 239.645 121.106 239.518 120.587 239.663Z",
    fill: "#72969B"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.887 239.663C125.91 239.018 126.7 239.151 127.217 239.001C127.199 239.645 126.397 239.518 125.887 239.663Z",
    fill: "#72969B"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.129 239.001C514.307 240.709 509.136 241.047 504.215 241.656C507.068 238.983 513.505 239.901 518.129 239.001Z",
    fill: "#72969B"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.591 240.326C174.364 242.952 174.364 237.711 173.591 240.326Z",
    fill: "#72969B"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.235 240.326C178.124 238.891 180.581 240.029 181.551 239.663C181.656 241.098 179.193 239.971 178.235 240.326Z",
    fill: "#72969B"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.508 240.326C187.943 240.767 187.235 240.053 187.508 240.326Z",
    fill: "#72969B"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.767 240.994C584.592 241.237 591.814 239.117 597.635 240.994C592.186 241.499 582.803 241.784 575.767 240.994Z",
    fill: "#72969B"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.915 240.326C606.926 239.686 607.721 239.808 608.233 239.663C608.215 240.314 607.419 240.18 606.915 240.326Z",
    fill: "#72969B"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.897 239.663C612.115 240.662 613.039 239.767 616.183 239.663C616.45 241.813 608.641 241.813 608.897 239.663Z",
    fill: "#72969B"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2018 240.994C74.6426 241.423 73.9291 240.709 74.2018 240.994Z",
    fill: "#72969B"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.086 240.994C131.859 241.766 119.298 246.002 101.375 244.967C103.705 248.331 110.09 247.78 114.627 247.617C124.701 247.251 136.856 246.124 145.769 244.967C132.453 250.412 114.145 250.26 98.0636 248.28C96.6983 246.973 98.5231 246.519 100.051 246.292C100.341 243.353 94.2993 246.739 94.7463 243.637C112.635 243.666 128.978 240.274 149.086 240.994Z",
    fill: "#72969B"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.392 240.994C152.41 240.349 153.206 240.476 153.717 240.326C153.7 240.97 152.91 240.837 152.392 240.994Z",
    fill: "#72969B"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.292 240.994C168.31 240.349 169.099 240.476 169.622 240.326C169.604 240.97 168.808 240.837 168.292 240.994Z",
    fill: "#72969B"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.768 240.994C573.636 240.849 572.974 242.161 570.464 241.656C571.533 240.505 573.45 240.221 575.768 240.326V240.994Z",
    fill: "#72969B"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.534 241.656C560.534 239.89 564.27 241.511 565.171 241.656C570.986 242.586 567.646 242.62 560.534 241.656Z",
    fill: "#72969B"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.35 241.656C211.892 243.677 209.11 240.895 213.35 241.656Z",
    fill: "#72969B"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.317 242.318C230.14 240.633 237.787 242.952 249.133 241.656V242.318C241.389 243.265 228.962 243.126 219.317 242.318Z",
    fill: "#72969B"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.114 242.318C251.114 241.946 251.653 241.563 251.775 242.318H251.114Z",
    fill: "#72969B"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.108 241.656C305.371 244.433 298.533 243.963 296.835 243.637C298.747 241.801 303.5 242.801 306.108 241.656Z",
    fill: "#72969B"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.462 241.656C570.532 242.457 569.505 242.062 570.462 241.656Z",
    fill: "#72969B"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.959 244.967C169.088 242.882 176.291 242.156 180.881 242.318C184.46 242.87 178.889 243.184 177.57 242.981C175.037 243.98 171.242 243.724 168.959 244.967Z",
    fill: "#72969B"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.519 242.318C184.067 244.34 181.279 241.551 185.519 242.318Z",
    fill: "#72969B"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.182 242.981C186.066 241.541 188.535 242.679 189.494 242.318C189.609 243.752 187.146 242.62 186.182 242.981Z",
    fill: "#72969B"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.316 242.318C217.853 244.34 215.07 241.551 219.316 242.318Z",
    fill: "#72969B"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.132 242.318H251.113C251.101 243.183 249.277 243.16 249.132 242.318Z",
    fill: "#72969B"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.775 242.318C252.577 242.249 252.188 243.282 251.775 242.318Z",
    fill: "#72969B"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.423 242.981C254.528 242.202 255.638 242.417 256.41 242.318C256.305 243.09 255.202 242.87 254.423 242.981Z",
    fill: "#72969B"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.703 242.981C371.848 242.139 373.679 242.11 373.69 242.981C375.364 243.009 383.173 242.69 379.652 243.637C376.77 243.655 373.69 243.858 371.704 242.981H371.703Z",
    fill: "#72969B"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1821 243.637C78.9606 246.257 78.9606 241.028 78.1821 243.637Z",
    fill: "#72969B"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.81 243.637C192.828 243.004 193.617 243.126 194.129 242.981C194.112 243.625 193.322 243.492 192.81 243.637Z",
    fill: "#72969B"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.566 242.981C392.114 245.008 389.325 242.219 393.566 242.981Z",
    fill: "#72969B"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.655 244.299C163.667 243.666 164.462 243.795 164.98 243.637C164.957 244.282 164.161 244.154 163.655 244.299Z",
    fill: "#72969B"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.719 244.299C423.155 244.735 422.447 244.033 422.719 244.299Z",
    fill: "#72969B"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.659 244.299C433.089 244.735 432.381 244.033 432.659 244.299Z",
    fill: "#72969B"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.622 244.299C439.051 244.735 438.344 244.033 438.622 244.299Z",
    fill: "#72969B"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.918 244.299C446.585 242.981 453.086 243.515 455.847 244.299C453.011 245.793 446.929 244.845 443.918 244.299Z",
    fill: "#72969B"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.158 244.299C566.873 245.781 563.893 244.572 562.521 244.967C563.788 243.614 565.392 243.637 567.158 244.299Z",
    fill: "#72969B"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.359 244.299C582.787 245.799 574.293 244.375 568.478 245.63C573.021 242.65 581.876 244.073 588.359 244.299Z",
    fill: "#72969B"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M722.863 244.967C723.008 244.009 724.838 244.735 724.844 243.637C726.924 244.387 726.599 243.457 728.167 244.299C735.692 244.643 725.727 245.288 722.863 244.967Z",
    fill: "#72969B"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.221 244.967C718.657 245.397 717.943 244.683 718.221 244.967Z",
    fill: "#72969B"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.205 245.63C233.758 243.608 230.971 246.391 235.205 245.63Z",
    fill: "#72969B"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.875 245.63C237.659 244.108 242.272 245.392 245.153 244.967C243.369 246.496 238.762 245.206 235.875 245.63Z",
    fill: "#72969B"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.463 244.967C247.01 246.989 244.223 244.201 248.463 244.967Z",
    fill: "#72969B"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.251 245.63C228.438 246.577 226.968 246.885 225.277 246.955C225.887 245.799 227.345 245.491 229.251 245.63Z",
    fill: "#72969B"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.575 246.292C231.01 246.722 230.291 246.008 230.575 246.292Z",
    fill: "#72969B"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.207 245.63H235.874C235.874 245.996 235.34 246.379 235.207 245.63Z",
    fill: "#72969B"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M711.598 246.292C708.292 248.181 705.16 246.606 701.657 247.617C703.639 245.782 709.111 245.624 711.598 246.292Z",
    fill: "#72969B"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6055 246.954C61.5605 249.214 55.809 248.424 53.6703 248.279C46.896 247.843 58.7597 247.1 63.6055 246.954Z",
    fill: "#72969B"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.714 247.617C212.014 246.078 216.081 247.536 218.649 247.617C213.728 249.575 212.154 250.807 204.734 250.267C205.135 248.541 204.467 247.884 202.747 248.28C203.456 246.78 206.913 248.029 208.714 247.617C208.36 248.152 208.022 248.692 208.045 249.599C209.562 249.791 210.544 249.447 210.7 248.28C210.591 247.507 209.492 247.721 208.714 247.617Z",
    fill: "#72969B"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.929 248.948C176.542 247.599 187.494 246.845 189.493 248.28C183.27 247.797 179.092 249.366 172.929 248.948Z",
    fill: "#72969B"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.817 247.617H192.148V248.948H190.817V247.617Z",
    fill: "#72969B"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.758 248.28C199.625 249.801 195.704 248.523 193.478 248.948C195.331 246.99 199.509 247.727 200.758 248.28Z",
    fill: "#72969B"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.427 248.28C201.856 248.714 201.149 248.007 201.427 248.28Z",
    fill: "#72969B"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.704 247.617C577.495 250.156 563.185 249.621 554.568 249.599C564.794 248.511 576.519 247.843 585.704 247.617Z",
    fill: "#72969B"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.661 247.617C586.259 249.599 584.894 246.792 593.661 247.617Z",
    fill: "#72969B"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.637 248.28C598.403 250.9 598.403 245.66 597.637 248.28Z",
    fill: "#72969B"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M736.772 248.28C730.701 250.034 726.745 248.047 720.208 248.28C721.818 247.024 732.886 247.437 736.772 248.28Z",
    fill: "#72969B"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.392 248.948C151.462 250.882 146.036 248.32 145.101 250.267C143.404 248.157 151.555 248.756 152.392 248.948Z",
    fill: "#72969B"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.041 249.599C155.691 246.717 161.518 249.018 164.319 248.28C160.781 249.703 159.247 249.03 155.041 249.599Z",
    fill: "#72969B"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.312 248.948C166.591 247.46 169.566 248.675 170.943 248.28C170.664 249.761 167.679 248.541 166.312 248.948Z",
    fill: "#72969B"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.739 249.599C634.629 248.169 637.091 249.307 638.05 248.947C638.167 250.382 635.703 249.244 634.739 249.599Z",
    fill: "#72969B"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.782 249.599C143.015 252.149 137.978 250.429 135.165 250.929C134.973 250.052 141.091 249.813 143.782 249.599Z",
    fill: "#72969B"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.141 250.267C624.838 248.762 628.3 250.011 630.101 249.599C629.393 251.11 625.935 249.86 624.141 250.267Z",
    fill: "#72969B"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1691 250.929C80.6098 251.364 79.8964 250.656 80.1691 250.929Z",
    fill: "#72969B"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.178 250.267C129.465 254.066 129.662 263.019 122.575 261.532C128.646 264.745 141.179 261.294 151.067 262.195C141.416 267.697 121.634 259.446 119.926 269.486C118.323 272.107 114.453 268.399 113.959 272.135C110.403 267.075 96.7792 273.506 94.0889 271.467C95.2859 268.737 96.6863 267.72 94.746 266.168C95.0247 264.681 98.2667 266.151 98.7254 264.844C98.1151 263.682 97.494 262.543 95.4081 262.857C96.8955 261.916 99.2895 261.881 99.3933 259.545C99.2837 258.313 97.145 259.132 96.739 258.221C97.2379 256.512 101.637 258.703 101.376 256.227C106.43 257.337 110.624 258.412 113.959 254.903C114.761 255.652 115.161 256.791 117.276 256.227C118.444 256.076 118.787 255.089 118.606 253.578C114.534 253.154 110.101 252.561 107.998 255.571C106.615 253.613 103.437 252.986 102.037 255.571C101.247 253.927 99.6378 253.108 96.7382 253.578C108.41 249.447 119.025 252.021 133.178 250.267ZM125.886 255.571C128.053 255.745 129.076 254.781 129.198 252.916C128.303 252.701 127.937 251.981 126.549 252.259C126.177 253.63 124.66 254.397 125.886 255.571ZM125.223 259.545C125.66 259.975 124.951 259.272 125.223 259.545ZM112.634 262.856H115.289C114.552 260.776 114.975 261.102 115.957 259.544C114.034 259.835 112.93 260.944 112.634 262.856ZM118.606 262.194C119.444 262.228 119.519 263.048 120.588 262.856C120.484 262.072 120.704 260.974 119.926 260.869C119.92 261.746 118.764 261.473 118.606 262.194ZM109.328 262.856C109.758 263.291 109.044 262.577 109.328 262.856ZM145.1 262.856C144.594 262.995 143.798 262.874 143.78 263.518C144.292 263.367 145.087 263.501 145.1 262.856ZM148.417 262.856C147.905 262.995 147.11 262.874 147.092 263.518C147.603 263.367 148.393 263.501 148.417 262.856ZM99.3925 265.505C100.636 265.215 103.373 266.406 102.699 264.186H99.3925V265.505ZM117.276 265.505C119.506 267.522 119.286 263.06 117.276 265.505ZM110.653 267.493C112.251 267.226 112.093 268.707 113.958 268.155C114.219 266.098 110.769 265.459 110.653 267.493ZM107.998 267.493C106.626 267.894 103.646 266.673 103.361 268.155C104.999 268.625 107.3 269.184 107.998 267.493C108.962 267.086 107.94 266.697 107.998 267.493Z",
    fill: "#72969B"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.426 250.929C192.176 253.608 177.745 251.109 167.63 252.916C177.112 250.505 192.073 251.429 201.426 250.929Z",
    fill: "#72969B"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.61 250.929C601.627 250.284 602.417 250.417 602.94 250.267C602.917 250.911 602.12 250.784 601.61 250.929Z",
    fill: "#72969B"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.589 250.929C605.7 250.15 606.798 250.365 607.576 250.267C607.471 251.045 606.362 250.83 605.589 250.929Z",
    fill: "#72969B"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.214 250.929C612.323 250.15 613.422 250.365 614.201 250.267C614.09 251.045 612.992 250.83 612.214 250.929Z",
    fill: "#72969B"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.863 250.929C614.88 250.284 615.67 250.417 616.182 250.267C616.176 250.911 615.38 250.784 614.863 250.929Z",
    fill: "#72969B"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.485 250.267C618.667 252.299 615.827 249.453 621.485 250.267Z",
    fill: "#72969B"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.138 250.929C245.047 252.16 241.927 252.353 238.522 252.259C240.608 251.028 243.734 250.841 247.138 250.929Z",
    fill: "#72969B"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.132 251.597C250.77 254.177 250.096 249.401 249.132 251.597Z",
    fill: "#72969B"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.366 252.916C159.155 250.743 163.292 253.37 166.963 251.597C165.918 254.519 159.585 252.16 156.366 252.916Z",
    fill: "#72969B"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.206 252.916C228.106 252.288 220.932 254.88 215.336 253.578C218.438 252.55 232.091 251.103 235.206 252.916Z",
    fill: "#72969B"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.048 251.597C259.526 254.043 255.656 251.394 251.775 252.259C251.095 250.882 258.48 251.917 261.048 251.597Z",
    fill: "#72969B"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.317 252.259C595.236 250.742 598.93 252.009 600.941 251.597C600.029 253.108 596.339 251.847 594.317 252.259Z",
    fill: "#72969B"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6577 252.916C55.7623 252.143 56.8661 252.358 57.6444 252.259C57.5339 253.037 56.436 252.811 55.6577 252.916Z",
    fill: "#72969B"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.366 252.916C154.647 253.689 148.203 254.711 143.782 254.903C139.727 255.083 131.826 254.589 139.146 254.24C144.381 253.659 152.381 252.585 156.366 252.916Z",
    fill: "#72969B"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M713.58 252.916C713.26 256.786 706.387 254.118 702.982 254.903C704.818 252.55 710.855 254.38 713.58 252.916Z",
    fill: "#72969B"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.248 255.571C591.514 255.675 588.714 254.799 574.451 254.903C574.323 254.345 574.707 254.281 575.108 254.24C584.339 253.99 597.272 253.381 606.248 255.571Z",
    fill: "#72969B"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.158 254.24C567.692 254.362 567.814 254.908 568.476 254.903C568.128 256.47 565.346 255.309 567.158 254.24Z",
    fill: "#72969B"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.125 254.24C570.296 256.268 567.456 253.439 573.125 254.24Z",
    fill: "#72969B"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.192 255.571C131.621 256.006 130.908 255.293 131.192 255.571Z",
    fill: "#72969B"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.516 255.571C132.952 256.006 132.231 255.293 132.516 255.571Z",
    fill: "#72969B"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.687 256.896C199.261 255.379 182.185 258.918 168.962 257.558C177.602 256.077 187.816 257.517 196.786 256.228C202.427 255.421 209.272 252.893 212.688 256.896H212.687Z",
    fill: "#72969B"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.221 255.571C727.07 253.258 723.683 257.012 718.221 255.571Z",
    fill: "#72969B"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M691.722 256.228C688.933 257.256 683.35 257.314 681.113 256.895C683.1 255.362 689.049 254.938 691.722 256.228Z",
    fill: "#72969B"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M704.975 256.895C703.749 258.33 701.065 258.284 698.352 258.221C699.601 256.675 702.785 256.402 704.975 256.895Z",
    fill: "#72969B"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.158 257.558C137.588 257.992 136.88 257.279 137.158 257.558Z",
    fill: "#72969B"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.464 257.558C140.899 257.992 140.191 257.279 140.464 257.558Z",
    fill: "#72969B"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.792 257.558C141.804 256.913 142.594 257.04 143.118 256.895C143.088 257.539 142.304 257.4 141.792 257.558Z",
    fill: "#72969B"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.963 257.558C166.987 256.913 167.783 257.04 168.293 256.895C168.276 257.539 167.487 257.4 166.963 257.558Z",
    fill: "#72969B"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.786 256.895C627.879 258.034 621.284 257.093 620.826 258.877C619.943 255.344 624.706 257.46 626.786 256.895Z",
    fill: "#72969B"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.115 257.558C628.545 257.992 627.837 257.279 628.115 257.558Z",
    fill: "#72969B"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.118 258.221C149.125 257.157 159.647 257.088 165.643 258.221C159.2 258.302 152.849 259.208 144.443 258.877C143.623 259.62 143.083 259.452 143.118 258.221Z",
    fill: "#72969B"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.521 258.22C615.039 259.714 611.807 258.477 610.221 258.877C611.238 256.977 613.544 257.616 615.521 258.22Z",
    fill: "#72969B"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.851 257.558H618.181V258.876H616.851V257.558Z",
    fill: "#72969B"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9565 258.876C61.0377 257.418 63.7691 258.597 64.9368 258.22C64.8497 259.684 62.1242 258.504 60.9565 258.876Z",
    fill: "#72969B"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.033 258.876C691.112 262.119 688.851 259.864 682.443 260.869C683.901 259.428 691.802 258.202 695.033 258.876Z",
    fill: "#72969B"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.793 258.876C140.33 260.904 137.553 258.121 141.793 258.876Z",
    fill: "#72969B"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.972 258.876C200.829 265.134 170.815 260.358 151.729 262.856C172.535 259.8 198.011 262.078 219.972 258.876Z",
    fill: "#72969B"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.964 259.545C221.982 258.9 222.771 259.027 223.284 258.877C223.272 259.521 222.476 259.394 221.964 259.545Z",
    fill: "#72969B"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.182 261.531C598.858 260.537 579.94 263.1 561.854 260.201C579.069 261.462 597.108 258.243 616.182 261.531Z",
    fill: "#72969B"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720.87 259.545C720.894 258.9 721.684 259.027 722.2 258.877C722.183 259.521 721.387 259.394 720.87 259.545Z",
    fill: "#72969B"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.167 259.545C130.966 261.567 128.108 258.709 135.167 259.545Z",
    fill: "#72969B"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.616 259.545C279.894 261.253 274.211 261.143 277.616 259.545Z",
    fill: "#72969B"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.942 260.201C278.965 259.562 279.75 259.695 280.267 259.544C280.249 260.188 279.459 260.061 278.942 260.201Z",
    fill: "#72969B"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M726.168 260.201C726.877 258.702 730.34 259.957 732.135 259.544C731.427 261.043 727.976 259.794 726.168 260.201Z",
    fill: "#72969B"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.589 260.869C229.508 259.573 234.214 260.062 235.207 260.869C233.696 261.56 230.849 261.857 228.589 260.869Z",
    fill: "#72969B"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.671 260.201C263.942 261.776 253.706 260.428 245.816 261.531C251.963 259.277 261.602 260.533 269.671 260.201Z",
    fill: "#72969B"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.875 261.531C236.31 261.967 235.591 261.247 235.875 261.531Z",
    fill: "#72969B"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.511 261.531C240.62 260.753 241.719 260.974 242.502 260.869C242.393 261.647 241.294 261.426 240.511 261.531Z",
    fill: "#72969B"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.737 261.531C634.761 260.88 635.551 261.02 636.062 260.869C636.045 261.513 635.249 261.386 634.737 261.531Z",
    fill: "#72969B"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.041 262.194C48.1744 260.683 52.1019 261.95 54.3327 261.531C53.2001 263.048 49.2718 261.775 47.041 262.194Z",
    fill: "#72969B"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.128 261.531C622.27 263.1 612.84 261.758 621.486 261.531C623.031 261.497 624.512 261.56 626.128 261.531Z",
    fill: "#72969B"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M712.261 261.531C713.952 264.541 706.719 263.268 704.308 262.856C705.452 260.904 711.122 263.483 712.261 261.531Z",
    fill: "#72969B"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4176 262.856C37.4662 263.663 33.6316 263.577 29.8146 263.518C28.6351 263.704 28.4552 262.891 29.1524 262.856C31.1103 261.514 55.8606 262.508 40.4176 262.856Z",
    fill: "#72969B"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.742 262.194C690.937 263.013 693.662 261.967 697.683 262.856C696.265 264.065 689.537 264.721 687.742 262.194Z",
    fill: "#72969B"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.542 263.518C540.084 266.284 526.821 263.594 507.525 264.843C524.694 261.386 546.359 264.739 558.542 263.518Z",
    fill: "#72969B"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685.092 263.518C684.104 263.409 682.646 263.751 682.443 262.856C683.43 262.966 684.888 262.613 685.092 263.518Z",
    fill: "#72969B"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685.761 263.518C688.507 264.151 685.889 261.538 685.761 263.518Z",
    fill: "#72969B"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.548 264.186C463.388 262.594 478.325 264.239 492.286 264.186C482.356 266.15 463.364 264.36 450.548 264.186Z",
    fill: "#72969B"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.204 263.518H561.853C562.526 265.516 560.383 264.692 559.204 264.843V263.518Z",
    fill: "#72969B"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.4 264.843C641.679 263.937 634.367 262.333 635.4 264.843Z",
    fill: "#72969B"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685.092 263.518H685.76V264.186C685.347 264.146 684.97 264.081 685.092 263.518Z",
    fill: "#72969B"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.053 264.843C153.488 265.272 152.773 264.571 153.053 264.843Z",
    fill: "#72969B"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.041 264.843C155.476 265.272 154.768 264.571 155.041 264.843Z",
    fill: "#72969B"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.747 266.168C404.122 266.086 384.486 265.97 372.361 266.825C388.884 263.321 403.711 265.122 418.747 266.168Z",
    fill: "#72969B"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4705 265.505C30.8031 267.237 29.3683 266.261 25.8418 266.825C27.0614 265.395 29.74 265.436 32.4705 265.505Z",
    fill: "#72969B"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.458 266.168C35.1611 264.657 38.6241 265.912 40.4196 265.505C39.7164 267.004 36.2535 265.756 34.458 266.168Z",
    fill: "#72969B"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0145 266.167C50.9099 264.727 53.3668 265.865 54.3309 265.505C54.4413 266.946 51.9844 265.808 51.0145 266.167Z",
    fill: "#72969B"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6579 266.168C56.0928 266.603 55.3794 265.901 55.6579 266.168Z",
    fill: "#72969B"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.646 266.168C189.463 269.165 155.225 268.068 126.548 269.485C127.658 265.767 133.451 268.19 137.157 268.155C141.369 268.12 146.43 268.236 151.066 268.155C174.248 267.771 194.169 265.587 218.646 266.168ZM128.536 268.817C128.971 269.253 128.263 268.538 128.536 268.817Z",
    fill: "#72969B"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.317 266.168C219.811 264.674 223.029 265.907 224.615 265.506C224.162 267.922 221.972 265.367 219.317 266.168Z",
    fill: "#72969B"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.191 267.493C332.996 266.918 323.067 266.987 308.095 268.155C318.466 265.105 337.68 264.867 345.191 267.493Z",
    fill: "#72969B"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.745 266.167C421.491 266.805 418.878 264.187 418.745 266.167Z",
    fill: "#72969B"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.87 266.825C271.604 267.801 245.088 269.759 227.263 268.155C248.522 268.224 267.473 265.976 290.87 266.825Z",
    fill: "#72969B"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.817 266.825C298.265 270.188 295.779 267.667 292.856 268.155C292.751 266.755 296.481 267.55 298.817 266.825Z",
    fill: "#72969B"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6958 268.155C49.7134 267.51 50.5094 267.643 51.015 267.493C51.0033 268.137 50.2081 268.004 49.6958 268.155Z",
    fill: "#72969B"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.575 270.142C123.011 270.583 122.303 269.869 122.575 270.142Z",
    fill: "#72969B"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.769 271.466C36.2004 272.995 31.82 271.705 29.1531 272.134C26.5675 271.739 36.4741 270.182 37.769 271.466Z",
    fill: "#72969B"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.419 271.466C40.8539 271.902 40.1463 271.194 40.419 271.466Z",
    fill: "#72969B"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3981 271.466C44.833 271.902 44.1196 271.194 44.3981 271.466Z",
    fill: "#72969B"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8736 273.453C20.5661 270.328 32.3143 273.43 22.5298 272.797C21.9665 272.675 21.9079 273.053 21.8736 273.453Z",
    fill: "#72969B"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M716.234 272.797C714.578 275.005 710.11 274.465 707.624 274.116C709.75 272.943 713.632 273.506 716.234 272.797Z",
    fill: "#72969B"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.17 274.116C189.134 273.71 188.107 273.315 188.17 274.116Z",
    fill: "#72969B"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8809 275.441C24.709 274.075 35.2945 274.97 39.094 274.784C32.744 275.964 24.0812 275.627 19.8809 275.441Z",
    fill: "#72969B"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4183 274.784C42.6414 273.182 38.8216 277.007 40.4183 274.784Z",
    fill: "#72969B"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0669 274.784C43.5019 275.213 42.7943 274.5 43.0669 274.784Z",
    fill: "#72969B"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3857 274.784C46.8156 275.213 46.113 274.5 46.3857 274.784Z",
    fill: "#72969B"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8384 275.441C81.2683 275.881 80.5599 275.168 80.8384 275.441Z",
    fill: "#72969B"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.508 276.771C672.543 276.725 672.456 276.115 672.508 276.109C675.685 275.546 669.36 280.361 672.508 276.771Z",
    fill: "#72969B"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4788 278.764C25.6565 280.291 17.8191 280.594 14.5771 280.083C19.3878 279.333 26.0516 277.77 30.4788 278.764Z",
    fill: "#72969B"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4775 278.764C32.7025 277.224 37.7633 278.531 41.0865 278.096C38.8557 279.629 33.8065 278.323 30.4775 278.764Z",
    fill: "#72969B"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3981 279.426C44.833 279.85 44.1196 279.147 44.3981 279.426Z",
    fill: "#72969B"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2516 280.083C13.6924 280.513 12.9789 279.81 13.2516 280.083Z",
    fill: "#72969B"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0718 281.413V280.745C96.4431 280.739 96.8262 281.28 96.0718 281.413Z",
    fill: "#72969B"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.018 282.064C643.35 287.589 636.855 287.28 634.739 291.347C632.886 291.696 631.294 292.318 629.441 292.672C621.08 299.935 611.076 304.455 601.612 309.898C598.585 311.641 596.58 314.773 593.664 316.522C581.284 323.976 568.1 329.646 555.894 337.065C550.846 340.127 546.905 344.456 541.979 347.657C537.303 350.713 531.557 352.619 526.072 355.61C521.116 358.324 516.48 362.217 511.501 364.889C506.406 367.631 501.264 370.507 496.267 373.505C485.543 379.925 474.713 386.217 461.147 390.731C443.363 405.651 416.353 414.824 398.865 427.827C371.669 420.588 356.761 401.038 329.965 393.38C329.159 390.65 325.997 390.272 324.661 388.082C299.144 380.686 281.215 365.714 257.744 356.278C221.705 330.25 175.307 314.593 137.16 290.685C136.759 287.664 134.737 288.234 133.18 285.387C185.074 283.528 242.516 284.596 294.84 284.062C302.927 283.975 310.474 284.567 318.695 284.062C341.289 282.662 363.036 282.702 388.268 282.732C396.146 282.737 404.28 284.213 411.455 283.394C413.832 283.121 413.936 283.19 415.429 281.412C438.128 283.08 458.817 282.046 480.366 281.412C519.6 280.25 564.051 283.958 604.923 283.394C618.147 283.214 634.315 284.823 644.018 282.064ZM192.812 292.01V290.685C189.251 290.14 180.861 290.122 178.891 293.335C185.119 297.193 190.377 295.159 198.11 295.322C203.863 295.444 210.015 297.414 215.337 297.303C221.048 297.198 227.311 295.624 233.226 298.634C215.198 297.007 197.28 298.076 179.56 298.634C179.148 297.675 178.764 298.704 179.56 298.634C183.203 301.991 198.274 297.669 199.435 301.951C191.371 301.991 179.908 299.581 174.918 303.933C174.383 303.81 174.261 303.27 173.593 303.27C174.272 305.506 171.542 304.304 170.281 304.595C172.536 307.309 177.752 309.563 181.552 307.256C182.104 307.365 182.168 306.988 182.209 306.588C194.555 308.958 216.202 305.634 229.913 309.899C217.48 308.475 203.24 309.859 191.481 309.899C188.012 309.905 182.998 307.204 180.884 311.224C194.711 312.363 206.622 311.602 219.317 312.549C211.194 315.169 196.687 313.722 188.169 313.874C192.48 319.962 212.862 319.637 218.649 315.861C219.636 316.151 218.387 316.709 218.649 317.847C214.965 319.306 209.201 320.142 202.091 319.834C208.888 326.579 222.942 318.452 231.907 323.152C224.97 322.304 214.791 322.426 208.713 324.471C216.655 333.679 233.847 330.658 246.483 332.419C240.249 333.267 230.628 330.716 226.602 333.749C232.186 337.293 251.48 334.626 261.717 335.742C251.167 336.898 244.003 337.177 233.888 336.404C234.806 340.697 239.93 340.999 243.829 343.028C247.146 344.759 250.434 348.431 254.426 348.988C256.262 349.25 258.337 347.751 260.394 347.658C269.561 347.257 281.112 349.476 290.872 350.313C280.641 350.837 266.436 349.291 256.413 349.651C262.107 357.459 279.351 351.818 292.197 354.955C283.755 356.948 273.321 353.444 265.692 355.612C271.833 363.385 287.706 361.427 298.821 364.228C294.637 364.344 284.778 362.364 280.27 364.228C282.321 365.263 284.848 365.838 285.568 368.208C289.293 365.332 299.809 369.388 306.775 369.527C300.477 370.213 293.516 368.336 289.543 368.864C293.505 375.534 300.204 371.293 308.1 373.507C306.398 374.559 302.854 372.874 299.49 373.507C302.238 379.59 314.124 376.534 320.684 378.805H310.749C315.629 384.749 328.928 382.268 337.248 384.773C331.799 385.574 326.506 382.727 322.009 384.773C324.147 387.3 331.421 385.545 329.307 388.746C333.473 387.318 335.733 390.914 339.898 391.396C338.853 391.448 337.37 391.076 337.248 392.059C340.35 396.02 347.444 396.004 353.155 397.363C351.546 399.106 348.856 395.661 348.513 398.682C350.546 399.972 354.921 398.903 356.461 400.669H354.48C357.832 407.838 372.211 403.539 381.642 405.973H363.753C371.044 411.348 383.495 423.694 392.251 417.238C394.232 419.429 391.31 420.713 390.92 422.537C396.561 421.619 397.56 423.147 402.848 421.875C403.638 419.092 400.054 420.69 399.53 419.22C402.865 417.994 405.706 420.074 407.49 417.9C404.509 416.361 400.831 418.493 397.549 416.576C412.568 417.238 422.114 412.434 430.015 405.973C426.616 405.352 421.823 408.466 420.068 405.311C423.287 406.537 425.913 403.992 429.347 403.981C430.584 403.981 433.134 405.498 433.989 405.311C436.621 404.748 440.868 401.099 443.924 399.344C447.067 397.544 450.518 395.557 452.54 392.721C449.252 390.827 444.924 393.418 443.256 392.059C449.269 390.333 459.506 392.843 461.15 386.76C456.171 385.911 449.432 388.317 447.236 386.097C457.125 384.529 466.373 387.282 470.429 382.124C458.641 381.148 441.937 383.349 429.347 381.455C440.014 380.67 449.072 381.554 459.164 381.455C467.246 381.374 476.227 382.443 481.689 378.143C471.835 377.69 468.157 378.132 457.844 378.143C467.524 374.385 484.239 379.886 488.98 374.175C476.715 373.385 458.194 373.46 444.587 372.845C463.254 369.318 487.371 378.126 499.584 367.546C484.49 366.651 472.644 367.959 460.489 366.215C475.948 363.897 499.415 371.515 508.856 361.579C503.522 360.243 498.427 363.659 492.954 361.579C500.001 359.348 510.21 362.305 514.817 358.929C499.502 356.612 475.321 358.291 455.19 357.605C471.01 356.222 490.276 356.566 508.856 356.28C512.528 356.221 517.756 359.232 520.127 354.955C513.667 354.95 505.172 353.183 503.557 352.306C503.151 351.382 501.007 352.202 500.908 350.981C502.919 351.4 506.608 350.127 507.532 351.644C506.777 351.766 507.16 352.306 507.532 352.306C508.328 352.236 507.939 353.27 507.532 352.306V351.644C511.586 350.853 516.688 355.78 524.096 353.625C522.934 350.592 516.56 352.776 514.155 350.981C520.371 350.121 530.469 353.16 532.706 348.326C514.34 345.608 490.456 350.964 472.422 346.339C494.488 347.501 512.453 346.612 528.737 346.339C532.362 346.281 537.882 347.914 540.664 344.358C518.616 342.755 495.685 344.811 472.422 343.69C496.457 340.657 522.741 345.885 545.296 341.041C518.553 339.484 480.608 340.982 451.217 337.066C476.338 337.125 506.637 340.419 536.686 339.047C541.892 338.816 548.55 340.982 552.593 336.404C514.202 332.25 470.535 338.153 431.998 333.749C468.211 333.191 515.642 335.881 549.938 333.749C553.61 333.522 557.683 336.078 559.211 331.1C532.504 330.884 500.404 330.251 476.391 328.45C501.99 327.032 528.947 331.669 551.925 327.125C548.48 324.638 542.525 327.665 539.335 325.801C541.328 322.489 551.298 323.634 555.243 324.47C553.593 324.377 552.024 324.354 551.925 325.801C554.673 325.679 555.568 326.951 557.224 325.138C556.289 325.197 555.353 325.248 555.243 324.47C561.948 323.122 567.908 323.506 575.113 323.819C573.904 319.955 570.139 322.617 567.833 322.489C546.313 321.339 524.137 322.076 504.22 321.164C517.124 316.888 536.686 322.803 549.275 318.509C549.978 319.787 550.536 321.216 553.244 320.496C556.334 321.077 552.803 318.312 554.574 318.509C560.68 319.549 569.122 318.869 573.131 317.19C562.876 316.546 551.14 319.032 543.971 315.86C555.864 315.627 565.304 315.36 573.787 313.21C566.309 314.843 564.636 309.596 559.872 311.886C524.821 310.171 494.685 315.185 467.117 310.56C487.528 311.072 513.538 312.908 531.38 309.23C530.742 309.219 530.875 308.423 530.723 307.911C531.683 307.499 530.648 307.11 530.723 307.911C526.523 308.266 515.932 309.184 507.531 307.911C517.466 305.378 535.907 309.474 545.295 305.256C537.004 301.608 523.862 307.9 516.147 303.269C526.819 303.048 548.275 304.175 557.89 300.62C543.859 298.272 528.487 302.757 512.167 301.282C527.127 298.384 550.622 300.26 559.872 297.302C550.402 295.088 535.987 294.635 524.757 295.321C483.199 297.86 437.737 297.743 394.901 292.01C398.933 289.941 404.4 293.13 408.147 291.347C407.857 293.845 411.168 292.747 412.122 293.991C438.452 294.624 464.468 295.292 490.967 295.321C511.319 295.338 532.583 294.734 551.925 294.653C558.768 294.63 565.677 294.031 572.463 292.672C526.942 289.111 448.427 296.698 399.532 288.029C433.683 289.912 478.453 292.95 518.797 290.022C521.556 289.371 525.21 292.584 525.426 288.692C525.222 287.71 522.632 289.407 522.108 287.373C529.696 287.873 537.563 286.403 541.984 288.692C540.857 288.448 540.735 289.21 540.664 290.022H539.996C539.584 289.058 539.195 290.086 539.996 290.022C540.119 290.772 540.664 290.382 540.664 290.022C542.355 291.382 545.911 290.371 547.288 289.36C545.348 288.424 544.029 290.121 542.647 288.029C547.282 287.152 554.051 288.395 557.223 286.048C512.098 284.258 465.811 283.102 428.024 284.718C436.64 289.232 452.106 285.369 461.152 288.029C446.319 286.617 429.447 289.76 414.115 287.373C389.841 283.585 355.819 285.688 326.66 286.048C302.147 286.344 276.637 289.929 251.12 287.373C234.48 285.7 210.649 285.949 192.155 286.71C177.224 287.32 163.936 285.642 148.425 288.691C153.009 289.307 157.744 288.709 162.339 288.691C177.445 288.656 191.772 288.715 202.753 288.691C202.235 289.278 202.038 290.19 202.096 291.346C210.137 292.252 218.149 291.573 223.953 293.333C215.43 296.197 203.961 290.905 192.818 292.009L192.812 292.01ZM577.756 287.374C576.682 288.937 573.207 288.111 571.795 289.361C574.031 289.78 575.193 291.26 578.424 290.685C579.185 291.661 579.185 292.347 578.424 293.335C580.22 292.922 583.682 294.172 584.386 292.672C582.875 292.852 581.893 292.51 581.736 291.347C588.697 289.419 601.711 292.313 608.235 289.361C597.969 288.803 586.03 289.924 577.756 287.374C578.726 286.961 577.693 286.572 577.756 287.374ZM581.736 286.712C580.278 288.734 577.489 285.951 581.736 286.712ZM630.103 288.693C632.625 289.007 634.234 288.408 634.739 286.712C632.13 286.306 631.294 287.688 630.103 288.693ZM534.694 289.361C533.137 289.146 532.202 288.309 530.057 288.693C530.586 291.342 534.16 290.982 534.694 289.361ZM567.828 289.361C567.415 288.978 564.679 287.803 564.505 289.361C564.917 289.739 567.648 290.906 567.828 289.361ZM618.181 289.361C615.271 289.256 610.564 287.432 608.898 290.023C610.286 291.22 620.616 289.79 618.181 289.361ZM627.454 289.361H624.804C624.281 291.906 627.977 291.906 627.454 289.361ZM151.068 292.672C150.144 290.505 147.739 289.82 144.445 290.023C145.037 292.515 148.117 292.533 151.068 292.672ZM162.333 291.347C161.927 290.383 161.532 291.412 162.333 291.347V292.01C169.433 292.219 174.453 293.346 178.892 291.347C174.349 289.954 167.766 290.354 162.333 291.347ZM160.347 291.347C159.452 291.139 159.081 290.401 157.692 290.685C156.634 292.534 160.562 292.515 160.347 291.347ZM585.048 293.335C589.813 293.445 597.04 295.45 601.612 292.672C596.075 291.644 588.888 292.138 585.048 293.335ZM602.274 293.335C603.436 294.299 607.369 294.02 607.578 292.01C605.417 292.063 603.505 292.347 602.274 293.335ZM611.553 292.01C611.035 292.162 610.245 292.028 610.222 292.672C610.733 292.521 611.529 292.649 611.553 292.01ZM150.406 295.322C151.981 295.786 156.553 297.076 157.029 294.654C155.454 294.195 150.882 292.905 150.406 295.322ZM159.016 294.654C158.976 294.666 159.057 295.27 159.016 295.322C155.873 298.918 162.2 294.09 159.016 294.654ZM180.222 294.654C179.711 294.805 178.916 294.677 178.892 295.322C179.41 295.177 180.199 295.298 180.222 294.654ZM573.782 297.303C579.523 296.647 588.051 298.767 591.671 295.984C582.532 297.605 579.615 294.021 573.782 297.303ZM563.848 297.303H565.173V295.984H563.848V297.303ZM571.127 297.303C571.806 295.038 566.154 295.734 565.828 296.652C567.867 297.907 569.32 296.257 571.127 297.303ZM617.513 296.652C616.137 295.194 615.376 297.227 614.202 295.984C613.179 297.983 617.624 297.721 617.513 296.652ZM561.855 297.303C562.285 297.744 561.582 297.03 561.855 297.303ZM159.016 298.634C159.4 301.881 170.834 300.365 167.633 297.971C166.07 299.494 161.689 298.21 159.016 298.634ZM569.146 299.958C569.571 302.793 575.683 301.086 575.77 299.302C573.214 299.168 570.89 299.279 569.146 299.958ZM612.877 301.283C605.818 296.977 591.125 300.295 583.061 299.958C589.138 301.736 604.546 300.592 612.877 301.283ZM562.523 300.62C561.744 300.719 560.646 300.511 560.536 301.283C561.315 301.185 562.419 301.393 562.523 300.62ZM164.321 302.613C166.15 303.955 170.212 303.113 170.944 301.283C168.174 302.95 166.278 299.755 164.321 302.613ZM560.536 305.257C569.571 304.717 579.046 306.041 587.697 305.925C594.93 305.826 603.134 307.134 607.578 303.27C592.787 303.653 573.393 300.243 560.536 305.257ZM549.933 304.595C551.827 304.99 557.172 305.397 557.888 303.933C554.652 303.641 551.398 302.515 549.933 304.595ZM547.284 306.588C547.714 307.023 547.005 306.309 547.284 306.588ZM548.608 306.588C552.978 308.232 551.612 304.368 548.608 306.588ZM554.569 308.58C568.175 309.672 586.181 310.01 599.625 307.912C585.153 306.796 564.666 306.843 554.569 308.58ZM542.642 309.23C543.077 309.666 542.369 308.958 542.642 309.23ZM592.334 312.548C593.373 312.484 594.628 312.629 594.321 311.223H592.996C593.002 311.886 592.462 312.014 592.334 312.548ZM590.347 314.541C591.404 312.687 587.488 312.699 587.697 313.873C588.592 314.081 588.964 314.819 590.347 314.541ZM579.755 317.846C581.051 319.444 583.062 319.375 583.724 317.19C581.702 317.44 580.348 315.447 579.755 317.846ZM566.497 327.793C564.377 327.874 561.431 327.131 561.855 329.78C563.656 330.507 565.95 330.031 566.497 327.793C569.419 327.909 566.689 325.179 566.497 327.793ZM510.176 352.968C510.612 353.403 509.903 352.689 510.176 352.968Z",
    fill: "#72969B"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.77 282.732C37.7935 282.087 38.5778 282.22 39.0951 282.064C39.0775 282.715 38.2882 282.587 37.77 282.732Z",
    fill: "#72969B"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7715 283.394C91.2072 283.83 90.4988 283.116 90.7715 283.394Z",
    fill: "#72969B"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7593 283.394C93.195 283.83 92.4866 283.116 92.7593 283.394Z",
    fill: "#72969B"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2923 284.063C61.3668 283.871 61.4363 284.684 62.2731 284.719C62.5401 286.003 59.2638 285.689 60.2923 284.063Z",
    fill: "#72969B"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2217 284.719C72.6507 285.154 71.949 284.44 72.2217 284.719Z",
    fill: "#72969B"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6451 284.719C48.2792 287.403 32.3716 286.659 22.5303 286.711C33.7494 284.951 47.3207 285.7 57.6451 284.719Z",
    fill: "#72969B"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5795 284.719C66.1326 286.746 63.3392 283.952 67.5795 284.719Z",
    fill: "#72969B"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9087 285.387C68.9263 284.743 69.7223 284.864 70.2338 284.719C70.2162 285.371 69.426 285.237 68.9087 285.387Z",
    fill: "#72969B"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2598 287.374C66.3585 285.723 68.5017 287.17 68.9084 287.374C68.8096 289.017 66.6606 287.565 66.2598 287.374Z",
    fill: "#72969B"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.896 287.374C392.92 286.729 393.716 286.857 394.227 286.711C394.21 287.351 393.42 287.222 392.896 287.374Z",
    fill: "#72969B"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.439 287.374C503.829 289.076 481.159 287.658 463.137 288.03C461.493 288.117 462.009 287.223 463.137 287.374H466.442C485.057 286.369 500.337 287.304 521.439 287.374Z",
    fill: "#72969B"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.08 287.374C364.271 287.293 364.485 288.187 365.729 288.03C365.949 289.197 362.023 289.209 363.08 287.374Z",
    fill: "#72969B"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.06 288.03C367.083 287.392 367.873 287.519 368.384 287.374C368.372 288.019 367.577 287.885 367.06 288.03Z",
    fill: "#72969B"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.651 287.374C375.886 290.418 368.704 287.815 377.658 288.03C378.181 288.048 378.744 287.066 379.651 287.374Z",
    fill: "#72969B"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.288 288.03C384.723 288.471 384.01 287.757 384.288 288.03Z",
    fill: "#72969B"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.112 288.693C359.223 287.921 360.321 288.141 361.099 288.03C360.989 288.808 359.891 288.594 359.112 288.693Z",
    fill: "#72969B"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.378 288.693C370.396 288.059 371.185 288.188 371.702 288.03C371.685 288.675 370.889 288.547 370.378 288.693Z",
    fill: "#72969B"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.732 289.361C205.522 287.571 208.189 289.361 209.368 289.361C208.369 291.365 206.457 288.809 204.732 289.361Z",
    fill: "#72969B"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.138 290.685C236.861 290.569 219.553 290.703 210.036 290.023C220.378 289.61 239.945 287.71 247.138 290.685Z",
    fill: "#72969B"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.839 292.01C278.443 292.114 265.556 291.301 247.802 290.685C260.241 288.792 279.32 291.208 294.839 292.01Z",
    fill: "#72969B"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.681 290.685C316.032 291.696 308.648 291.818 306.109 291.347C308.973 287.996 316.265 291.22 320.681 290.685Z",
    fill: "#72969B"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.68 290.685C323.591 288.681 327.722 291.132 331.283 290.685C328.442 292.62 324.723 289.756 320.68 290.685Z",
    fill: "#72969B"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.952 290.685C332.434 289.425 333.154 290.697 333.933 290.685C337.698 290.639 348.312 289.924 347.191 291.347H342.549C340.336 291.29 334.769 292.655 331.952 290.685Z",
    fill: "#72969B"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.836 292.01C296.388 291.807 297.579 290.72 298.817 292.01C298.735 293.48 296.004 292.289 294.836 292.672V292.01Z",
    fill: "#72969B"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.08 291.347C361.633 293.369 358.845 290.575 363.08 291.347Z",
    fill: "#72969B"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.676 292.01C375.694 291.366 376.483 291.493 377.001 291.347C376.984 291.992 376.188 291.853 375.676 292.01Z",
    fill: "#72969B"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.324 292.01C378.435 291.232 379.533 291.446 380.311 291.347C380.206 292.126 379.108 291.906 378.324 292.01Z",
    fill: "#72969B"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.754 292.01C579.76 291.366 580.556 291.493 581.074 291.347C581.05 291.992 580.26 291.853 579.754 292.01Z",
    fill: "#72969B"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.811 292.01C192.305 293.103 187.349 293.103 186.849 292.01H192.811Z",
    fill: "#72969B"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.789 292.672C359.438 290.087 358.753 294.868 357.789 292.672Z",
    fill: "#72969B"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.253 292.672C390.363 291.894 391.455 292.114 392.246 292.01C392.135 292.783 391.032 292.574 390.253 292.672Z",
    fill: "#72969B"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.575 292.672C232.225 293.445 235.739 292.359 235.873 294.654C234.34 294.869 233.328 294.544 232.556 293.992C231.888 294.427 231.882 295.525 230.575 295.322V292.672Z",
    fill: "#72969B"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.828 293.335C242.394 294.322 240.093 294.462 237.862 294.654C237.606 291.975 241.993 293.933 243.828 293.335Z",
    fill: "#72969B"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.631 295.322C264.72 295.415 254.1 295.212 244.484 293.992C253.019 293.428 264.842 295.282 275.631 294.654V295.322Z",
    fill: "#72969B"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.277 295.322C225.294 294.677 226.085 294.804 226.602 294.654C226.578 295.298 225.788 295.177 225.277 295.322Z",
    fill: "#72969B"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.631 295.322C278.077 295.746 282.232 294.462 283.579 295.984C281.133 295.565 276.98 296.844 275.631 295.322Z",
    fill: "#72969B"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.896 298.634C387.221 297.507 383.892 297.378 376.339 298.634C379.843 295.473 391.126 296.118 394.896 298.634Z",
    fill: "#72969B"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.06 297.971C371.299 298.738 368.517 295.944 367.06 297.971Z",
    fill: "#72969B"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.042 297.971C370.781 296.681 374.052 297.001 373.029 298.634H371.704C371.82 298.07 371.449 298.012 371.042 297.971Z",
    fill: "#72969B"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.357 297.971C374.781 298.407 374.073 297.692 374.357 297.971Z",
    fill: "#72969B"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.875 298.634C236.31 299.069 235.591 298.361 235.875 298.634Z",
    fill: "#72969B"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.853 298.634C239.448 297.675 239.053 298.703 239.853 298.634Z",
    fill: "#72969B"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.082 297.971C308.63 299.998 305.842 297.205 310.082 297.971Z",
    fill: "#72969B"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.056 297.971C311.925 299.998 309.102 297.187 314.056 297.971Z",
    fill: "#72969B"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.06 297.971C366.456 299.128 364.986 299.435 363.08 299.302C363.161 297.605 365.305 297.983 367.06 297.971Z",
    fill: "#72969B"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.853 298.634C247.435 298.553 254.808 298.692 261.047 299.958C251.363 299.877 247.394 299.476 239.853 299.302V298.634Z",
    fill: "#72969B"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.183 298.634H295.507V299.958H294.183V298.634Z",
    fill: "#72969B"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.797 299.302C303.227 299.731 302.513 299.023 302.797 299.302Z",
    fill: "#72969B"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.003 299.302C322.114 298.518 323.212 298.738 323.996 298.634C323.885 299.412 322.788 299.191 322.003 299.302Z",
    fill: "#72969B"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.919 298.634C331.725 300.667 328.86 297.797 335.919 298.634Z",
    fill: "#72969B"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.562 299.302C340.452 297.862 342.915 299 343.873 298.634C343.983 300.068 341.52 298.93 340.562 299.302Z",
    fill: "#72969B"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.283 299.302C427.285 300.661 417.183 300.051 402.843 299.958C414.009 298.332 426.716 298.634 439.283 299.302Z",
    fill: "#72969B"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.484 299.958C299.502 299.314 300.291 299.453 300.803 299.302C300.791 299.947 299.996 299.814 299.484 299.958Z",
    fill: "#72969B"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.6 299.302C441.136 301.323 438.355 298.535 442.6 299.302Z",
    fill: "#72969B"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.088 300.62C201.966 299.192 204.435 300.319 205.399 299.958C205.504 301.392 203.052 300.26 202.088 300.62Z",
    fill: "#72969B"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.048 299.958C267.09 299.441 271.181 300.871 276.956 300.62C274.255 302.479 265.11 300.975 261.048 299.958Z",
    fill: "#72969B"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.47 301.284C462.348 300.54 461.807 300.923 461.807 301.284H460.483C465.497 304.368 473.026 303.619 479.696 303.933C490.315 304.427 500.233 304.287 509.512 304.595C494.353 306.873 477.169 303.7 458.501 303.933C455.189 304.055 460.587 301.69 457.176 301.284C454.179 304.456 446.579 302.904 439.95 302.614C442.193 301.004 444.976 303.793 447.23 301.951C448.032 301.881 447.637 302.904 447.23 301.951C446.957 301.114 446.376 300.597 445.249 300.621C466.769 298.954 489.66 301.359 510.836 301.284C494.813 304.037 482.404 300.418 462.47 301.284ZM459.157 301.951C459.594 302.381 458.873 301.667 459.157 301.951ZM459.82 303.27C460.256 303.706 459.542 302.997 459.82 303.27Z",
    fill: "#72969B"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.926 301.283C229.064 299.767 232.98 301.045 235.206 300.62C234.078 302.143 230.152 300.859 227.926 301.283Z",
    fill: "#72969B"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.24 301.283C288.957 301.94 273.457 301.981 279.603 301.283C279.928 301.242 281.009 300.836 284.24 301.283Z",
    fill: "#72969B"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.89 301.283C286.704 300.225 290.473 300.359 288.877 301.951C289.132 301.689 286.884 301.236 286.89 301.283Z",
    fill: "#72969B"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.138 301.283C361.552 303.473 359.536 299.744 355.138 301.283Z",
    fill: "#72969B"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.203 301.951C237.307 301.173 238.411 301.387 239.183 301.283C239.079 302.062 237.975 301.847 237.203 301.951Z",
    fill: "#72969B"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.339 301.951C379.744 300.597 386.867 302.712 392.897 302.613C389.638 305.111 381.515 301.858 376.339 301.951Z",
    fill: "#72969B"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.809 301.283H462.471C462.471 301.655 461.937 302.038 461.809 301.283Z",
    fill: "#72969B"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.208 306.588H181.552C181.418 305.832 180.884 306.221 180.884 306.588C179.89 304.699 175.835 305.891 174.917 303.933C178.124 303.962 180.581 305.495 182.871 303.27C191.765 304.757 203.589 300.574 211.357 303.933C208.638 302.904 207.29 305.043 204.077 305.257C197.268 305.733 187.345 302.038 182.209 306.588H182.208Z",
    fill: "#72969B"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.834 302.613C241.945 301.835 243.043 302.05 243.827 301.951C243.722 302.724 242.619 302.503 241.834 302.613Z",
    fill: "#72969B"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.152 302.613C252.292 300.644 259.573 303.589 265.69 303.27C258.73 304.595 251.77 302.689 245.152 302.613Z",
    fill: "#72969B"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.335 301.951C430.167 302.997 427.803 302.829 426.031 303.27C425.624 300.661 429.668 302.491 431.335 301.951Z",
    fill: "#72969B"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.952 302.614C435.054 300.592 432.184 303.45 439.952 302.614Z",
    fill: "#72969B"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.871 303.269C182.464 302.312 182.069 303.34 182.871 303.269Z",
    fill: "#72969B"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.429 303.27C409.462 305.042 401.23 303.351 394.897 303.27C397.675 302.131 410.416 302.259 415.429 303.27Z",
    fill: "#72969B"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.284 303.933C221.935 305.455 217.782 304.176 215.336 304.595C217.19 302.445 220.344 303.735 223.284 303.933Z",
    fill: "#72969B"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.605 304.595C275.312 305.798 264.691 303.358 267.671 303.27C269.437 303.218 271.964 303.09 274.301 303.27C276.397 303.439 281.103 303.927 279.605 304.595Z",
    fill: "#72969B"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.686 304.595C212.791 303.822 213.894 304.037 214.673 303.933C214.562 304.711 213.464 304.49 212.686 304.595Z",
    fill: "#72969B"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.926 305.257C229.913 302.898 238.471 304.344 242.502 305.257C247.615 306.419 243.862 305.379 239.185 305.257C236.245 305.182 233.003 305.315 227.926 305.257Z",
    fill: "#72969B"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.812 304.595C514.656 305.553 509.363 306.14 510.176 303.933C511.942 303.944 513.963 303.689 514.812 304.595Z",
    fill: "#72969B"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.811 304.594C515.775 304.188 514.754 303.793 514.811 304.594Z",
    fill: "#72969B"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.277 305.257C225.387 304.49 226.485 304.699 227.264 304.595C227.159 305.373 226.049 305.158 225.277 305.257Z",
    fill: "#72969B"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.591 305.257C281.701 304.49 282.799 304.699 283.577 304.595C283.474 305.373 282.369 305.158 281.591 305.257Z",
    fill: "#72969B"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.294 307.256C268.27 307.378 264.685 308.179 257.075 306.588H247.14C255.767 305.246 267.382 306.657 276.294 307.256Z",
    fill: "#72969B"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.884 306.588H181.552V307.255C181.145 307.214 180.762 307.145 180.884 306.588Z",
    fill: "#72969B"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.273 307.912C484.46 308.569 472.899 307.773 463.8 307.912C473.769 306.302 483.576 306.971 494.273 307.256V307.912Z",
    fill: "#72969B"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.294 307.256C279.046 306.612 276.428 309.23 276.294 307.256Z",
    fill: "#72969B"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.942 307.912C279.052 307.14 280.15 307.355 280.929 307.256C280.824 308.022 279.72 307.813 278.942 307.912Z",
    fill: "#72969B"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.732 308.58C414.568 308.156 410.396 309.713 404.168 309.231C405.911 308.679 418.617 306.57 420.732 308.58Z",
    fill: "#72969B"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.395 307.912C423.039 305.891 425.415 308.702 428.018 307.912C426.815 309.492 422.83 308.284 421.395 307.912Z",
    fill: "#72969B"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.471 307.912C462.906 308.348 462.192 307.628 462.471 307.912Z",
    fill: "#72969B"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.272 307.912C499.112 307.68 501.634 307.006 505.532 307.912C503.307 309.01 496.509 309.01 494.272 307.912Z",
    fill: "#72969B"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.159 307.912C455.783 312.966 442.694 308.162 432.66 310.561C439.225 307.407 452.559 311.032 459.159 307.912Z",
    fill: "#72969B"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.85 309.23C400.873 308.598 401.663 308.725 402.181 308.579C402.163 309.218 401.367 309.085 400.85 309.23Z",
    fill: "#72969B"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.575 309.898C230.465 308.458 232.928 309.596 233.886 309.23C233.996 310.671 231.539 309.532 230.575 309.898Z",
    fill: "#72969B"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.853 309.23C238.389 311.257 235.602 308.475 239.853 309.23Z",
    fill: "#72969B"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.119 309.898C465.044 311.362 462.313 310.177 461.145 310.561C462.075 308.917 463.429 309.381 465.119 309.898Z",
    fill: "#72969B"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.672 310.561C431.102 310.997 430.388 310.289 430.672 310.561Z",
    fill: "#72969B"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.483 309.898C459.025 311.919 456.236 309.132 460.483 309.898Z",
    fill: "#72969B"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.112 310.561C466.706 309.597 466.311 310.631 467.112 310.561Z",
    fill: "#72969B"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.114 311.224C252.246 309.707 256.168 310.973 258.405 310.561C257.267 312.077 253.351 310.804 251.114 311.224Z",
    fill: "#72969B"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.671 310.561C266.987 313.571 253.381 311.357 264.372 310.561C265.668 311.88 268.155 310.986 269.671 310.561Z",
    fill: "#72969B"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.975 311.223C273.899 309.713 277.588 310.973 279.604 310.56C278.256 312.978 275.641 311.113 272.975 311.223Z",
    fill: "#72969B"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.242 311.223C284.323 309.764 287.054 310.945 288.216 310.561C288.135 312.02 285.409 310.845 284.242 311.223Z",
    fill: "#72969B"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.877 311.223C288.987 310.451 290.085 310.659 290.869 310.56C290.759 311.339 289.66 311.113 288.877 311.223Z",
    fill: "#72969B"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.195 311.223C292.624 311.653 291.917 310.945 292.195 311.223Z",
    fill: "#72969B"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.137 311.223C300.247 310.451 301.345 310.659 302.135 310.56C302.019 311.339 300.927 311.113 300.137 311.223Z",
    fill: "#72969B"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.441 311.223C305.876 311.653 305.162 310.945 305.441 311.223Z",
    fill: "#72969B"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.317 312.548C219.322 311.682 221.146 311.699 221.298 312.548H219.317Z",
    fill: "#72969B"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.621 312.548C223.062 312.978 222.342 312.269 222.621 312.548Z",
    fill: "#72969B"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.861 312.548C237.989 311.566 239.464 311.944 240.51 311.886C239.935 313.814 239.522 312.629 237.861 312.548Z",
    fill: "#72969B"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.178 312.548C241.613 312.978 240.899 312.269 241.178 312.548Z",
    fill: "#72969B"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.504 311.886C245.403 312.513 248.419 313.036 251.777 313.21C249.854 314.221 243.637 313.867 242.504 311.886Z",
    fill: "#72969B"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.964 312.548C329.976 311.903 330.771 312.03 331.283 311.886C331.265 312.53 330.475 312.397 329.964 312.548Z",
    fill: "#72969B"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.952 312.548C331.969 311.903 332.759 312.03 333.271 311.886C333.259 312.53 332.463 312.397 331.952 312.548Z",
    fill: "#72969B"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.867 311.886C560.673 311.821 560.279 312.849 559.867 311.886Z",
    fill: "#72969B"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.86 312.548C233.357 313.953 229.586 313.721 226.601 313.21C229.041 311.682 234.317 312.978 237.86 312.548Z",
    fill: "#72969B"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.543 313.21C558.978 313.645 558.264 312.931 558.543 313.21Z",
    fill: "#72969B"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.711 313.873C463.562 316.365 504.272 313.756 543.302 315.86C529.045 318.428 508.008 315.9 488.306 315.86C466.984 315.819 443.692 316.783 424.711 313.873Z",
    fill: "#72969B"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.065 314.541C420.089 313.89 420.885 314.018 421.396 313.873C421.379 314.517 420.583 314.39 420.065 314.541Z",
    fill: "#72969B"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.719 314.541C423.155 314.97 422.447 314.256 422.719 314.541Z",
    fill: "#72969B"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.427 315.197C415.531 314.419 416.641 314.64 417.413 314.541C417.309 315.307 416.205 315.093 415.427 315.197Z",
    fill: "#72969B"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.713 316.522C209.142 316.957 208.428 316.244 208.713 316.522Z",
    fill: "#72969B"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.686 316.522C212.704 315.878 213.488 316.011 214.016 315.86C213.993 316.505 213.197 316.371 212.686 316.522Z",
    fill: "#72969B"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.648 317.846C220.646 315.848 229.484 315.517 230.576 318.509C226.811 318.073 221.315 319.381 218.648 317.846Z",
    fill: "#72969B"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.5 316.522C296.431 317.672 294.519 317.957 292.195 317.846C293.253 316.708 295.175 316.412 297.5 316.522Z",
    fill: "#72969B"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.818 317.19C301.041 315.588 297.221 319.402 298.818 317.19Z",
    fill: "#72969B"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.733 317.19C308.137 317.573 304.721 319.061 300.805 317.19C305.273 318.108 309.781 315.575 312.733 317.19Z",
    fill: "#72969B"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.734 317.19C316.139 316.673 317.765 318.334 320.026 317.19C319.219 319.764 314.472 317.742 312.734 317.19Z",
    fill: "#72969B"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.244 317.846C337.354 317.074 338.458 317.289 339.236 317.19C339.132 317.963 338.028 317.742 337.244 317.846Z",
    fill: "#72969B"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.192 317.19C340.998 319.212 338.133 316.354 345.192 317.19Z",
    fill: "#72969B"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.496 317.846C350.937 318.282 350.217 317.574 350.496 317.846Z",
    fill: "#72969B"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.783 318.509C247.325 319.625 242.131 317.806 237.861 318.509C237.85 317.429 247.61 317.429 249.783 318.509Z",
    fill: "#72969B"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.1 319.171C256.423 317.632 262.599 318.945 267.02 318.509C263.697 320.049 257.527 318.741 253.1 319.171Z",
    fill: "#72969B"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.338 319.171C268.355 318.527 269.152 318.66 269.668 318.509C269.645 319.154 268.848 319.021 268.338 319.171Z",
    fill: "#72969B"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.651 320.496C382.33 317.214 391.806 320.728 395.553 318.509C400.527 319.294 403.53 318.713 410.124 319.171C401.473 321.112 388.332 318.573 379.651 320.496Z",
    fill: "#72969B"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.731 319.171C416.496 321.182 406.789 317.881 416.09 318.509C417.809 318.631 419.471 319.711 420.731 319.171Z",
    fill: "#72969B"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.214 321.164C482.869 324.041 451.728 319.294 427.361 318.509C451.129 318.218 476.698 321.542 504.214 321.164Z",
    fill: "#72969B"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.649 319.833C272.144 318.346 275.374 319.578 276.954 319.171C276.455 320.676 273.231 319.433 271.649 319.833Z",
    fill: "#72969B"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.267 320.496C280.377 319.729 281.475 319.938 282.26 319.834C282.149 320.612 281.051 320.398 280.267 320.496Z",
    fill: "#72969B"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.001 320.497C377.019 319.852 377.808 319.991 378.326 319.834C378.314 320.485 377.519 320.351 377.001 320.497Z",
    fill: "#72969B"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.693 322.489C427.127 322.918 426.414 322.21 426.693 322.489Z",
    fill: "#72969B"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.335 321.821C429.877 323.848 427.089 321.06 431.335 321.821Z",
    fill: "#72969B"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.557 323.151C233.916 321.629 238.064 322.913 240.51 322.489C239.169 324.011 235.02 322.727 232.557 323.151Z",
    fill: "#72969B"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.463 323.151C248.747 321.669 251.728 322.878 253.099 322.489C252.815 323.97 249.834 322.756 248.463 323.151Z",
    fill: "#72969B"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.763 323.151C253.873 322.372 254.971 322.587 255.749 322.489C255.645 323.261 254.541 323.052 253.763 323.151Z",
    fill: "#72969B"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.322 323.151C433.403 321.688 436.134 322.872 437.296 322.489C437.209 323.947 434.478 322.767 433.322 323.151Z",
    fill: "#72969B"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.958 323.151C465.369 321.188 497.957 327.532 524.751 325.138C529.062 324.749 531.026 322.495 534.692 324.47C533.827 328.514 527.552 325.72 523.427 325.801C496.341 326.323 466.555 324.801 437.958 323.151Z",
    fill: "#72969B"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.04 323.819C263.469 324.243 262.762 323.534 263.04 323.819Z",
    fill: "#72969B"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.001 323.151C268.008 325.922 262.78 322.669 269.001 323.151Z",
    fill: "#72969B"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.817 324.47C403.383 323.918 399.658 324.871 396.214 325.138C397.783 323.656 405.458 321.815 406.817 324.47Z",
    fill: "#72969B"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.67 324.47C269.955 322.988 272.929 324.203 274.301 323.819C274.022 325.289 271.041 324.081 269.67 324.47Z",
    fill: "#72969B"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.968 324.47C274.985 323.825 275.775 323.959 276.292 323.819C276.269 324.452 275.478 324.324 274.968 324.47Z",
    fill: "#72969B"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.566 323.819C284.41 324.853 282.039 324.696 280.267 325.138C280.419 323.07 283.567 324.017 285.566 323.819Z",
    fill: "#72969B"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.651 324.47C380.085 324.906 379.372 324.203 379.651 324.47Z",
    fill: "#72969B"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.618 325.138C278.047 325.568 277.345 324.854 277.618 325.138Z",
    fill: "#72969B"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.916 324.47C389.464 326.497 386.676 323.715 390.916 324.47Z",
    fill: "#72969B"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.247 325.138C392.13 323.698 394.593 324.836 395.551 324.47C395.668 325.91 393.199 324.772 392.247 325.138Z",
    fill: "#72969B"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.925 326.463C225.479 329.147 210.884 325.028 214.016 325.138C215.225 325.179 222.719 326.666 227.925 326.463Z",
    fill: "#72969B"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.519 326.463C291.498 326.951 291.567 325.319 289.54 325.801C290.144 324.203 293.282 325.516 293.519 326.463Z",
    fill: "#72969B"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.018 325.138C537.203 325.057 537.411 325.951 538.667 325.801C538.231 326.69 537.255 327.032 536.018 327.125V325.138Z",
    fill: "#72969B"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.467 326.463C301.491 325.824 302.287 325.952 302.797 325.801C302.774 326.44 301.984 326.318 301.467 326.463Z",
    fill: "#72969B"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.292 327.125C262.116 328.769 245.877 327.514 229.25 327.793C243.81 326.282 259.09 326.661 276.292 327.125Z",
    fill: "#72969B"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.521 326.463C295.532 326.882 299.226 325.621 300.139 327.125C298.135 326.707 294.439 327.98 293.521 326.463Z",
    fill: "#72969B"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.66 327.793C432.677 327.142 433.473 327.27 433.985 327.125C433.967 327.77 433.171 327.637 432.66 327.793Z",
    fill: "#72969B"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.646 327.793C434.657 327.142 435.459 327.27 435.971 327.125C435.947 327.77 435.157 327.637 434.646 327.793Z",
    fill: "#72969B"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.605 327.793C278.152 329.809 275.359 327.021 279.605 327.793Z",
    fill: "#72969B"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.283 328.45C441.067 326.928 445.674 328.212 448.556 327.793C446.767 329.31 442.165 328.026 439.283 328.45Z",
    fill: "#72969B"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.88 328.45C457.293 327.01 468.169 327.828 475.722 328.45C466.49 329.519 456.236 328.735 449.88 328.45Z",
    fill: "#72969B"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.93 329.118C280.953 328.467 281.743 328.601 282.261 328.45C282.237 329.095 281.441 328.968 280.93 329.118Z",
    fill: "#72969B"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.241 329.118C284.676 329.547 283.974 328.834 284.241 329.118Z",
    fill: "#72969B"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.673 328.45C428.483 330.031 420.703 328.752 416.09 329.78C419.181 327.561 425.671 328.752 430.673 328.45Z",
    fill: "#72969B"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.767 329.78C415.203 330.204 414.489 329.496 414.767 329.78Z",
    fill: "#72969B"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.3 329.78C329.004 330.587 328.446 331.139 327.308 331.099C326.994 329.687 328.254 329.839 329.3 329.78Z",
    fill: "#72969B"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.62 330.437C330.637 329.792 331.433 329.919 331.95 329.78C331.926 330.412 331.136 330.291 330.62 330.437Z",
    fill: "#72969B"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.394 331.099C313.285 329.659 315.747 330.797 316.706 330.437C316.815 331.878 314.359 330.739 313.394 331.099Z",
    fill: "#72969B"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.031 331.1C318.055 330.455 318.845 330.588 319.356 330.437C319.339 331.082 318.554 330.955 318.031 331.1Z",
    fill: "#72969B"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.005 331.099C321.9 329.659 324.351 330.797 325.327 330.437C325.432 331.878 322.975 330.739 322.005 331.099Z",
    fill: "#72969B"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.14 332.418C248.871 331.877 253.315 331.209 257.075 331.099C259.718 331.023 266.394 330.652 264.371 331.755C257.905 331.261 253.484 332.8 247.14 332.418Z",
    fill: "#72969B"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.774 331.755C360.21 332.197 359.496 331.482 359.774 331.755Z",
    fill: "#72969B"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.54 333.086C282.12 333.278 273.284 333.195 267.671 331.755C275.387 331.772 283.521 331.372 289.54 333.086Z",
    fill: "#72969B"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.788 331.755C355.208 332.859 347.72 335.636 345.192 332.418C350.246 333.225 352.64 332.139 357.788 331.755Z",
    fill: "#72969B"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.019 335.073C375.03 334.429 375.826 334.568 376.338 334.416C376.32 335.061 375.524 334.927 375.019 335.073Z",
    fill: "#72969B"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.961 334.417C385.041 336.125 372.462 334.533 382.961 334.417Z",
    fill: "#72969B"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.948 335.073C385.383 335.514 384.67 334.794 384.948 335.073Z",
    fill: "#72969B"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.942 335.073C387.371 335.514 386.663 334.794 386.942 335.073Z",
    fill: "#72969B"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.691 335.741C423.356 336.577 417.715 337.217 414.763 336.403C418.62 335.137 422.63 335.328 426.691 335.741Z",
    fill: "#72969B"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.44 337.065C413.874 337.495 413.167 336.787 413.44 337.065Z",
    fill: "#72969B"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.602 337.728C442.177 336.206 446.557 337.49 449.218 337.066C447.655 338.589 443.275 337.293 440.602 337.728Z",
    fill: "#72969B"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.484 338.385C304.8 337.972 311.133 339.076 318.029 338.385C322.247 338.768 314.875 339.639 314.055 339.709C309.332 340.127 302.401 339.349 299.484 338.385Z",
    fill: "#72969B"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.68 339.046C320.575 337.612 323.032 338.744 323.996 338.385C324.112 339.825 321.644 338.692 320.68 339.046Z",
    fill: "#72969B"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.654 339.047C326.672 338.402 327.455 338.542 327.973 338.385C327.955 339.036 327.166 338.902 326.654 339.047Z",
    fill: "#72969B"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.464 340.377C245.443 340.093 241.173 341.04 239.186 339.709C240.818 338.774 246.274 339.674 248.464 340.377Z",
    fill: "#72969B"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.642 339.047C272.184 341.073 269.396 338.28 273.642 339.047Z",
    fill: "#72969B"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.463 340.378C256.259 340.668 263.209 340.11 270.331 339.709C266.311 341.504 255.028 341.58 248.463 340.378Z",
    fill: "#72969B"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.578 340.378C284.013 340.807 283.305 340.093 283.578 340.378Z",
    fill: "#72969B"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.164 339.709C350.02 341.133 345.929 341.945 344.529 341.04C344.884 338.733 348.863 340.064 351.164 339.709Z",
    fill: "#72969B"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.821 341.04C351.932 340.267 353.03 340.476 353.814 340.378C353.703 341.15 352.6 340.929 351.821 341.04Z",
    fill: "#72969B"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.432 341.04C363.347 338.612 362.952 342.869 360.432 341.04Z",
    fill: "#72969B"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.284 341.04C436.042 344.136 428.56 340.395 422.72 341.702C425.399 339.813 433.091 341.283 439.284 341.04Z",
    fill: "#72969B"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.059 341.04C365.606 343.061 362.819 340.279 367.059 341.04Z",
    fill: "#72969B"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.091 341.702C416.115 341.051 416.905 341.184 417.416 341.04C417.404 341.678 416.614 341.557 416.091 341.702Z",
    fill: "#72969B"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.181 342.364C294.616 342.8 293.902 342.085 294.181 342.364Z",
    fill: "#72969B"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.052 342.364C369.476 342.8 368.768 342.085 369.052 342.364Z",
    fill: "#72969B"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.933 342.364C443.264 342.138 444.007 342.504 443.92 343.689H441.933V342.364Z",
    fill: "#72969B"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.217 343.689C449.658 344.124 448.945 343.416 449.217 343.689Z",
    fill: "#72969B"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.418 343.689C466.603 346.141 456.679 343.62 450.55 343.689C457.469 342.086 464.389 344.386 472.418 343.689Z",
    fill: "#72969B"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.281 344.357C281.988 344.839 275.289 345.508 272.976 345.676C268.056 346.03 260.351 345.844 257.743 345.676C256.041 345.566 246.118 343.358 250.452 343.689C261.571 344.538 265.83 344.985 278.281 344.357Z",
    fill: "#72969B"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.532 344.357C291.956 344.787 291.253 344.072 291.532 344.357Z",
    fill: "#72969B"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.746 345.676C310.85 344.898 311.954 345.124 312.732 345.019C312.623 345.792 311.524 345.577 310.746 345.676Z",
    fill: "#72969B"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.395 346.338C322.237 344.025 318.862 347.779 313.395 346.338Z",
    fill: "#72969B"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.952 346.338C333.834 346.082 341.132 344.223 343.211 346.995C339.818 345.154 335.425 348.268 331.952 346.338Z",
    fill: "#72969B"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.952 346.338C332.015 347.134 330.982 346.745 331.952 346.338Z",
    fill: "#72969B"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.774 346.338C355.58 348.366 352.715 345.502 359.774 346.338Z",
    fill: "#72969B"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.548 346.995C450.652 346.223 451.756 346.443 452.534 346.338C452.43 347.122 451.325 346.896 450.548 346.995Z",
    fill: "#72969B"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.197 346.995C453.086 345.915 457.53 345.665 456.507 347.657C454.637 348.214 454.794 346.733 453.197 346.995Z",
    fill: "#72969B"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.113 346.995C464.103 349.394 450.997 345.16 463.139 346.338C464.621 346.483 466.067 347.483 467.113 346.995Z",
    fill: "#72969B"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.425 346.995C472.075 344.415 471.389 349.197 470.425 346.995Z",
    fill: "#72969B"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.415 350.313C417.851 350.753 417.142 350.04 417.415 350.313Z",
    fill: "#72969B"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.057 350.312C422.161 349.534 423.258 349.754 424.043 349.65C423.933 350.428 422.835 350.214 422.057 350.312Z",
    fill: "#72969B"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.603 349.65C437.553 352.99 430.802 348.982 425.375 350.313C427.042 348.598 437.402 350.441 440.603 349.65Z",
    fill: "#72969B"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.77 350.981C463.913 350.422 460.897 351.992 458.503 350.981C460.078 349.882 466.201 349.882 467.77 350.981Z",
    fill: "#72969B"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.77 350.981C474.289 351.184 478.478 349.859 484.34 350.981C480.354 352.084 471.762 352.084 467.77 350.981Z",
    fill: "#72969B"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.001 350.981C485.019 350.336 485.808 350.457 486.325 350.313C486.308 350.963 485.512 350.824 485.001 350.981Z",
    fill: "#72969B"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.962 350.981C492.264 349.72 497.545 350.098 498.91 350.981C497.381 352.468 492.67 351.504 490.962 350.981Z",
    fill: "#72969B"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.88 351.643C449.904 350.992 450.7 351.126 451.21 350.981C451.193 351.632 450.397 351.485 449.88 351.643Z",
    fill: "#72969B"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.535 351.643C452.744 350.742 454.191 351.085 455.185 350.981C454.981 351.88 453.528 351.526 452.535 351.643Z",
    fill: "#72969B"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.509 351.643C456.527 350.992 457.317 351.126 457.839 350.981C457.816 351.632 457.021 351.485 456.509 351.643Z",
    fill: "#72969B"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.517 351.643C403.556 352.102 402.789 352.102 404.823 351.643C405.84 353.675 400.502 353.675 401.517 351.643Z",
    fill: "#72969B"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.154 352.305C406.177 351.66 406.962 351.782 407.485 351.643C407.461 352.281 406.665 352.154 406.154 352.305Z",
    fill: "#72969B"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.565 352.968C502 353.403 501.287 352.689 501.565 352.968Z",
    fill: "#72969B"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.552 352.305C504.354 352.235 503.965 353.268 503.552 352.305Z",
    fill: "#72969B"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.275 353.624C492.671 355.803 491.108 351.783 494.275 353.624Z",
    fill: "#72969B"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.963 354.286C491.399 354.722 490.69 354.014 490.963 354.286Z",
    fill: "#72969B"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.936 354.286C495.43 352.799 498.654 354.025 500.235 353.624C499.741 355.123 496.522 353.886 494.936 354.286Z",
    fill: "#72969B"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.902 354.286C500.92 353.642 501.704 353.782 502.227 353.624C502.204 354.269 501.414 354.141 500.902 354.286Z",
    fill: "#72969B"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.181 354.954C294.076 353.52 296.533 354.653 297.497 354.286C297.602 355.726 295.139 354.588 294.181 354.954Z",
    fill: "#72969B"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.575 355.611C443.461 357.778 438.911 356.326 433.322 356.941C437.436 355.141 440.509 355.89 446.575 355.611Z",
    fill: "#72969B"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.707 356.941C316.992 355.454 319.972 356.674 321.349 356.279C321.058 357.761 318.078 356.546 316.707 356.941Z",
    fill: "#72969B"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.987 356.279C376.85 358.3 374.033 355.489 378.987 356.279Z",
    fill: "#72969B"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.672 356.941C430.771 356.163 431.881 356.378 432.659 356.279C432.549 357.058 431.445 356.837 430.672 356.941Z",
    fill: "#72969B"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.208 358.267C288.436 359.952 275.237 358.894 274.301 357.604C278.047 356.872 284.375 358.918 290.208 358.267Z",
    fill: "#72969B"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.673 357.603C322.778 356.825 323.882 357.039 324.66 356.94C324.555 357.719 323.452 357.499 322.673 357.603Z",
    fill: "#72969B"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.731 357.604C369.241 354.913 380.721 358.748 369.054 358.266C367.712 358.207 367.73 357.429 365.731 357.604Z",
    fill: "#72969B"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.199 357.604C454.843 360.188 454.163 355.407 453.199 357.604Z",
    fill: "#72969B"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.532 359.585C292.45 358.074 296.14 359.346 298.155 358.928C297.237 360.445 293.542 359.171 291.532 359.585Z",
    fill: "#72969B"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.136 360.253C302.019 358.818 304.482 359.951 305.441 359.585C305.557 361.031 303.094 359.892 302.136 360.253Z",
    fill: "#72969B"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.164 360.253C349.706 362.274 346.918 359.486 351.164 360.253Z",
    fill: "#72969B"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.637 361.577C389.41 361.699 386.511 358.039 381.637 361.577Z",
    fill: "#72969B"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.6 360.915C439.737 363.797 431.701 361.508 426.693 362.234C423.201 362.757 420.168 361.31 425.373 361.577H433.321C437.109 360.967 437.947 361.049 442.6 360.915Z",
    fill: "#72969B"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.185 362.234C463.58 361.159 479.603 360.224 488.307 361.577C495.29 362.658 488.155 362.397 484.338 361.577C481.736 362.989 476.513 362.112 473.735 361.577C468.396 362.286 459.368 362.565 455.185 362.234Z",
    fill: "#72969B"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.11 362.234C414.214 361.467 415.319 361.682 416.091 361.577C415.987 362.355 414.889 362.135 414.11 362.234Z",
    fill: "#72969B"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.878 362.234C451.977 361.467 453.087 361.682 453.859 361.577C453.755 362.355 452.651 362.135 451.878 362.234Z",
    fill: "#72969B"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.071 363.564C313.715 366.15 313.036 361.369 312.071 363.564Z",
    fill: "#72969B"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.484 364.226C300.187 362.722 303.644 363.976 305.439 363.564C304.742 365.068 301.28 363.814 299.484 364.226Z",
    fill: "#72969B"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.759 364.226C308.771 363.588 309.566 363.715 310.083 363.564C310.065 364.209 309.276 364.076 308.759 364.226Z",
    fill: "#72969B"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.582 366.876C446.233 364.297 445.552 369.072 444.582 366.876Z",
    fill: "#72969B"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.899 366.876C447.894 366.516 448.434 366.121 448.556 366.876H447.899Z",
    fill: "#72969B"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.554 366.876C452.609 366.557 456.793 365.499 459.157 366.214C458.733 366.085 450.867 367.776 448.554 367.544V366.876Z",
    fill: "#72969B"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.899 366.876C447.963 367.671 446.935 367.289 447.899 366.876Z",
    fill: "#72969B"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.433 369.526C307.543 368.753 308.641 368.962 309.425 368.863C309.315 369.641 308.211 369.421 307.433 369.526Z",
    fill: "#72969B"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.746 369.526C310.763 368.881 311.559 369.014 312.071 368.863C312.053 369.507 311.257 369.38 310.746 369.526Z",
    fill: "#72969B"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.358 369.526C373.131 372.146 373.131 366.911 372.358 369.526Z",
    fill: "#72969B"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.689 369.526C373.701 368.52 378.593 368.073 377.658 370.194C376.026 370.281 374.469 370.292 373.689 369.526Z",
    fill: "#72969B"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.988 369.526C380.638 366.94 379.952 371.727 378.988 369.526Z",
    fill: "#72969B"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.962 369.526C383.402 369.961 382.683 369.247 382.962 369.526Z",
    fill: "#72969B"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.842 370.85C399.118 367.428 392.931 373.337 389.59 369.526C393.419 369.404 400.262 367.26 402.842 370.85Z",
    fill: "#72969B"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.395 370.194C313.505 369.415 314.603 369.63 315.375 369.526C315.277 370.304 314.173 370.089 313.395 370.194Z",
    fill: "#72969B"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.711 370.85C424.938 373.314 416.409 372.703 412.115 372.843C412.964 371.466 421.875 372.46 424.711 370.85Z",
    fill: "#72969B"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.921 371.518C341.498 374.313 349.045 370.385 358.451 371.518C360.85 371.036 360.85 372.662 358.451 372.181H353.815C346.895 372.28 339.586 376.7 335.921 371.518Z",
    fill: "#72969B"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.099 372.181C361.117 371.536 361.913 371.664 362.429 371.518C362.406 372.163 361.616 372.024 361.099 372.181Z",
    fill: "#72969B"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.095 373.505C313.888 373.459 319.372 373.709 323.997 374.824C318.181 374.906 312.487 374.848 308.095 373.505Z",
    fill: "#72969B"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.765 375.492C410.054 376.933 402.182 379.362 398.202 377.474C403.205 376.3 409.368 376.277 414.765 375.492Z",
    fill: "#72969B"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.602 377.474C439.859 380.193 437.668 377.631 435.309 378.142C435.67 375.812 439.155 377.085 440.602 377.474Z",
    fill: "#72969B"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.598 377.474C444.452 378.24 446.038 378.24 447.897 377.474C448.188 379.153 442.146 379.867 442.598 377.474Z",
    fill: "#72969B"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.839 378.142C457.828 378.804 456.673 378.978 456.509 378.142H457.839Z",
    fill: "#72969B"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.971 378.804C323.771 380.837 320.907 377.968 327.971 378.804Z",
    fill: "#72969B"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.302 380.129C329.731 380.57 329.018 379.856 329.302 380.129Z",
    fill: "#72969B"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.395 382.122C421.418 381.477 422.201 381.605 422.719 381.453C422.707 382.098 421.912 381.97 421.395 382.122Z",
    fill: "#72969B"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.905 386.758C444.598 387.873 441.774 387.478 439.95 388.082C441.048 386.804 444.517 385.694 445.905 386.758Z",
    fill: "#72969B"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.62 387.42C330.637 386.781 331.433 386.902 331.95 386.758C331.926 387.402 331.136 387.269 330.62 387.42Z",
    fill: "#72969B"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.762 386.758C365.602 388.099 370.384 386.019 375.676 386.758C377.966 386.861 362.61 389.825 361.762 386.758Z",
    fill: "#72969B"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.988 387.42C379.005 386.781 379.801 386.902 380.313 386.758C380.301 387.402 379.499 387.269 378.988 387.42Z",
    fill: "#72969B"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.427 387.419C415.531 386.641 416.641 386.861 417.413 386.758C417.309 387.53 416.205 387.315 415.427 387.419Z",
    fill: "#72969B"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.745 387.42C418.763 386.781 419.552 386.902 420.064 386.758C420.046 387.402 419.257 387.269 418.745 387.42Z",
    fill: "#72969B"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.01 386.758C429.33 388.285 426.96 388.134 424.711 388.082C425.867 387.036 428.232 387.193 430.01 386.758Z",
    fill: "#72969B"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.264 388.082C335.375 387.303 336.473 387.524 337.245 387.42C337.146 388.192 336.037 387.983 335.264 388.082Z",
    fill: "#72969B"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.719 388.082C423.155 388.517 422.447 387.803 422.719 388.082Z",
    fill: "#72969B"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.335 388.082C431.219 386.641 433.682 387.779 434.646 387.42C434.756 388.854 432.293 387.722 431.335 388.082Z",
    fill: "#72969B"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.309 388.082C435.193 386.641 437.657 387.779 438.621 387.42C438.73 388.854 436.268 387.722 435.309 388.082Z",
    fill: "#72969B"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.561 392.056C340.84 390.58 343.826 391.789 345.192 391.393C344.913 392.869 341.932 391.661 340.561 392.056Z",
    fill: "#72969B"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.485 391.393C406.027 393.415 403.233 390.632 407.485 391.393Z",
    fill: "#72969B"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.142 392.056C408.16 391.405 408.95 391.545 409.467 391.393C409.45 392.033 408.654 391.911 408.142 392.056Z",
    fill: "#72969B"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.791 392.056C410.675 390.622 413.144 391.754 414.108 391.393C414.212 392.828 411.756 391.69 410.791 392.056Z",
    fill: "#72969B"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.427 392.056C415.45 391.405 416.24 391.545 416.752 391.393C416.734 392.033 415.945 391.911 415.427 392.056Z",
    fill: "#72969B"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.951 391.393C441.014 391.202 441.089 392.021 441.932 392.056C442.194 393.34 438.912 393.026 439.951 391.393Z",
    fill: "#72969B"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.172 392.718C349.195 392.074 349.991 392.201 350.497 392.056C350.485 392.701 349.689 392.574 349.172 392.718Z",
    fill: "#72969B"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.711 392.718C424.81 391.94 425.913 392.161 426.692 392.056C426.588 392.834 425.484 392.614 424.711 392.718Z",
    fill: "#72969B"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.322 392.718C432.619 394.222 429.156 392.969 427.361 393.38C429.086 391.434 430.231 393.026 433.322 392.718Z",
    fill: "#72969B"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.322 392.718C438.276 393.508 435.46 390.685 433.322 392.718Z",
    fill: "#72969B"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.906 395.373C445.621 397.529 436.917 397.529 436.633 395.373C438.782 396.727 444.145 394.176 445.906 395.373Z",
    fill: "#72969B"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.813 396.036C354.458 394.583 357.63 396.123 358.45 396.693C358.316 399.655 354.319 396.908 353.813 396.036Z",
    fill: "#72969B"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.824 396.035C405.265 396.46 404.552 395.757 404.824 396.035Z",
    fill: "#72969B"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.805 396.036C408.822 395.384 409.618 395.518 410.123 395.373C410.111 396.006 409.316 395.885 408.805 396.036Z",
    fill: "#72969B"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.791 396.036C411.459 394.165 413.609 396.216 414.765 396.036C413.952 398.046 412.488 395.315 410.791 396.036Z",
    fill: "#72969B"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.672 396.035C436.08 393.748 434.57 397.482 430.672 396.035Z",
    fill: "#72969B"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.112 396.693C359.13 396.048 359.92 396.175 360.432 396.036C360.42 396.674 359.63 396.541 359.112 396.693Z",
    fill: "#72969B"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.201 396.693C398.224 396.048 399.014 396.175 399.526 396.036C399.508 396.674 398.718 396.541 398.201 396.693Z",
    fill: "#72969B"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.091 396.693C416.178 395.235 418.909 396.414 420.065 396.036C419.984 397.489 417.259 396.309 416.091 396.693Z",
    fill: "#72969B"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.043 396.035C422.59 398.051 419.802 395.269 424.043 396.035Z",
    fill: "#72969B"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.671 396.036C426.471 398.063 423.606 395.199 430.671 396.036Z",
    fill: "#72969B"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.43 397.361C360.966 399.382 358.184 396.594 362.43 397.361Z",
    fill: "#72969B"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.73 398.017C364.907 400.05 362.066 397.21 367.73 398.017Z",
    fill: "#72969B"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.387 398.68C368.404 398.035 369.2 398.168 369.717 398.017C369.693 398.656 368.903 398.54 368.387 398.68Z",
    fill: "#72969B"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.378 398.68C370.459 397.216 373.185 398.395 374.357 398.017C374.27 399.487 371.546 398.296 370.378 398.68Z",
    fill: "#72969B"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.457 400.666C360.506 400.056 368.1 401.306 373.026 401.997C369.668 401.91 360 402.747 356.457 400.666Z",
    fill: "#72969B"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.295 401.997C429.493 401.329 421.911 403.647 414.765 402.659C411.384 402.189 416.403 402.403 421.395 401.997C425.787 401.631 433.803 398.586 437.295 401.997Z",
    fill: "#72969B"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.455 405.971C411.472 405.326 412.268 405.459 412.779 405.309C412.761 405.953 411.965 405.82 411.455 405.971Z",
    fill: "#72969B"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.805 406.634C408.822 405.982 409.618 406.122 410.123 405.971C410.111 406.615 409.316 406.488 408.805 406.634Z",
    fill: "#72969B"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.441 406.634C413.523 405.164 416.253 406.355 417.415 405.971C417.334 407.43 414.608 406.255 413.441 406.634Z",
    fill: "#72969B"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.745 407.964C420.145 410.253 407.137 410.7 399.526 410.607C403.065 409.497 413.627 409.701 418.745 407.964Z",
    fill: "#72969B"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.732 408.62C421.494 411.24 421.494 405.999 420.732 408.62Z",
    fill: "#72969B"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.214 410.607C396.231 409.968 397.022 410.09 397.545 409.951C397.521 410.595 396.725 410.462 396.214 410.607Z",
    fill: "#72969B"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.441 412.6C408.206 416.19 396.523 413.344 389.592 415.244C396.697 412.711 406.899 413.728 413.441 412.6Z",
    fill: "#72969B"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.897 417.236C395.001 416.457 396.099 416.678 396.878 416.574C396.774 417.346 395.67 417.131 394.897 417.236Z",
    fill: "#72969B"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.552 419.217C395.988 419.652 395.28 418.945 395.552 419.217Z",
    fill: "#72969B"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.877 419.879C396.987 419.113 398.086 419.328 398.864 419.217C398.759 419.995 397.656 419.78 396.877 419.879Z",
    fill: "#72969B"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M392.213 177.686C390.552 177.524 387.938 176.9 387.095 173.155C386.193 169.132 383.236 168.225 381.403 168.079C380.513 168.008 379.686 168.551 379.501 169.243L377.149 178.014C377.599 178.34 378.191 178.283 378.336 178.293C378.374 178.294 378.406 178.298 378.448 178.3C379.625 178.352 380.829 178.55 383.359 180.729C386.532 183.457 390.589 181.082 392.427 179.164C392.557 179.031 393.055 178.366 393.246 177.652C392.767 177.715 392.213 177.686 392.213 177.686Z",
    fill: "#FE6030"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M379.111 166.882L378.139 166.621C377.872 166.55 377.605 166.67 377.546 166.888L371.797 188.327C371.739 188.546 371.91 188.783 372.177 188.854L373.149 189.115C373.417 189.186 373.683 189.066 373.742 188.848L379.491 167.409C379.549 167.19 379.378 166.953 379.111 166.882Z",
    fill: "#FE6030"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M191.25 222.49C191.357 220.41 191.437 217.983 191.49 215.21C191.597 212.383 191.65 209.476 191.65 206.49C191.704 203.45 191.73 200.57 191.73 197.85V194.41C191.73 191.69 191.704 188.89 191.65 186.01C191.65 183.076 191.624 180.25 191.57 177.53C191.517 174.81 191.437 172.41 191.33 170.33H205.57C205.464 172.41 205.384 174.81 205.33 177.53C205.277 180.25 205.224 183.076 205.17 186.01C205.17 188.89 205.17 191.69 205.17 194.41V197.85C205.17 200.57 205.17 203.45 205.17 206.49C205.224 209.476 205.277 212.383 205.33 215.21C205.384 217.983 205.464 220.41 205.57 222.49H191.25ZM186.61 222.49V220.57L194.93 219.29H201.97L209.97 220.57V222.49H186.61ZM186.61 172.25V170.33H210.29V172.25L201.97 173.53H194.93L186.61 172.25ZM214.13 222.49V220.57L221.81 219.29H229.17L237.17 220.57V222.49H214.13ZM217.65 172.25V170.33H233.65V172.25L225.97 173.53H225.65L217.65 172.25ZM197.81 211.29V205.53H199.73L226.37 170.33H229.81L197.81 211.29ZM218.93 222.49L207.73 197.21L216.05 185.05L233.97 222.49H218.93Z",
    fill: "#3E626A"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M250.623 223.77C247.743 223.77 245.423 222.943 243.663 221.29C241.903 219.636 241.023 217.37 241.023 214.49C241.023 212.516 241.53 210.73 242.543 209.13C243.556 207.476 245.156 205.983 247.343 204.65C249.583 203.263 252.49 202.063 256.063 201.05C257.076 200.73 258.276 200.383 259.663 200.01C261.103 199.636 262.543 199.263 263.983 198.89C265.476 198.516 266.783 198.17 267.903 197.85V199.77C266.143 200.303 264.41 200.81 262.703 201.29C261.05 201.77 259.796 202.223 258.943 202.65C257.983 203.13 257.023 203.743 256.063 204.49C255.156 205.183 254.383 206.116 253.743 207.29C253.156 208.41 252.863 209.85 252.863 211.61C252.863 213.69 253.29 215.236 254.143 216.25C255.05 217.21 256.17 217.69 257.503 217.69C258.196 217.69 258.81 217.583 259.343 217.37C259.93 217.156 260.543 216.81 261.183 216.33C261.823 215.85 262.57 215.236 263.423 214.49L264.063 217.69H261.663C260.596 219.236 259.503 220.463 258.383 221.37C257.263 222.223 256.063 222.836 254.783 223.21C253.556 223.583 252.17 223.77 250.623 223.77ZM269.823 223.77C267.05 223.77 264.943 223.21 263.503 222.09C262.063 220.916 261.183 219.45 260.863 217.69V196.89C260.863 194.276 260.703 192.25 260.383 190.81C260.116 189.37 259.583 188.356 258.783 187.77C258.036 187.13 256.916 186.81 255.423 186.81C254.73 186.81 254.036 186.916 253.343 187.13C252.65 187.29 252.063 187.503 251.583 187.77L253.983 185.45L253.823 190.89C253.77 193.983 253.076 196.09 251.743 197.21C250.41 198.276 249.023 198.81 247.583 198.81C246.25 198.81 245.156 198.49 244.303 197.85C243.45 197.21 242.81 196.196 242.383 194.81C242.543 191.77 244.116 189.29 247.103 187.37C250.143 185.396 254.25 184.41 259.423 184.41C262.783 184.41 265.503 184.943 267.583 186.01C269.716 187.023 271.263 188.623 272.223 190.81C273.183 192.943 273.663 195.716 273.663 199.13V217.05C273.663 217.53 273.796 217.93 274.063 218.25C274.33 218.516 274.676 218.65 275.103 218.65C275.583 218.65 276.01 218.543 276.383 218.33C276.756 218.063 277.183 217.61 277.663 216.97L278.943 217.93C278.25 219.743 277.103 221.183 275.503 222.25C273.956 223.263 272.063 223.77 269.823 223.77Z",
    fill: "#3E626A"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M295.812 223.77C293.572 223.77 291.412 223.45 289.332 222.81C287.252 222.17 285.278 221.316 283.412 220.25L283.652 210.33H285.412L290.212 220.89H287.492V219.13C288.878 219.876 290.105 220.49 291.172 220.97C292.238 221.45 293.732 221.69 295.652 221.69C296.878 221.69 297.972 221.503 298.932 221.13C299.892 220.703 300.638 220.09 301.172 219.29C301.705 218.436 301.972 217.423 301.972 216.25C301.972 214.383 301.278 212.996 299.892 212.09C298.558 211.183 296.958 210.33 295.092 209.53L292.852 208.57C291.358 207.876 289.892 207.076 288.452 206.17C287.065 205.263 285.918 204.09 285.012 202.65C284.105 201.156 283.652 199.236 283.652 196.89C283.652 194.49 284.185 192.356 285.252 190.49C286.318 188.623 287.945 187.156 290.132 186.09C292.318 184.97 295.065 184.41 298.372 184.41C300.505 184.41 302.398 184.676 304.052 185.21C305.705 185.69 307.332 186.383 308.932 187.29L308.692 196.89H306.932L302.132 186.33H304.772V188.89C303.918 187.983 303.012 187.37 302.052 187.05C301.145 186.676 299.918 186.49 298.372 186.49C296.718 186.49 295.332 186.89 294.212 187.69C293.145 188.49 292.612 189.743 292.612 191.45C292.612 193.263 293.332 194.65 294.772 195.61C296.212 196.516 297.865 197.37 299.732 198.17L301.972 199.13C303.518 199.77 304.985 200.543 306.372 201.45C307.758 202.303 308.905 203.476 309.812 204.97C310.718 206.41 311.172 208.303 311.172 210.65C311.172 213.53 310.558 215.956 309.332 217.93C308.105 219.85 306.345 221.316 304.052 222.33C301.758 223.29 299.012 223.77 295.812 223.77Z",
    fill: "#3E626A"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M327.197 188.25V185.69H340.957V188.25H327.197ZM331.677 223.77C328.104 223.77 325.331 222.89 323.357 221.13C321.384 219.37 320.397 216.623 320.397 212.89C320.397 211.13 320.371 209.583 320.317 208.25C320.317 206.916 320.344 205.156 320.397 202.97L320.557 188.25H316.317V186.33L322.717 184.89L320.157 186.65L329.117 173.53H333.597L333.277 186.65V213.21C333.277 215.023 333.677 216.276 334.477 216.97C335.331 217.663 336.317 218.01 337.437 218.01C338.504 218.01 339.357 217.85 339.997 217.53C340.637 217.156 341.277 216.596 341.917 215.85L343.197 216.81C342.557 218.303 341.731 219.583 340.717 220.65C339.704 221.663 338.451 222.436 336.957 222.97C335.464 223.503 333.704 223.77 331.677 223.77Z",
    fill: "#3E626A"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M347.143 222.49V220.57L353.543 219.29H361.223L368.263 220.57V222.49H347.143ZM350.503 222.49C350.663 221.05 350.77 219.396 350.823 217.53C350.877 215.61 350.903 213.636 350.903 211.61C350.957 209.583 350.983 207.663 350.983 205.85V203.93C350.983 202.17 350.983 200.623 350.983 199.29C350.983 197.903 350.957 196.623 350.903 195.45C350.903 194.223 350.877 192.996 350.823 191.77L346.823 190.49V188.89L362.503 184.41L363.783 185.37V205.85C363.783 207.663 363.783 209.583 363.783 211.61C363.837 213.636 363.89 215.61 363.943 217.53C363.997 219.396 364.103 221.05 364.263 222.49H350.503ZM363.463 199.77L362.183 196.25H363.303C364.157 193.583 365.09 191.396 366.103 189.69C367.117 187.93 368.263 186.623 369.543 185.77C370.877 184.863 372.343 184.41 373.943 184.41C375.757 184.41 377.25 184.916 378.423 185.93C379.597 186.89 380.343 188.41 380.663 190.49C380.503 192.73 379.81 194.356 378.583 195.37C377.41 196.383 376.023 196.89 374.423 196.89C373.143 196.89 371.943 196.57 370.823 195.93C369.757 195.236 368.797 193.956 367.943 192.09L366.823 189.53L368.583 190.17C367.677 191.076 366.663 192.463 365.543 194.33C364.477 196.196 363.783 198.01 363.463 199.77Z",
    fill: "#3E626A"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M402.728 223.77C398.461 223.77 394.888 222.916 392.008 221.21C389.181 219.503 387.048 217.183 385.608 214.25C384.221 211.263 383.528 207.876 383.528 204.09C383.528 200.303 384.301 196.943 385.848 194.01C387.448 191.023 389.688 188.676 392.568 186.97C395.448 185.263 398.835 184.41 402.728 184.41C407.048 184.41 410.621 185.263 413.448 186.97C416.275 188.676 418.381 191.023 419.768 194.01C421.208 196.943 421.928 200.303 421.928 204.09C421.928 207.823 421.101 211.183 419.448 214.17C417.848 217.156 415.608 219.503 412.728 221.21C409.848 222.916 406.515 223.77 402.728 223.77ZM402.728 221.53C403.901 221.53 404.888 221.05 405.688 220.09C406.488 219.13 407.101 217.396 407.528 214.89C407.955 212.383 408.168 208.783 408.168 204.09C408.168 199.343 407.955 195.716 407.528 193.21C407.101 190.703 406.488 188.996 405.688 188.09C404.888 187.13 403.901 186.65 402.728 186.65C401.555 186.65 400.568 187.13 399.768 188.09C398.968 189.05 398.355 190.783 397.928 193.29C397.501 195.796 397.288 199.396 397.288 204.09C397.288 208.783 397.501 212.41 397.928 214.97C398.355 217.476 398.968 219.21 399.768 220.17C400.568 221.076 401.555 221.53 402.728 221.53Z",
    fill: "#3E626A"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M426.75 241.69V239.77L433.15 238.49H440.83L447.87 239.77V241.69H426.75ZM430.11 241.69C430.27 240.25 430.376 238.57 430.43 236.65C430.483 234.783 430.51 232.836 430.51 230.81C430.563 228.783 430.59 226.863 430.59 225.05V203.93C430.59 202.17 430.59 200.623 430.59 199.29C430.59 197.903 430.563 196.623 430.51 195.45C430.51 194.223 430.483 192.996 430.43 191.77L426.43 190.49V188.89L442.11 184.41L443.39 185.37V215.77L443.23 216.09V225.05C443.23 226.863 443.23 228.783 443.23 230.81C443.283 232.836 443.336 234.783 443.39 236.65C443.443 238.57 443.55 240.25 443.71 241.69H430.11ZM452.59 223.77C451.096 223.77 449.71 223.45 448.43 222.81C447.203 222.223 446.056 221.29 444.99 220.01C443.976 218.73 443.043 217.05 442.19 214.97H441.55L442.11 213.85C443.07 215.076 443.896 215.983 444.59 216.57C445.336 217.103 446.296 217.37 447.47 217.37C448.643 217.37 449.683 216.916 450.59 216.01C451.496 215.103 452.216 213.636 452.75 211.61C453.336 209.583 453.63 206.916 453.63 203.61C453.63 198.81 453.07 195.476 451.95 193.61C450.83 191.743 449.336 190.81 447.47 190.81C446.776 190.81 446.11 190.996 445.47 191.37C444.883 191.69 444.296 192.143 443.71 192.73C443.176 193.263 442.643 193.903 442.11 194.65L441.55 193.21H442.19C442.99 191.343 443.923 189.77 444.99 188.49C446.11 187.156 447.39 186.143 448.83 185.45C450.27 184.756 451.87 184.41 453.63 184.41C456.403 184.41 458.776 185.13 460.75 186.57C462.776 187.956 464.323 190.036 465.39 192.81C466.51 195.53 467.07 198.89 467.07 202.89C467.07 207.156 466.483 210.863 465.31 214.01C464.136 217.103 462.456 219.503 460.27 221.21C458.136 222.916 455.576 223.77 452.59 223.77Z",
    fill: "#3E626A"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M493.428 223.77C489.161 223.77 485.588 222.916 482.708 221.21C479.881 219.503 477.748 217.183 476.308 214.25C474.921 211.263 474.228 207.876 474.228 204.09C474.228 200.303 475.001 196.943 476.548 194.01C478.148 191.023 480.388 188.676 483.268 186.97C486.148 185.263 489.535 184.41 493.428 184.41C497.748 184.41 501.321 185.263 504.148 186.97C506.975 188.676 509.081 191.023 510.468 194.01C511.908 196.943 512.628 200.303 512.628 204.09C512.628 207.823 511.801 211.183 510.148 214.17C508.548 217.156 506.308 219.503 503.428 221.21C500.548 222.916 497.215 223.77 493.428 223.77ZM493.428 221.53C494.601 221.53 495.588 221.05 496.388 220.09C497.188 219.13 497.801 217.396 498.228 214.89C498.655 212.383 498.868 208.783 498.868 204.09C498.868 199.343 498.655 195.716 498.228 193.21C497.801 190.703 497.188 188.996 496.388 188.09C495.588 187.13 494.601 186.65 493.428 186.65C492.255 186.65 491.268 187.13 490.468 188.09C489.668 189.05 489.055 190.783 488.628 193.29C488.201 195.796 487.988 199.396 487.988 204.09C487.988 208.783 488.201 212.41 488.628 214.97C489.055 217.476 489.668 219.21 490.468 220.17C491.268 221.076 492.255 221.53 493.428 221.53Z",
    fill: "#3E626A"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M517.84 222.49V220.57L524.24 219.29H531.92L538 220.57V222.49H517.84ZM521.2 222.49C521.36 221.05 521.467 219.396 521.52 217.53C521.574 215.61 521.6 213.636 521.6 211.61C521.654 209.583 521.68 207.663 521.68 205.85V171.53L517.52 170.25V168.65L533.52 164.49L534.8 165.45L534.48 182.17V205.85C534.48 207.663 534.48 209.583 534.48 211.61C534.534 213.636 534.587 215.61 534.64 217.53C534.694 219.396 534.8 221.05 534.96 222.49H521.2Z",
    fill: "#3E626A"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M542.8 222.49V220.57L549.2 219.29H556.88L562.96 220.57V222.49H542.8ZM546.16 222.49C546.32 221.05 546.426 219.396 546.48 217.53C546.533 215.61 546.56 213.636 546.56 211.61C546.613 209.583 546.64 207.663 546.64 205.85V203.93C546.64 201.316 546.64 199.103 546.64 197.29C546.64 195.476 546.586 193.636 546.48 191.77L542.48 190.49V188.89L558.48 184.41L559.76 185.37L559.44 196.09V205.85C559.44 207.663 559.44 209.583 559.44 211.61C559.493 213.636 559.546 215.61 559.6 217.53C559.653 219.396 559.76 221.05 559.92 222.49H546.16ZM553.04 179.37C551.386 179.37 549.946 178.81 548.72 177.69C547.493 176.57 546.88 175.13 546.88 173.37C546.88 171.61 547.493 170.17 548.72 169.05C549.946 167.93 551.386 167.37 553.04 167.37C554.746 167.37 556.186 167.93 557.36 169.05C558.586 170.17 559.2 171.61 559.2 173.37C559.2 175.13 558.586 176.57 557.36 177.69C556.186 178.81 554.746 179.37 553.04 179.37Z",
    fill: "#3E626A"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M580.799 223.77C578.559 223.77 576.399 223.45 574.319 222.81C572.239 222.17 570.266 221.316 568.399 220.25L568.639 210.33H570.399L575.199 220.89H572.479V219.13C573.866 219.876 575.092 220.49 576.159 220.97C577.226 221.45 578.719 221.69 580.639 221.69C581.866 221.69 582.959 221.503 583.919 221.13C584.879 220.703 585.626 220.09 586.159 219.29C586.692 218.436 586.959 217.423 586.959 216.25C586.959 214.383 586.266 212.996 584.879 212.09C583.546 211.183 581.946 210.33 580.079 209.53L577.839 208.57C576.346 207.876 574.879 207.076 573.439 206.17C572.052 205.263 570.906 204.09 569.999 202.65C569.092 201.156 568.639 199.236 568.639 196.89C568.639 194.49 569.172 192.356 570.239 190.49C571.306 188.623 572.932 187.156 575.119 186.09C577.306 184.97 580.052 184.41 583.359 184.41C585.492 184.41 587.386 184.676 589.039 185.21C590.692 185.69 592.319 186.383 593.919 187.29L593.679 196.89H591.919L587.119 186.33H589.759V188.89C588.906 187.983 587.999 187.37 587.039 187.05C586.132 186.676 584.906 186.49 583.359 186.49C581.706 186.49 580.319 186.89 579.199 187.69C578.132 188.49 577.599 189.743 577.599 191.45C577.599 193.263 578.319 194.65 579.759 195.61C581.199 196.516 582.852 197.37 584.719 198.17L586.959 199.13C588.506 199.77 589.972 200.543 591.359 201.45C592.746 202.303 593.892 203.476 594.799 204.97C595.706 206.41 596.159 208.303 596.159 210.65C596.159 213.53 595.546 215.956 594.319 217.93C593.092 219.85 591.332 221.316 589.039 222.33C586.746 223.29 583.999 223.77 580.799 223.77Z",
    fill: "#3E626A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoV2);
export default __webpack_public_path__ + "static/media/Logo_v2.b8af20f3fec740d57c5c0a80c1a59b1d.svg";
export { ForwardRef as ReactComponent };